/* tslint:disable */
/* eslint-disable */
/**
 * Peanuts Backend API
 * Django REST API for multi-tenant SaaS platform with Clerk authentication
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from "./common"
import type { RequestArgs } from "./base"
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from "./base"

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface Activity {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  workPeriodOwnerId: string
  updatedAt: string
  timeStart: string
  timeEnd: string
  /**
   * * `1` - Break * `2` - Maintenance
   */
  type: ActivityTypeEnum
  description?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  workPeriod: string
}

export const ActivityTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type ActivityTypeEnum = (typeof ActivityTypeEnum)[keyof typeof ActivityTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ActivityRequest {
  id?: string | null
  createdAt?: string | null
  timeStart: string
  timeEnd: string
  /**
   * * `1` - Break * `2` - Maintenance
   */
  type: ActivityRequestTypeEnum
  description?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  workPeriod: string
}

export const ActivityRequestTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type ActivityRequestTypeEnum =
  (typeof ActivityRequestTypeEnum)[keyof typeof ActivityRequestTypeEnum]

export interface AddTokenCreateRequest {
  token?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Address {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  street?: string | null
  houseNumber?: string | null
  postalCode?: string | null
  country?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface AddressRequest {
  id?: string | null
  createdAt?: string | null
  street?: string | null
  houseNumber?: string | null
  postalCode?: string | null
  country?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface BaseFile {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  url: string
  thumbUrl: string
  fileName: string
  thumbName: string
  updatedAt: string
  originalName?: string | null
  extension?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  originalFile?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface BaseFileRequest {
  id?: string | null
  createdAt?: string | null
  originalName?: string | null
  extension?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  originalFile?: string | null
}
/**
 * Serializer for battery information from Transistorsoft Background Geolocation plugin.
 */
export interface Battery {
  isCharging?: boolean | null
  level?: number | null
}
/**
 * Serializer for battery information from Transistorsoft Background Geolocation plugin.
 */
export interface BatteryRequest {
  isCharging?: boolean | null
  level?: number | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface BusinessLocation {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  location: GlobalScopedLocation
  updatedAt: string
  isMain?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  registeredBusinessEntity: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface BusinessLocationRequest {
  id?: string | null
  createdAt?: string | null
  isMain?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  registeredBusinessEntity: string
}
/**
 * Contact person at destination
 */
export interface ContactInfo {
  name: string
  phone: string | null
}
/**
 * Serializer for coordinates from Transistorsoft Background Geolocation plugin.
 */
export interface Coords {
  latitude: number
  longitude: number
  accuracy?: number | null
  speed?: number | null
  speedAccuracy?: number | null
  heading?: number | null
  headingAccuracy?: number | null
  altitude?: number | null
  ellipsoidalAltitude?: number | null
  altitudeAccuracy?: number | null
}
/**
 * Serializer for coordinates from Transistorsoft Background Geolocation plugin.
 */
export interface CoordsRequest {
  latitude: number
  longitude: number
  accuracy?: number | null
  speed?: number | null
  speedAccuracy?: number | null
  heading?: number | null
  headingAccuracy?: number | null
  altitude?: number | null
  ellipsoidalAltitude?: number | null
  altitudeAccuracy?: number | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface CounterRentalDispense {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  rentalDispenseItem: RentalDispenseItem
  project?: Project | null
  counteredBy: Array<ShallowRentalDispense>
  productionStatement?: ProductionStatement | null
  fileBucket: FileBucket
  sequenceNumber: number
  materializationCount: number
  updatedAt: string
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: CounterRentalDispenseFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  supplierComment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instruction: string
  counterMutation?: string | null
}

export const CounterRentalDispenseFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type CounterRentalDispenseFlowDirectionEnum =
  (typeof CounterRentalDispenseFlowDirectionEnum)[keyof typeof CounterRentalDispenseFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface CounterRentalDispenseRequest {
  id?: string | null
  createdAt?: string | null
  rentalDispenseItem: RentalDispenseItemRequest
  project?: ProjectRequest | null
  productionStatement?: ProductionStatementRequest | null
  fileBucket: FileBucketRequest
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: CounterRentalDispenseRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  supplierComment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instruction: string
  counterMutation?: string | null
}

export const CounterRentalDispenseRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type CounterRentalDispenseRequestFlowDirectionEnum =
  (typeof CounterRentalDispenseRequestFlowDirectionEnum)[keyof typeof CounterRentalDispenseRequestFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface CounterRentalIntake {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  rentalIntakeItem: RentalIntakeItem
  project?: Project | null
  counteredBy: Array<ShallowRentalIntake>
  fileBucket: FileBucket
  associatedRentalDispense: RentalDispense
  sequenceNumber: number
  materializationCount: number
  incomingInvoiceReferences: Array<any>
  updatedAt: string
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: CounterRentalIntakeFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instruction: string
  counterMutation?: string | null
}

export const CounterRentalIntakeFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type CounterRentalIntakeFlowDirectionEnum =
  (typeof CounterRentalIntakeFlowDirectionEnum)[keyof typeof CounterRentalIntakeFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface CounterRentalIntakeRequest {
  id?: string | null
  createdAt?: string | null
  rentalIntakeItem: RentalIntakeItemRequest
  project?: ProjectRequest | null
  fileBucket: FileBucketRequest
  associatedRentalDispense: RentalDispenseRequest
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: CounterRentalIntakeRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  instruction: string
  counterMutation?: string | null
}

export const CounterRentalIntakeRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type CounterRentalIntakeRequestFlowDirectionEnum =
  (typeof CounterRentalIntakeRequestFlowDirectionEnum)[keyof typeof CounterRentalIntakeRequestFlowDirectionEnum]

/**
 * Destination/delivery location info
 */
export interface Destination {
  name: string | null
  address: string | null
  coordinates: Location | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface FileBucket {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  fileRelations: Array<FileRelation>
  updatedAt: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface FileBucketRequest {
  id?: string | null
  createdAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface FileRelation {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  file: any
  updatedAt: string
  unsavedBucketId?: string | null
  /**
   * * `1` - Planning * `2` - Dienstverlener-app * `3` - Systeem * `4` - Inkomende factuur kolom
   */
  context: FileRelationContextEnum
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  fileBucket?: string | null
}

export const FileRelationContextEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4
} as const

export type FileRelationContextEnum =
  (typeof FileRelationContextEnum)[keyof typeof FileRelationContextEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface FileRelationRequest {
  id?: string | null
  createdAt?: string | null
  file: FileRequest
  unsavedBucketId?: string | null
  /**
   * * `1` - Planning * `2` - Dienstverlener-app * `3` - Systeem * `4` - Inkomende factuur kolom
   */
  context: FileRelationRequestContextEnum
  createdBy?: string | null
  updatedBy?: string | null
  fileBucket?: string | null
}

export const FileRelationRequestContextEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4
} as const

export type FileRelationRequestContextEnum =
  (typeof FileRelationRequestContextEnum)[keyof typeof FileRelationRequestContextEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface FileRequest {
  id?: string | null
  createdAt?: string | null
  originalName?: string | null
  extension?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  originalFile?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface GlobalScopedLocation {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  latitude: number
  longitude: number
  updatedAt: string
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  address?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface GlobalScopedLocationRequest {
  id?: string | null
  createdAt?: string | null
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  address?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface Group {
  name: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface Holiday {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  name: string
  date: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface HolidayRequest {
  id?: string | null
  createdAt?: string | null
  name: string
  date: string
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface IncomingInvoice {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  supplier?: KnownBusinessEntity | null
  processedBy: KnownBusinessEntityContact
  reviewedBy: KnownBusinessEntityContact
  rejectedBy: KnownBusinessEntityContact
  deletedBy: KnownBusinessEntityContact
  incomingInvoicePurchases: Array<IncomingInvoicePurchase>
  incomingInvoiceRentalIntakeMaterializations: Array<IncomingInvoiceRentalIntakeMaterialization>
  fileBucket: FileBucket
  fileBucketAttachments: FileBucket
  deletedAt: string
  updatedAt: string
  reference?: string | null
  date?: string | null
  dueDate?: string | null
  amountExclVat?: string | null
  comment?: string | null
  processedAt?: string | null
  reviewedAt?: string | null
  rejectedAt?: string | null
  exportedToAccountingAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface IncomingInvoicePurchase {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  incomingInvoiceReference: string
  updatedAt: string
  quantity: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  incomingInvoice: string
  purchase: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface IncomingInvoicePurchaseRequest {
  id?: string | null
  createdAt?: string | null
  quantity: string
  createdBy?: string | null
  updatedBy?: string | null
  incomingInvoice: string
  purchase: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface IncomingInvoiceRentalIntakeMaterialization {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  incomingInvoiceReference: string
  updatedAt: string
  quantity: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  incomingInvoice: string
  rentalIntakeMaterialization: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface IncomingInvoiceRentalIntakeMaterializationRequest {
  id?: string | null
  createdAt?: string | null
  quantity: string
  createdBy?: string | null
  updatedBy?: string | null
  incomingInvoice: string
  rentalIntakeMaterialization: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface IncomingInvoiceRequest {
  id?: string | null
  createdAt?: string | null
  supplier?: KnownBusinessEntityRequest | null
  fileBucket: FileBucketRequest
  fileBucketAttachments: FileBucketRequest
  reference?: string | null
  date?: string | null
  dueDate?: string | null
  amountExclVat?: string | null
  comment?: string | null
  processedAt?: string | null
  reviewedAt?: string | null
  rejectedAt?: string | null
  exportedToAccountingAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Instruction {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  planner: KnownBusinessEntityContact
  location?: Location | null
  machine?: Machine | null
  contact?: KnownBusinessEntityContact | null
  feedback: InstructionFeedback
  project?: Project | null
  fileBucket: FileBucket
  serviceProvider?: KnownBusinessEntityContact | null
  preparedBy?: KnownBusinessEntityContact | null
  reviewedBy?: KnownBusinessEntityContact | null
  updatedAt: string
  reference: string
  date?: string | null
  timeStart?: string | null
  timeEnd?: string | null
  body?: string | null
  adminComment?: string | null
  summaryText?: string | null
  flagRental?: boolean
  preparedAt?: string | null
  reviewedAt?: string | null
  lastChangeRelevantToServiceProviderAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  order: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface InstructionFeedback {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  instruction: string
  serviceProvider: KnownBusinessEntityContact
  instructionFeedbackActivities: Array<InstructionFeedbackActivity>
  fileBucket: FileBucket
  confirmedAt: string
  updatedAt: string
  body?: string | null
  /**
   * * `1` - Te doen * `2` - In behandeling * `3` - Voltooid
   */
  status?: InstructionFeedbackStatusEnum
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}

export const InstructionFeedbackStatusEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3
} as const

export type InstructionFeedbackStatusEnum =
  (typeof InstructionFeedbackStatusEnum)[keyof typeof InstructionFeedbackStatusEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface InstructionFeedbackActivity {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  instructionFeedbackActivityProducts: Array<InstructionFeedbackActivityProduct>
  location: Location
  fileBucket: FileBucket
  updatedAt: string
  /**
   * * `1` - Laden * `2` - Lossen
   */
  type: InstructionFeedbackActivityTypeEnum
  timeStart?: string | null
  timeEnd?: string | null
  customLocationText?: string | null
  body?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instructionFeedback: string
  workPeriod?: string | null
}

export const InstructionFeedbackActivityTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type InstructionFeedbackActivityTypeEnum =
  (typeof InstructionFeedbackActivityTypeEnum)[keyof typeof InstructionFeedbackActivityTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface InstructionFeedbackActivityProduct {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  product?: Product | null
  fileBucket: FileBucket
  updatedAt: string
  quantity?: string | null
  customProductName?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instructionFeedbackActivity: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface InstructionFeedbackActivityProductRequest {
  id?: string | null
  createdAt?: string | null
  product?: ProductRequest | null
  fileBucket: FileBucketRequest
  quantity?: string | null
  customProductName?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instructionFeedbackActivity: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface InstructionFeedbackActivityRequest {
  id?: string | null
  createdAt?: string | null
  location: LocationRequest
  fileBucket: FileBucketRequest
  /**
   * * `1` - Laden * `2` - Lossen
   */
  type: InstructionFeedbackActivityRequestTypeEnum
  timeStart?: string | null
  timeEnd?: string | null
  customLocationText?: string | null
  body?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instructionFeedback: string
  workPeriod?: string | null
}

export const InstructionFeedbackActivityRequestTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type InstructionFeedbackActivityRequestTypeEnum =
  (typeof InstructionFeedbackActivityRequestTypeEnum)[keyof typeof InstructionFeedbackActivityRequestTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface InstructionFeedbackRequest {
  id?: string | null
  createdAt?: string | null
  serviceProvider: KnownBusinessEntityContactRequest
  fileBucket: FileBucketRequest
  body?: string | null
  /**
   * * `1` - Te doen * `2` - In behandeling * `3` - Voltooid
   */
  status?: InstructionFeedbackRequestStatusEnum
  createdBy?: string | null
  updatedBy?: string | null
}

export const InstructionFeedbackRequestStatusEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3
} as const

export type InstructionFeedbackRequestStatusEnum =
  (typeof InstructionFeedbackRequestStatusEnum)[keyof typeof InstructionFeedbackRequestStatusEnum]

/**
 * Lightweight serializer for location-only tracking.
 */
export interface InstructionLocationOnly {
  currentLocation: Location | null
  locationUpdatedAt: string | null
}
/**
 * Serializer for read operations that uses foreign key fields instead of full serialized objects.
 */
export interface InstructionRead {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  feedback: InstructionFeedback
  fileBucket: FileBucket
  updatedAt: string
  reference: string
  date?: string | null
  timeStart?: string | null
  timeEnd?: string | null
  body?: string | null
  adminComment?: string | null
  summaryText?: string | null
  flagRental?: boolean
  preparedAt?: string | null
  reviewedAt?: string | null
  lastChangeRelevantToServiceProviderAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  order: string
  project?: string | null
  planner: string
  location?: string | null
  serviceProvider?: string | null
  machine?: string | null
  contact?: string | null
  preparedBy?: string | null
  reviewedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface InstructionRequest {
  id?: string | null
  createdAt?: string | null
  planner: KnownBusinessEntityContactRequest
  location?: LocationRequest | null
  machine?: MachineRequest | null
  contact?: KnownBusinessEntityContactRequest | null
  project?: ProjectRequest | null
  fileBucket: FileBucketRequest
  serviceProvider?: KnownBusinessEntityContactRequest | null
  preparedBy?: KnownBusinessEntityContactRequest | null
  reviewedBy?: KnownBusinessEntityContactRequest | null
  date?: string | null
  timeStart?: string | null
  timeEnd?: string | null
  body?: string | null
  adminComment?: string | null
  summaryText?: string | null
  flagRental?: boolean
  preparedAt?: string | null
  reviewedAt?: string | null
  lastChangeRelevantToServiceProviderAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  order: string
}
/**
 * Full tracking info for an instruction
 */
export interface InstructionTracking {
  serviceProvider: ServiceProvider
  currentLocation: Location | null
  locationUpdatedAt: string | null
  destination: Destination | null
  schedule: Schedule
  order: OrderInfo
  project: ProjectInfo | null
  contact: ContactInfo | null
  planner: PlannerInfo
  machine: MachineInfo | null
  instructionSummary: string | null
  instructionMessage: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface KnownBusinessEntity {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  registeredBusinessEntity: RegisteredBusinessEntity
  updatedAt: string
  customName?: string | null
  countryOfRegistration?: string | null
  registrationNumber?: string | null
  comment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface KnownBusinessEntityContact {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  person: Person
  knownBusinessEntity?: KnownBusinessEntity | null
  userId: string
  roles: Array<OptimizedRole>
  email?: string | null
  phoneNumber?: string | null
  invitationCode: string
  updatedAt: string
  isPrivateIndividual?: boolean
  isActive?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  relatedUser?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface KnownBusinessEntityContactRequest {
  id?: string | null
  createdAt?: string | null
  person: PersonRequest
  knownBusinessEntity?: KnownBusinessEntityRequest | null
  email?: string | null
  phoneNumber?: string | null
  isPrivateIndividual?: boolean
  isActive?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  relatedUser?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface KnownBusinessEntityRentalDispenseItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  unitPricePerDay: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  knownBusinessEntity: string
  rentalDispenseItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface KnownBusinessEntityRentalDispenseItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPricePerDay: string
  createdBy?: string | null
  updatedBy?: string | null
  knownBusinessEntity: string
  rentalDispenseItem: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface KnownBusinessEntityRequest {
  id?: string | null
  createdAt?: string | null
  customName?: string | null
  countryOfRegistration?: string | null
  registrationNumber?: string | null
  comment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface KnownBusinessEntitySaleItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  unitPrice: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  saleItem: string
  knownBusinessEntity: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface KnownBusinessEntitySaleItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPrice: string
  createdBy?: string | null
  updatedBy?: string | null
  saleItem: string
  knownBusinessEntity: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface LayoutColumnConfig {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  userSettings: string
  updatedAt: string
  /**
   * * `1` - Orderlijst * `2` - Instructielijst * `3` - Bestandsviewer * `4` - Kaart * `5` - App * `6` - Klant * `7` - Productieverantwoording * `8` - Inkoop * `9` - Facturatie * `10` - Instructiezoeker * `11` - Inkoopfacturen
   */
  component: LayoutColumnConfigComponentEnum
  widthPercentage?: number | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}

export const LayoutColumnConfigComponentEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11
} as const

export type LayoutColumnConfigComponentEnum =
  (typeof LayoutColumnConfigComponentEnum)[keyof typeof LayoutColumnConfigComponentEnum]

/**
 * Serializer mixin that exposes a PostGIS PointField as flat latitude/longitude fields.  Expects the model to have a `point` field (PointField). Adds `latitude` and `longitude` to the serialized output and accepts them on input.
 */
export interface Location {
  id?: string | null
  latitude?: number | null
  longitude?: number | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  address?: string | null
  name?: string | null
  isTenantBase?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Serializer mixin that exposes a PostGIS PointField as flat latitude/longitude fields.  Expects the model to have a `point` field (PointField). Adds `latitude` and `longitude` to the serialized output and accepts them on input.
 */
export interface LocationRequest {
  id?: string | null
  latitude?: number | null
  longitude?: number | null
  createdAt?: string | null
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  address?: string | null
  name?: string | null
  isTenantBase?: boolean
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Machine {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  name: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Machine/equipment info
 */
export interface MachineInfo {
  id: string
  name: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface MachineRequest {
  id?: string | null
  createdAt?: string | null
  name: string
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Message {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  messenger?: KnownBusinessEntityContact
  fileBucket: FileBucket
  updatedAt: string
  body?: string | null
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  order?: string
}
/**
 * Serializer for read operations that uses foreign key fields instead of full serialized objects.
 */
export interface MessageRead {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  fileBucket: FileBucket
  updatedAt: string
  body?: string | null
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  messenger: string
  order?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface MessageRequest {
  id?: string | null
  createdAt?: string | null
  messenger?: KnownBusinessEntityContactRequest
  fileBucket: FileBucketRequest
  body?: string | null
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  order?: string
}
export interface ModelError {
  error: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ModelFile {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  url: string
  thumbUrl: string
  fileName: string
  thumbName: string
  derivedFiles: Array<BaseFile>
  updatedAt: string
  originalName?: string | null
  extension?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  originalFile?: string | null
}
/**
 * Optimized serializer for read-only operations that works efficiently with prefetched concrete instances. This serializer avoids the polymorphic overhead and directly serializes the concrete instances.
 */
export interface OptimizedRole {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  /**
   * * `1` - Planner * `2` - Dienstverlener * `3` - Financieel verantwoordelijke
   */
  type: OptimizedRoleTypeEnum
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  knownBusinessEntityContact: string
}

export const OptimizedRoleTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3
} as const

export type OptimizedRoleTypeEnum =
  (typeof OptimizedRoleTypeEnum)[keyof typeof OptimizedRoleTypeEnum]

/**
 * Optimized serializer for read-only operations that works efficiently with prefetched concrete instances. This serializer avoids the polymorphic overhead and directly serializes the concrete instances.
 */
export interface OptimizedRoleRequest {
  id?: string | null
  createdAt?: string | null
  /**
   * * `1` - Planner * `2` - Dienstverlener * `3` - Financieel verantwoordelijke
   */
  type: OptimizedRoleRequestTypeEnum
  createdBy?: string | null
  updatedBy?: string | null
  knownBusinessEntityContact: string
}

export const OptimizedRoleRequestTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3
} as const

export type OptimizedRoleRequestTypeEnum =
  (typeof OptimizedRoleRequestTypeEnum)[keyof typeof OptimizedRoleRequestTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface Order {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  messages: Array<Message>
  instructions: Array<Instruction>
  updatedAt: string
  reference: string
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Order info
 */
export interface OrderInfo {
  id: string
  reference: string
}
/**
 * Serializer for read operations that uses read serializers for optimal performance.
 */
export interface OrderRead {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  messages: Array<MessageRead>
  instructions: Array<InstructionRead>
  updatedAt: string
  reference: string
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface OrderRequest {
  id?: string | null
  createdAt?: string | null
  messages: Array<MessageRequest>
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
}
export interface PaginatedActivityList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Activity>
}
export interface PaginatedHolidayList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Holiday>
}
export interface PaginatedIncomingInvoiceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<IncomingInvoice>
}
export interface PaginatedIncomingInvoicePurchaseList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<IncomingInvoicePurchase>
}
export interface PaginatedIncomingInvoiceRentalIntakeMaterializationList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<IncomingInvoiceRentalIntakeMaterialization>
}
export interface PaginatedInstructionFeedbackActivityList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<InstructionFeedbackActivity>
}
export interface PaginatedInstructionFeedbackActivityProductList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<InstructionFeedbackActivityProduct>
}
export interface PaginatedInstructionFeedbackList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<InstructionFeedback>
}
export interface PaginatedInstructionList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Instruction>
}
export interface PaginatedKnownBusinessEntityContactList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<KnownBusinessEntityContact>
}
export interface PaginatedKnownBusinessEntityList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<KnownBusinessEntity>
}
export interface PaginatedKnownBusinessEntityRentalDispenseItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<KnownBusinessEntityRentalDispenseItem>
}
export interface PaginatedKnownBusinessEntitySaleItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<KnownBusinessEntitySaleItem>
}
export interface PaginatedLocationList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Location>
}
export interface PaginatedMachineList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Machine>
}
export interface PaginatedMessageList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Message>
}
export interface PaginatedOrderReadList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<OrderRead>
}
export interface PaginatedPersonList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Person>
}
export interface PaginatedProductList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Product>
}
export interface PaginatedProjectList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Project>
}
export interface PaginatedProjectPurchaseItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ProjectPurchaseItem>
}
export interface PaginatedProjectRentalDispenseItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ProjectRentalDispenseItem>
}
export interface PaginatedProjectRentalIntakeItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ProjectRentalIntakeItem>
}
export interface PaginatedProjectSaleItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ProjectSaleItem>
}
export interface PaginatedPurchaseItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<PurchaseItem>
}
export interface PaginatedPurchaseList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Purchase>
}
export interface PaginatedPurchaseSurchargePeriodList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<PurchaseSurchargePeriod>
}
export interface PaginatedRentalDispenseItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<RentalDispenseItem>
}
export interface PaginatedRentalDispenseList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<RentalDispense>
}
export interface PaginatedRentalIntakeItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<RentalIntakeItem>
}
export interface PaginatedRentalIntakeList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<RentalIntake>
}
export interface PaginatedRoleServiceProviderMachineList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<RoleServiceProviderMachine>
}
export interface PaginatedSaleItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<SaleItem>
}
export interface PaginatedSaleList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Sale>
}
export interface PaginatedServiceProviderDateList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ServiceProviderDate>
}
export interface PaginatedShallowRentalIntakeMaterializationList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ShallowRentalIntakeMaterialization>
}
export interface PaginatedUserLocationList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<UserLocation>
}
export interface PaginatedWorkPeriodList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<WorkPeriod>
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedActivityRequest {
  id?: string | null
  createdAt?: string | null
  timeStart?: string
  timeEnd?: string
  /**
   * * `1` - Break * `2` - Maintenance
   */
  type?: PatchedActivityRequestTypeEnum
  description?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  workPeriod?: string
}

export const PatchedActivityRequestTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PatchedActivityRequestTypeEnum =
  (typeof PatchedActivityRequestTypeEnum)[keyof typeof PatchedActivityRequestTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedHolidayRequest {
  id?: string | null
  createdAt?: string | null
  name?: string
  date?: string
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedIncomingInvoicePurchaseRequest {
  id?: string | null
  createdAt?: string | null
  quantity?: string
  createdBy?: string | null
  updatedBy?: string | null
  incomingInvoice?: string
  purchase?: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedIncomingInvoiceRentalIntakeMaterializationRequest {
  id?: string | null
  createdAt?: string | null
  quantity?: string
  createdBy?: string | null
  updatedBy?: string | null
  incomingInvoice?: string
  rentalIntakeMaterialization?: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedIncomingInvoiceRequest {
  id?: string | null
  createdAt?: string | null
  supplier?: KnownBusinessEntityRequest | null
  fileBucket?: FileBucketRequest
  fileBucketAttachments?: FileBucketRequest
  reference?: string | null
  date?: string | null
  dueDate?: string | null
  amountExclVat?: string | null
  comment?: string | null
  processedAt?: string | null
  reviewedAt?: string | null
  rejectedAt?: string | null
  exportedToAccountingAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedInstructionFeedbackActivityProductRequest {
  id?: string | null
  createdAt?: string | null
  product?: ProductRequest | null
  fileBucket?: FileBucketRequest
  quantity?: string | null
  customProductName?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instructionFeedbackActivity?: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedInstructionFeedbackActivityRequest {
  id?: string | null
  createdAt?: string | null
  location?: LocationRequest
  fileBucket?: FileBucketRequest
  /**
   * * `1` - Laden * `2` - Lossen
   */
  type?: PatchedInstructionFeedbackActivityRequestTypeEnum
  timeStart?: string | null
  timeEnd?: string | null
  customLocationText?: string | null
  body?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instructionFeedback?: string
  workPeriod?: string | null
}

export const PatchedInstructionFeedbackActivityRequestTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PatchedInstructionFeedbackActivityRequestTypeEnum =
  (typeof PatchedInstructionFeedbackActivityRequestTypeEnum)[keyof typeof PatchedInstructionFeedbackActivityRequestTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedInstructionFeedbackRequest {
  id?: string | null
  createdAt?: string | null
  serviceProvider?: KnownBusinessEntityContactRequest
  fileBucket?: FileBucketRequest
  body?: string | null
  /**
   * * `1` - Te doen * `2` - In behandeling * `3` - Voltooid
   */
  status?: PatchedInstructionFeedbackRequestStatusEnum
  createdBy?: string | null
  updatedBy?: string | null
}

export const PatchedInstructionFeedbackRequestStatusEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3
} as const

export type PatchedInstructionFeedbackRequestStatusEnum =
  (typeof PatchedInstructionFeedbackRequestStatusEnum)[keyof typeof PatchedInstructionFeedbackRequestStatusEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedInstructionRequest {
  id?: string | null
  createdAt?: string | null
  planner?: KnownBusinessEntityContactRequest
  location?: LocationRequest | null
  machine?: MachineRequest | null
  contact?: KnownBusinessEntityContactRequest | null
  project?: ProjectRequest | null
  fileBucket?: FileBucketRequest
  serviceProvider?: KnownBusinessEntityContactRequest | null
  preparedBy?: KnownBusinessEntityContactRequest | null
  reviewedBy?: KnownBusinessEntityContactRequest | null
  date?: string | null
  timeStart?: string | null
  timeEnd?: string | null
  body?: string | null
  adminComment?: string | null
  summaryText?: string | null
  flagRental?: boolean
  preparedAt?: string | null
  reviewedAt?: string | null
  lastChangeRelevantToServiceProviderAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  order?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedKnownBusinessEntityContactRequest {
  id?: string | null
  createdAt?: string | null
  person?: PersonRequest
  knownBusinessEntity?: KnownBusinessEntityRequest | null
  email?: string | null
  phoneNumber?: string | null
  isPrivateIndividual?: boolean
  isActive?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  relatedUser?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedKnownBusinessEntityRentalDispenseItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPricePerDay?: string
  createdBy?: string | null
  updatedBy?: string | null
  knownBusinessEntity?: string
  rentalDispenseItem?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedKnownBusinessEntityRequest {
  id?: string | null
  createdAt?: string | null
  customName?: string | null
  countryOfRegistration?: string | null
  registrationNumber?: string | null
  comment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedKnownBusinessEntitySaleItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPrice?: string
  createdBy?: string | null
  updatedBy?: string | null
  saleItem?: string
  knownBusinessEntity?: string
}
/**
 * Serializer mixin that exposes a PostGIS PointField as flat latitude/longitude fields.  Expects the model to have a `point` field (PointField). Adds `latitude` and `longitude` to the serialized output and accepts them on input.
 */
export interface PatchedLocationRequest {
  id?: string | null
  latitude?: number | null
  longitude?: number | null
  createdAt?: string | null
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  address?: string | null
  name?: string | null
  isTenantBase?: boolean
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedMachineRequest {
  id?: string | null
  createdAt?: string | null
  name?: string
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedMessageRequest {
  id?: string | null
  createdAt?: string | null
  messenger?: KnownBusinessEntityContactRequest
  fileBucket?: FileBucketRequest
  body?: string | null
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  order?: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedOrderRequest {
  id?: string | null
  createdAt?: string | null
  messages?: Array<MessageRequest>
  isPrepared?: boolean
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedPersonRequest {
  id?: string | null
  createdAt?: string | null
  address?: AddressRequest | null
  firstName?: string
  lastName?: string
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedProjectPurchaseItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPrice?: string
  createdBy?: string | null
  updatedBy?: string | null
  project?: string
  purchaseItem?: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedProjectRentalDispenseItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPricePerDay?: string
  createdBy?: string | null
  updatedBy?: string | null
  project?: string
  rentalDispenseItem?: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedProjectRentalIntakeItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPricePerDay?: string
  createdBy?: string | null
  updatedBy?: string | null
  project?: string
  rentalIntakeItem?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedProjectRequest {
  id?: string | null
  createdAt?: string | null
  executor?: KnownBusinessEntityContactRequest
  contact?: KnownBusinessEntityContactRequest
  fileBucket?: FileBucketRequest
  name?: string
  descriptionPlanner?: string | null
  descriptionServiceProvider?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedProjectSaleItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPrice?: string
  createdBy?: string | null
  updatedBy?: string | null
  project?: string
  saleItem?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedPurchaseItemRequest {
  id?: string | null
  createdAt?: string | null
  saleItem?: SaleItemRequest | null
  supplier?: KnownBusinessEntityRequest
  name?: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: PatchedPurchaseItemRequestUnitEnum
  unitPrice?: string | null
  conversionRate?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const PatchedPurchaseItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type PatchedPurchaseItemRequestUnitEnum =
  (typeof PatchedPurchaseItemRequestUnitEnum)[keyof typeof PatchedPurchaseItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedPurchaseRequest {
  id?: string | null
  createdAt?: string | null
  purchaseItem?: PurchaseItemRequest
  project?: ProjectRequest | null
  associatedSale?: SaleRequest | null
  fileBucket?: FileBucketRequest
  unitPrice?: string | null
  quantity?: string | null
  date?: string | null
  sortIndex?: number
  hasCustomUnitPrice?: boolean
  comment?: string
  /**
   * * `1` - Percentage * `2` - Vast bedrag
   */
  surchargeType?: PatchedPurchaseRequestSurchargeTypeEnum | null
  invoiceReference?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instruction?: string
  isSurchargeFor?: string | null
  purchaseSurchargePeriod?: string | null
}

export const PatchedPurchaseRequestSurchargeTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PatchedPurchaseRequestSurchargeTypeEnum =
  (typeof PatchedPurchaseRequestSurchargeTypeEnum)[keyof typeof PatchedPurchaseRequestSurchargeTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedPurchaseSurchargePeriodRequest {
  id?: string | null
  createdAt?: string | null
  periodStart?: string
  periodEnd?: string
  /**
   * Notatie: 3 = 3%, 120 = 120%
   */
  surchargePercent?: string | null
  /**
   * Vast bedrag dat bovenop de procentuele toeslag komt.
   */
  surchargeFlat?: string | null
  /**
   * Alleen actieve periodes genereren toeslagregels. Bij (de)activering worden bestaande toeslagregels met terugwerkende kracht aangemaakt of verwijderd (indien optie \"terugwerkende kracht\" is aangevinkt).
   */
  isActive?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  purchaseItem?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedRentalDispenseItemRequest {
  id?: string | null
  createdAt?: string | null
  name?: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: PatchedRentalDispenseItemRequestUnitEnum
  unitPricePerDay?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const PatchedRentalDispenseItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type PatchedRentalDispenseItemRequestUnitEnum =
  (typeof PatchedRentalDispenseItemRequestUnitEnum)[keyof typeof PatchedRentalDispenseItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedRentalDispenseRequest {
  id?: string | null
  createdAt?: string | null
  rentalDispenseItem?: RentalDispenseItemRequest
  project?: ProjectRequest | null
  productionStatement?: ProductionStatementRequest | null
  fileBucket?: FileBucketRequest
  counterMutation?: CounterRentalDispenseRequest | null
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection?: PatchedRentalDispenseRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  supplierComment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instruction?: string
}

export const PatchedRentalDispenseRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PatchedRentalDispenseRequestFlowDirectionEnum =
  (typeof PatchedRentalDispenseRequestFlowDirectionEnum)[keyof typeof PatchedRentalDispenseRequestFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedRentalIntakeItemRequest {
  id?: string | null
  createdAt?: string | null
  rentalDispenseItem?: RentalDispenseItemRequest | null
  supplier?: KnownBusinessEntityRequest
  name?: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: PatchedRentalIntakeItemRequestUnitEnum
  unitPricePerDay?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const PatchedRentalIntakeItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type PatchedRentalIntakeItemRequestUnitEnum =
  (typeof PatchedRentalIntakeItemRequestUnitEnum)[keyof typeof PatchedRentalIntakeItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedRentalIntakeRequest {
  id?: string | null
  createdAt?: string | null
  rentalIntakeItem?: RentalIntakeItemRequest
  project?: ProjectRequest | null
  fileBucket?: FileBucketRequest
  associatedRentalDispense?: RentalDispenseRequest
  counterMutation?: CounterRentalIntakeRequest | null
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection?: PatchedRentalIntakeRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  instruction?: string
}

export const PatchedRentalIntakeRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PatchedRentalIntakeRequestFlowDirectionEnum =
  (typeof PatchedRentalIntakeRequestFlowDirectionEnum)[keyof typeof PatchedRentalIntakeRequestFlowDirectionEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedRoleServiceProviderMachineRequest {
  id?: string | null
  createdAt?: string | null
  machine?: MachineRequest | null
  purchaseItem?: PurchaseItemRequest | null
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  roleServiceProvider?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedSaleItemRequest {
  id?: string | null
  createdAt?: string | null
  name?: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: PatchedSaleItemRequestUnitEnum
  unitPrice?: string | null
  /**
   * Modifier waarmee de brandstoftoeslag wordt vermenigvuldigd. Leeg = geen toeslag, 1 = onaangepaste toeslag.
   */
  surchargeModifier?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const PatchedSaleItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type PatchedSaleItemRequestUnitEnum =
  (typeof PatchedSaleItemRequestUnitEnum)[keyof typeof PatchedSaleItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PatchedSaleRequest {
  id?: string | null
  createdAt?: string | null
  saleItem?: SaleItemRequest
  project?: ProjectRequest | null
  productionStatement?: ProductionStatementRequest | null
  fileBucket?: FileBucketRequest
  unitPrice?: string | null
  quantity?: string | null
  date?: string | null
  sortIndex?: number
  hasCustomUnitPrice?: boolean
  comment?: string
  /**
   * * `1` - Percentage * `2` - Vast bedrag
   */
  surchargeType?: PatchedSaleRequestSurchargeTypeEnum | null
  createdBy?: string | null
  updatedBy?: string | null
  instruction?: string
  isSurchargeFor?: string | null
  saleSurchargePeriod?: string | null
}

export const PatchedSaleRequestSurchargeTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PatchedSaleRequestSurchargeTypeEnum =
  (typeof PatchedSaleRequestSurchargeTypeEnum)[keyof typeof PatchedSaleRequestSurchargeTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedServiceProviderDateRequest {
  id?: string | null
  createdAt?: string | null
  serviceProvider?: KnownBusinessEntityContactRequest
  fileBucket?: FileBucketRequest
  date?: string
  isPublished?: boolean
  purchaseTimeStart?: string | null
  purchaseTimeEnd?: string | null
  saleTimeStart?: string | null
  saleTimeEnd?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Shallow representation of RentalIntakeMaterialization. Does not include rental_mutation full nested object, but annotates the key fields instead.
 */
export interface PatchedShallowRentalIntakeMaterializationRequest {
  id?: string | null
  createdAt?: string | null
  periodStart?: string
  periodEnd?: string
  quantity?: string
  unitPricePerDay?: string
  netDayQuantity?: number
  sequenceNumber?: number
  invoiceReference?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Serializer for UserLocation model.
 */
export interface PatchedUserLocationRequest {
  id?: string | null
  latitude?: number | null
  longitude?: number | null
  createdAt?: string | null
  coords?: CoordsRequest
  activity?: ActivityRequest | null
  battery?: BatteryRequest | null
  uuid?: string | null
  timestamp?: string | null
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  /**
   * Accuracy in meters
   */
  accuracy?: number | null
  /**
   * Speed in meters/second
   */
  speed?: number | null
  /**
   * Speed accuracy in meters/second (Android only)
   */
  speedAccuracy?: number | null
  /**
   * Heading in degrees (0-360)
   */
  heading?: number | null
  /**
   * Heading accuracy in degrees (iOS only)
   */
  headingAccuracy?: number | null
  /**
   * Altitude in meters above sea level
   */
  altitude?: number | null
  /**
   * Altitude accuracy in meters
   */
  altitudeAccuracy?: number | null
  /**
   * Altitude with respect to the WGS84 ellipsoid (Android only)
   */
  ellipsoidalAltitude?: number | null
  /**
   * Activity type: still, walking, on_foot, running, on_bicycle, in_vehicle, unknown
   */
  activityType?: string | null
  /**
   * Activity confidence (0-100)
   */
  activityConfidence?: number | null
  /**
   * Battery level (0.0 - 1.0)
   */
  batteryLevel?: number | null
  /**
   * Whether device is charging
   */
  batteryIsCharging?: boolean | null
  /**
   * Event that triggered location: motionchange, providerchange, geofence, heartbeat, etc.
   */
  event?: string | null
  /**
   * Whether device is moving
   */
  isMoving?: boolean | null
  /**
   * Distance traveled in meters
   */
  odometer?: number | null
  /**
   * Unique identifier for this location from the plugin
   */
  locationUuid?: string | null
  /**
   * Age of location in milliseconds
   */
  age?: number | null
  /**
   * Custom extras attached to location
   */
  extras?: any | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedUserTenantRequest {
  id?: string | null
  createdAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  user?: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PatchedWorkPeriodRequest {
  id?: string | null
  createdAt?: string | null
  owner?: KnownBusinessEntityContactRequest
  timeStart?: string
  timeEnd?: string | null
  description?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Person {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  knownBusinessEntities: Array<KnownBusinessEntity>
  address?: Address | null
  fullName: string
  updatedAt: string
  firstName: string
  lastName: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PersonRequest {
  id?: string | null
  createdAt?: string | null
  address?: AddressRequest | null
  firstName: string
  lastName: string
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Planner who assigned this instruction
 */
export interface PlannerInfo {
  name: string
  phone: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface Product {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit: ProductUnitEnum
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}

export const ProductUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type ProductUnitEnum = (typeof ProductUnitEnum)[keyof typeof ProductUnitEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProductRequest {
  id?: string | null
  createdAt?: string | null
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit: ProductRequestUnitEnum
  createdBy?: string | null
  updatedBy?: string | null
}

export const ProductRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type ProductRequestUnitEnum =
  (typeof ProductRequestUnitEnum)[keyof typeof ProductRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ProductionStatement {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  project: string
  updatedAt: string
  periodStart: string
  periodEnd: string
  reference: string
  lastSentAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  fileBucket?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ProductionStatementRequest {
  id?: string | null
  createdAt?: string | null
  periodStart: string
  periodEnd: string
  reference: string
  lastSentAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  fileBucket?: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Project {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  executor: KnownBusinessEntityContact
  contact: KnownBusinessEntityContact
  fileBucket: FileBucket
  updatedAt: string
  name: string
  descriptionPlanner?: string | null
  descriptionServiceProvider?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Project info
 */
export interface ProjectInfo {
  id: string
  name: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectPurchaseItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  unitPrice: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  project: string
  purchaseItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectPurchaseItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPrice: string
  createdBy?: string | null
  updatedBy?: string | null
  project: string
  purchaseItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectRentalDispenseItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  unitPricePerDay: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  project: string
  rentalDispenseItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectRentalDispenseItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPricePerDay: string
  createdBy?: string | null
  updatedBy?: string | null
  project: string
  rentalDispenseItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectRentalIntakeItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  unitPricePerDay: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  project: string
  rentalIntakeItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectRentalIntakeItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPricePerDay: string
  createdBy?: string | null
  updatedBy?: string | null
  project: string
  rentalIntakeItem: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ProjectRequest {
  id?: string | null
  createdAt?: string | null
  executor: KnownBusinessEntityContactRequest
  contact: KnownBusinessEntityContactRequest
  fileBucket: FileBucketRequest
  name: string
  descriptionPlanner?: string | null
  descriptionServiceProvider?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectSaleItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  unitPrice: string
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  project: string
  saleItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ProjectSaleItemRequest {
  id?: string | null
  createdAt?: string | null
  unitPrice: string
  createdBy?: string | null
  updatedBy?: string | null
  project: string
  saleItem: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Purchase {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  purchaseItem: PurchaseItem
  project?: Project | null
  associatedSale?: Sale | null
  incomingInvoicePurchases: Array<IncomingInvoicePurchase>
  fileBucket: FileBucket
  projectExecutorFullName: string
  surchargeDescription: string
  surchargePercent: string
  surchargeFlat: string
  updatedAt: string
  unitPrice?: string | null
  quantity?: string | null
  date?: string | null
  sortIndex?: number
  hasCustomUnitPrice?: boolean
  comment?: string
  /**
   * * `1` - Percentage * `2` - Vast bedrag
   */
  surchargeType?: PurchaseSurchargeTypeEnum | null
  invoiceReference?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instruction: string
  isSurchargeFor?: string | null
  purchaseSurchargePeriod?: string | null
}

export const PurchaseSurchargeTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PurchaseSurchargeTypeEnum =
  (typeof PurchaseSurchargeTypeEnum)[keyof typeof PurchaseSurchargeTypeEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PurchaseItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  saleItem?: SaleItem | null
  supplier: KnownBusinessEntity
  updatedAt: string
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: PurchaseItemUnitEnum
  unitPrice?: string | null
  conversionRate?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}

export const PurchaseItemUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type PurchaseItemUnitEnum = (typeof PurchaseItemUnitEnum)[keyof typeof PurchaseItemUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PurchaseItemRequest {
  id?: string | null
  createdAt?: string | null
  saleItem?: SaleItemRequest | null
  supplier: KnownBusinessEntityRequest
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: PurchaseItemRequestUnitEnum
  unitPrice?: string | null
  conversionRate?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const PurchaseItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type PurchaseItemRequestUnitEnum =
  (typeof PurchaseItemRequestUnitEnum)[keyof typeof PurchaseItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface PurchaseRequest {
  id?: string | null
  createdAt?: string | null
  purchaseItem: PurchaseItemRequest
  project?: ProjectRequest | null
  associatedSale?: SaleRequest | null
  fileBucket: FileBucketRequest
  unitPrice?: string | null
  quantity?: string | null
  date?: string | null
  sortIndex?: number
  hasCustomUnitPrice?: boolean
  comment?: string
  /**
   * * `1` - Percentage * `2` - Vast bedrag
   */
  surchargeType?: PurchaseRequestSurchargeTypeEnum | null
  invoiceReference?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instruction: string
  isSurchargeFor?: string | null
  purchaseSurchargePeriod?: string | null
}

export const PurchaseRequestSurchargeTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type PurchaseRequestSurchargeTypeEnum =
  (typeof PurchaseRequestSurchargeTypeEnum)[keyof typeof PurchaseRequestSurchargeTypeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PurchaseSurchargePeriod {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  periodStart: string
  periodEnd: string
  /**
   * Notatie: 3 = 3%, 120 = 120%
   */
  surchargePercent?: string | null
  /**
   * Vast bedrag dat bovenop de procentuele toeslag komt.
   */
  surchargeFlat?: string | null
  /**
   * Alleen actieve periodes genereren toeslagregels. Bij (de)activering worden bestaande toeslagregels met terugwerkende kracht aangemaakt of verwijderd (indien optie \"terugwerkende kracht\" is aangevinkt).
   */
  isActive?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  purchaseItem: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface PurchaseSurchargePeriodRequest {
  id?: string | null
  createdAt?: string | null
  periodStart: string
  periodEnd: string
  /**
   * Notatie: 3 = 3%, 120 = 120%
   */
  surchargePercent?: string | null
  /**
   * Vast bedrag dat bovenop de procentuele toeslag komt.
   */
  surchargeFlat?: string | null
  /**
   * Alleen actieve periodes genereren toeslagregels. Bij (de)activering worden bestaande toeslagregels met terugwerkende kracht aangemaakt of verwijderd (indien optie \"terugwerkende kracht\" is aangevinkt).
   */
  isActive?: boolean
  createdBy?: string | null
  updatedBy?: string | null
  purchaseItem: string
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RegisteredBusinessEntity {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  businessLocations: Array<BusinessLocation>
  updatedAt: string
  /**
   * * `1` - Handmatig * `2` - KVK
   */
  dataSource: RegisteredBusinessEntityDataSourceEnum
  countryOfRegistration: string
  registrationNumber: string
  name: string
  createdBy?: string | null
  updatedBy?: string | null
}

export const RegisteredBusinessEntityDataSourceEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type RegisteredBusinessEntityDataSourceEnum =
  (typeof RegisteredBusinessEntityDataSourceEnum)[keyof typeof RegisteredBusinessEntityDataSourceEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RegisteredBusinessEntityRequest {
  id?: string | null
  createdAt?: string | null
  /**
   * * `1` - Handmatig * `2` - KVK
   */
  dataSource: RegisteredBusinessEntityRequestDataSourceEnum
  countryOfRegistration: string
  registrationNumber: string
  name: string
  createdBy?: string | null
  updatedBy?: string | null
}

export const RegisteredBusinessEntityRequestDataSourceEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type RegisteredBusinessEntityRequestDataSourceEnum =
  (typeof RegisteredBusinessEntityRequestDataSourceEnum)[keyof typeof RegisteredBusinessEntityRequestDataSourceEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalDispense {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  rentalDispenseItem: RentalDispenseItem
  project?: Project | null
  counteredBy: Array<ShallowRentalDispense>
  productionStatement?: ProductionStatement | null
  fileBucket: FileBucket
  sequenceNumber: number
  materializationCount: number
  counterMutation?: CounterRentalDispense | null
  updatedAt: string
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: RentalDispenseFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  supplierComment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instruction: string
}

export const RentalDispenseFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type RentalDispenseFlowDirectionEnum =
  (typeof RentalDispenseFlowDirectionEnum)[keyof typeof RentalDispenseFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalDispenseItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: RentalDispenseItemUnitEnum
  unitPricePerDay?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}

export const RentalDispenseItemUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type RentalDispenseItemUnitEnum =
  (typeof RentalDispenseItemUnitEnum)[keyof typeof RentalDispenseItemUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalDispenseItemRequest {
  id?: string | null
  createdAt?: string | null
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: RentalDispenseItemRequestUnitEnum
  unitPricePerDay?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const RentalDispenseItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type RentalDispenseItemRequestUnitEnum =
  (typeof RentalDispenseItemRequestUnitEnum)[keyof typeof RentalDispenseItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalDispenseRequest {
  id?: string | null
  createdAt?: string | null
  rentalDispenseItem: RentalDispenseItemRequest
  project?: ProjectRequest | null
  productionStatement?: ProductionStatementRequest | null
  fileBucket: FileBucketRequest
  counterMutation?: CounterRentalDispenseRequest | null
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: RentalDispenseRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  supplierComment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  instruction: string
}

export const RentalDispenseRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type RentalDispenseRequestFlowDirectionEnum =
  (typeof RentalDispenseRequestFlowDirectionEnum)[keyof typeof RentalDispenseRequestFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalIntake {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  rentalIntakeItem: RentalIntakeItem
  project?: Project | null
  counteredBy: Array<ShallowRentalIntake>
  fileBucket: FileBucket
  associatedRentalDispense: RentalDispense
  sequenceNumber: number
  materializationCount: number
  incomingInvoiceReferences: Array<any>
  counterMutation?: CounterRentalIntake | null
  updatedAt: string
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: RentalIntakeFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instruction: string
}

export const RentalIntakeFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type RentalIntakeFlowDirectionEnum =
  (typeof RentalIntakeFlowDirectionEnum)[keyof typeof RentalIntakeFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalIntakeItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  rentalDispenseItem?: RentalDispenseItem | null
  supplier: KnownBusinessEntity
  updatedAt: string
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: RentalIntakeItemUnitEnum
  unitPricePerDay?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}

export const RentalIntakeItemUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type RentalIntakeItemUnitEnum =
  (typeof RentalIntakeItemUnitEnum)[keyof typeof RentalIntakeItemUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalIntakeItemRequest {
  id?: string | null
  createdAt?: string | null
  rentalDispenseItem?: RentalDispenseItemRequest | null
  supplier: KnownBusinessEntityRequest
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: RentalIntakeItemRequestUnitEnum
  unitPricePerDay?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const RentalIntakeItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type RentalIntakeItemRequestUnitEnum =
  (typeof RentalIntakeItemRequestUnitEnum)[keyof typeof RentalIntakeItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface RentalIntakeRequest {
  id?: string | null
  createdAt?: string | null
  rentalIntakeItem: RentalIntakeItemRequest
  project?: ProjectRequest | null
  fileBucket: FileBucketRequest
  associatedRentalDispense: RentalDispenseRequest
  counterMutation?: CounterRentalIntakeRequest | null
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: RentalIntakeRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  instruction: string
}

export const RentalIntakeRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type RentalIntakeRequestFlowDirectionEnum =
  (typeof RentalIntakeRequestFlowDirectionEnum)[keyof typeof RentalIntakeRequestFlowDirectionEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface RoleServiceProviderMachine {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  machine?: Machine | null
  purchaseItem?: PurchaseItem | null
  updatedAt: string
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  roleServiceProvider?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface RoleServiceProviderMachineRequest {
  id?: string | null
  createdAt?: string | null
  machine?: MachineRequest | null
  purchaseItem?: PurchaseItemRequest | null
  sortIndex?: number
  createdBy?: string | null
  updatedBy?: string | null
  roleServiceProvider?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface Sale {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  saleItem: SaleItem
  project?: Project | null
  productionStatement?: ProductionStatement | null
  fileBucket: FileBucket
  surchargePercent: string
  surchargeFlat: string
  surchargeDescription: string
  updatedAt: string
  unitPrice?: string | null
  quantity?: string | null
  date?: string | null
  sortIndex?: number
  hasCustomUnitPrice?: boolean
  comment?: string
  /**
   * * `1` - Percentage * `2` - Vast bedrag
   */
  surchargeType?: SaleSurchargeTypeEnum | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  instruction: string
  isSurchargeFor?: string | null
  saleSurchargePeriod?: string | null
}

export const SaleSurchargeTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type SaleSurchargeTypeEnum =
  (typeof SaleSurchargeTypeEnum)[keyof typeof SaleSurchargeTypeEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface SaleItem {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: SaleItemUnitEnum
  unitPrice?: string | null
  /**
   * Modifier waarmee de brandstoftoeslag wordt vermenigvuldigd. Leeg = geen toeslag, 1 = onaangepaste toeslag.
   */
  surchargeModifier?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}

export const SaleItemUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type SaleItemUnitEnum = (typeof SaleItemUnitEnum)[keyof typeof SaleItemUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface SaleItemRequest {
  id?: string | null
  createdAt?: string | null
  name: string
  /**
   * * `1` - Stuk * `101` - Ton * `102` - Kilogram * `201` - m³ * `202` - Liter * `301` - m * `401` - Uur * `501` - m²
   */
  unit?: SaleItemRequestUnitEnum
  unitPrice?: string | null
  /**
   * Modifier waarmee de brandstoftoeslag wordt vermenigvuldigd. Leeg = geen toeslag, 1 = onaangepaste toeslag.
   */
  surchargeModifier?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

export const SaleItemRequestUnitEnum = {
  NUMBER_1: 1,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_301: 301,
  NUMBER_401: 401,
  NUMBER_501: 501
} as const

export type SaleItemRequestUnitEnum =
  (typeof SaleItemRequestUnitEnum)[keyof typeof SaleItemRequestUnitEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface SaleRequest {
  id?: string | null
  createdAt?: string | null
  saleItem: SaleItemRequest
  project?: ProjectRequest | null
  productionStatement?: ProductionStatementRequest | null
  fileBucket: FileBucketRequest
  unitPrice?: string | null
  quantity?: string | null
  date?: string | null
  sortIndex?: number
  hasCustomUnitPrice?: boolean
  comment?: string
  /**
   * * `1` - Percentage * `2` - Vast bedrag
   */
  surchargeType?: SaleRequestSurchargeTypeEnum | null
  createdBy?: string | null
  updatedBy?: string | null
  instruction: string
  isSurchargeFor?: string | null
  saleSurchargePeriod?: string | null
}

export const SaleRequestSurchargeTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type SaleRequestSurchargeTypeEnum =
  (typeof SaleRequestSurchargeTypeEnum)[keyof typeof SaleRequestSurchargeTypeEnum]

/**
 * Scheduled timing info
 */
export interface Schedule {
  date: string
  timeStart: string | null
  timeEnd: string | null
}
/**
 * Info about the service provider (driver/technician)
 */
export interface ServiceProvider {
  name: string
  phone: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ServiceProviderDate {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  serviceProvider: KnownBusinessEntityContact
  nextWeekday: string
  existsNextWeekday: boolean
  isExpanded: string
  fileBucket: FileBucket
  updatedAt: string
  date: string
  isPublished?: boolean
  purchaseTimeStart?: string | null
  purchaseTimeEnd?: string | null
  saleTimeStart?: string | null
  saleTimeEnd?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface ServiceProviderDateRequest {
  id?: string | null
  createdAt?: string | null
  serviceProvider: KnownBusinessEntityContactRequest
  fileBucket: FileBucketRequest
  date: string
  isPublished?: boolean
  purchaseTimeStart?: string | null
  purchaseTimeEnd?: string | null
  saleTimeStart?: string | null
  saleTimeEnd?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ShallowRentalDispense {
  id: string
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: ShallowRentalDispenseFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  sequenceNumber: number
  supplierComment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  fileBucket?: string
  project?: string | null
  instruction: string
  rentalDispenseItem: string
  counterMutation?: string | null
  productionStatement?: string | null
}

export const ShallowRentalDispenseFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type ShallowRentalDispenseFlowDirectionEnum =
  (typeof ShallowRentalDispenseFlowDirectionEnum)[keyof typeof ShallowRentalDispenseFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ShallowRentalDispenseRequest {
  createdAt?: string | null
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: ShallowRentalDispenseRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  sequenceNumber: number
  supplierComment?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  fileBucket?: string
  project?: string | null
  instruction: string
  rentalDispenseItem: string
  counterMutation?: string | null
  productionStatement?: string | null
}

export const ShallowRentalDispenseRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type ShallowRentalDispenseRequestFlowDirectionEnum =
  (typeof ShallowRentalDispenseRequestFlowDirectionEnum)[keyof typeof ShallowRentalDispenseRequestFlowDirectionEnum]

/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ShallowRentalIntake {
  id: string
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  updatedAt: string
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: ShallowRentalIntakeFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  sequenceNumber: number
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  fileBucket?: string
  project?: string | null
  instruction: string
  rentalIntakeItem: string
  counterMutation?: string | null
  associatedRentalDispense?: string | null
}

export const ShallowRentalIntakeFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type ShallowRentalIntakeFlowDirectionEnum =
  (typeof ShallowRentalIntakeFlowDirectionEnum)[keyof typeof ShallowRentalIntakeFlowDirectionEnum]

/**
 * Shallow representation of RentalIntakeMaterialization. Does not include rental_mutation full nested object, but annotates the key fields instead.
 */
export interface ShallowRentalIntakeMaterialization {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  rentalMutation: string
  incomingInvoiceRentalIntakeMaterializations: Array<IncomingInvoiceRentalIntakeMaterialization>
  instructionId: string
  projectExecutorFullName: string
  projectName: string
  projectExecutorFirstName: string
  projectExecutorLastName: string
  projectExecutorKnownBusinessEntityName: string
  rentalIntakeItemId: string
  rentalIntakeItemName: string
  rentalIntakeItemSupplierId: string
  rentalIntakeItemSupplierName: string
  projectId: string
  updatedAt: string
  periodStart: string
  periodEnd: string
  quantity: string
  unitPricePerDay: string
  netDayQuantity: number
  sequenceNumber: number
  invoiceReference?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Shallow representation of RentalIntakeMaterialization. Does not include rental_mutation full nested object, but annotates the key fields instead.
 */
export interface ShallowRentalIntakeMaterializationRequest {
  id?: string | null
  createdAt?: string | null
  periodStart: string
  periodEnd: string
  quantity: string
  unitPricePerDay: string
  netDayQuantity: number
  sequenceNumber: number
  invoiceReference?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * Extend UniqueFieldsMixin to remove UniqueValidator from the field validators. This is to prevent the UniqueTogetherValidator from being applied to the nested fields update.
 */
export interface ShallowRentalIntakeRequest {
  createdAt?: string | null
  /**
   * * `1` - Uitgifte * `2` - Retour
   */
  flowDirection: ShallowRentalIntakeRequestFlowDirectionEnum
  quantity?: string | null
  commencementDate?: string | null
  adminComment?: string | null
  sortIndex?: number
  sequenceNumber: number
  createdBy?: string | null
  updatedBy?: string | null
  fileBucket?: string
  project?: string | null
  instruction: string
  rentalIntakeItem: string
  counterMutation?: string | null
  associatedRentalDispense?: string | null
}

export const ShallowRentalIntakeRequestFlowDirectionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2
} as const

export type ShallowRentalIntakeRequestFlowDirectionEnum =
  (typeof ShallowRentalIntakeRequestFlowDirectionEnum)[keyof typeof ShallowRentalIntakeRequestFlowDirectionEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface Tenant {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  settingsApiKeyGoogleMaps: string
  updatedAt: string
  name: string
  sequenceNumber?: number
  createdBy?: string | null
  updatedBy?: string | null
  tenantSettings?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface TenantRequest {
  id?: string | null
  createdAt?: string | null
  name: string
  sequenceNumber?: number
  createdBy?: string | null
  updatedBy?: string | null
  tenantSettings?: string | null
}
export interface TrackingUrl {
  token: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface User {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  groups: Array<Group>
  knownBusinessEntityContact: KnownBusinessEntityContact
  activeTenant: Tenant
  userTenants: Array<UserTenant>
  fullName: string
  userSettings: UserSettings
  lastLogin?: string | null
  /**
   * Bepaalt dat deze gebruiker alle rechten heeft, zonder deze expliciet toe te wijzen.
   */
  isSuperuser?: boolean
  firstName?: string
  lastName?: string
  /**
   * Bepaalt of de gebruiker zich op deze beheerwebsite kan aanmelden.
   */
  isStaff?: boolean
  /**
   * Bepaalt of deze gebruiker als actief dient te worden behandeld. U kunt dit uitvinken in plaats van een gebruiker te verwijderen.
   */
  isActive?: boolean
  updatedAt: string
  phoneNumber?: string | null
  email?: string | null
  clerkId?: string | null
  pushTokens?: Array<any>
  /**
   * Specifieke rechten voor deze gebruiker.
   */
  userPermissions?: Array<number>
}
/**
 * Serializer for UserLocation model.
 */
export interface UserLocation {
  id?: string | null
  latitude?: number | null
  longitude?: number | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  user: string
  timestamp?: string | null
  userKbecPersonFirstName: string
  userKbecPersonLastName: string
  updatedAt: string
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  /**
   * Accuracy in meters
   */
  accuracy?: number | null
  /**
   * Speed in meters/second
   */
  speed?: number | null
  /**
   * Speed accuracy in meters/second (Android only)
   */
  speedAccuracy?: number | null
  /**
   * Heading in degrees (0-360)
   */
  heading?: number | null
  /**
   * Heading accuracy in degrees (iOS only)
   */
  headingAccuracy?: number | null
  /**
   * Altitude in meters above sea level
   */
  altitude?: number | null
  /**
   * Altitude accuracy in meters
   */
  altitudeAccuracy?: number | null
  /**
   * Altitude with respect to the WGS84 ellipsoid (Android only)
   */
  ellipsoidalAltitude?: number | null
  /**
   * Activity type: still, walking, on_foot, running, on_bicycle, in_vehicle, unknown
   */
  activityType?: string | null
  /**
   * Activity confidence (0-100)
   */
  activityConfidence?: number | null
  /**
   * Battery level (0.0 - 1.0)
   */
  batteryLevel?: number | null
  /**
   * Whether device is charging
   */
  batteryIsCharging?: boolean | null
  /**
   * Event that triggered location: motionchange, providerchange, geofence, heartbeat, etc.
   */
  event?: string | null
  /**
   * Whether device is moving
   */
  isMoving?: boolean | null
  /**
   * Distance traveled in meters
   */
  odometer?: number | null
  /**
   * Unique identifier for this location from the plugin
   */
  locationUuid?: string | null
  /**
   * Age of location in milliseconds
   */
  age?: number | null
  /**
   * Custom extras attached to location
   */
  extras?: any | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * Serializer for UserLocation model.
 */
export interface UserLocationRequest {
  id?: string | null
  latitude?: number | null
  longitude?: number | null
  createdAt?: string | null
  coords: CoordsRequest
  activity?: ActivityRequest | null
  battery?: BatteryRequest | null
  uuid?: string | null
  timestamp?: string | null
  /**
   * Geographic point (longitude, latitude)
   */
  point?: string | null
  /**
   * Accuracy in meters
   */
  accuracy?: number | null
  /**
   * Speed in meters/second
   */
  speed?: number | null
  /**
   * Speed accuracy in meters/second (Android only)
   */
  speedAccuracy?: number | null
  /**
   * Heading in degrees (0-360)
   */
  heading?: number | null
  /**
   * Heading accuracy in degrees (iOS only)
   */
  headingAccuracy?: number | null
  /**
   * Altitude in meters above sea level
   */
  altitude?: number | null
  /**
   * Altitude accuracy in meters
   */
  altitudeAccuracy?: number | null
  /**
   * Altitude with respect to the WGS84 ellipsoid (Android only)
   */
  ellipsoidalAltitude?: number | null
  /**
   * Activity type: still, walking, on_foot, running, on_bicycle, in_vehicle, unknown
   */
  activityType?: string | null
  /**
   * Activity confidence (0-100)
   */
  activityConfidence?: number | null
  /**
   * Battery level (0.0 - 1.0)
   */
  batteryLevel?: number | null
  /**
   * Whether device is charging
   */
  batteryIsCharging?: boolean | null
  /**
   * Event that triggered location: motionchange, providerchange, geofence, heartbeat, etc.
   */
  event?: string | null
  /**
   * Whether device is moving
   */
  isMoving?: boolean | null
  /**
   * Distance traveled in meters
   */
  odometer?: number | null
  /**
   * Unique identifier for this location from the plugin
   */
  locationUuid?: string | null
  /**
   * Age of location in milliseconds
   */
  age?: number | null
  /**
   * Custom extras attached to location
   */
  extras?: any | null
  createdBy?: string | null
  updatedBy?: string | null
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface UserSettings {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  layoutColumnConfigs: Array<LayoutColumnConfig>
  updatedAt: string
  windowPosX?: number
  windowPosY?: number
  /**
   * * `1` - Peanuts * `2` - Van Wageningen * `3` - Kalkman * `4` - Coolblue * `5` - Pretty Pink
   */
  theme?: UserSettingsThemeEnum
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
  relatedUser?: string | null
}

export const UserSettingsThemeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5
} as const

export type UserSettingsThemeEnum =
  (typeof UserSettingsThemeEnum)[keyof typeof UserSettingsThemeEnum]

/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface UserTenant {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  tenant: Tenant
  updatedAt: string
  createdBy?: string | null
  updatedBy?: string | null
  user: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface UserTenantRequest {
  id?: string | null
  createdAt?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  user: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface WorkPeriod {
  id?: string | null
  createdAt?: string | null
  isSaved: string
  tenantId: string
  sid: string
  owner: KnownBusinessEntityContact
  activities: Array<Activity>
  updatedAt: string
  timeStart: string
  timeEnd?: string | null
  description?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  tenant: string
}
/**
 * A serializer mixin that allows dynamic field selection via query parameters.  Usage:     GET /api/projects?fields=id,name,contact.person.full_name  This will: 1. Only serialize the requested fields 2. For nested serializers, only include the requested nested paths 3. Automatically optimize database queries
 */
export interface WorkPeriodRequest {
  id?: string | null
  createdAt?: string | null
  owner: KnownBusinessEntityContactRequest
  timeStart: string
  timeEnd?: string | null
  description?: string | null
  createdBy?: string | null
  updatedBy?: string | null
}

/**
 * AcceptInviteApi - axios parameter creator
 */
export const AcceptInviteApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} inviteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptInviteRetrieve: async (
      inviteCode: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'inviteCode' is not null or undefined
      assertParamExists("acceptInviteRetrieve", "inviteCode", inviteCode)
      const localVarPath = `/auth/accept-invite/{inviteCode}/`.replace(
        `{${"inviteCode"}}`,
        encodeURIComponent(String(inviteCode))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AcceptInviteApi - functional programming interface
 */
export const AcceptInviteApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AcceptInviteApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} inviteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptInviteRetrieve(
      inviteCode: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInviteRetrieve(
        inviteCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AcceptInviteApi.acceptInviteRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AcceptInviteApi - factory interface
 */
export const AcceptInviteApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AcceptInviteApiFp(configuration)
  return {
    /**
     *
     * @param {string} inviteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptInviteRetrieve(inviteCode: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .acceptInviteRetrieve(inviteCode, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AcceptInviteApi - object-oriented interface
 */
export class AcceptInviteApi extends BaseAPI {
  /**
   *
   * @param {string} inviteCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public acceptInviteRetrieve(inviteCode: string, options?: RawAxiosRequestConfig) {
    return AcceptInviteApiFp(this.configuration)
      .acceptInviteRetrieve(inviteCode, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ActiveServiceProvidersApi - axios parameter creator
 */
export const ActiveServiceProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsBulkCreateCreate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists(
        "activeServiceProvidersUserLocationsBulkCreateCreate",
        "userLocationRequest",
        userLocationRequest
      )
      const localVarPath = `/auth/active-service-providers/user-locations/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsBulkDeleteCreate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists(
        "activeServiceProvidersUserLocationsBulkDeleteCreate",
        "userLocationRequest",
        userLocationRequest
      )
      const localVarPath = `/auth/active-service-providers/user-locations/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsBulkUpdateUpdate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists(
        "activeServiceProvidersUserLocationsBulkUpdateUpdate",
        "userLocationRequest",
        userLocationRequest
      )
      const localVarPath = `/auth/active-service-providers/user-locations/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsCreate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists(
        "activeServiceProvidersUserLocationsCreate",
        "userLocationRequest",
        userLocationRequest
      )
      const localVarPath = `/auth/active-service-providers/user-locations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activeServiceProvidersUserLocationsDestroy", "id", id)
      const localVarPath = `/auth/active-service-providers/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsList: async (
      $skip?: number,
      $top?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/active-service-providers/user-locations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsPartialUpdate: async (
      id: string,
      patchedUserLocationRequest?: PatchedUserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activeServiceProvidersUserLocationsPartialUpdate", "id", id)
      const localVarPath = `/auth/active-service-providers/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedUserLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activeServiceProvidersUserLocationsRetrieve", "id", id)
      const localVarPath = `/auth/active-service-providers/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsUpdate: async (
      id: string,
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activeServiceProvidersUserLocationsUpdate", "id", id)
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists(
        "activeServiceProvidersUserLocationsUpdate",
        "userLocationRequest",
        userLocationRequest
      )
      const localVarPath = `/auth/active-service-providers/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ActiveServiceProvidersApi - functional programming interface
 */
export const ActiveServiceProvidersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ActiveServiceProvidersApiAxiosParamCreator(configuration)
  return {
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsBulkCreateCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsBulkCreateCreate(
          userLocationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ActiveServiceProvidersApi.activeServiceProvidersUserLocationsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsBulkDeleteCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsBulkDeleteCreate(
          userLocationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ActiveServiceProvidersApi.activeServiceProvidersUserLocationsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsBulkUpdateUpdate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsBulkUpdateUpdate(
          userLocationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ActiveServiceProvidersApi.activeServiceProvidersUserLocationsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsCreate(
          userLocationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActiveServiceProvidersApi.activeServiceProvidersUserLocationsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ActiveServiceProvidersApi.activeServiceProvidersUserLocationsDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUserLocationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsList(
          $skip,
          $top,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActiveServiceProvidersApi.activeServiceProvidersUserLocationsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsPartialUpdate(
      id: string,
      patchedUserLocationRequest?: PatchedUserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsPartialUpdate(
          id,
          patchedUserLocationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ActiveServiceProvidersApi.activeServiceProvidersUserLocationsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ActiveServiceProvidersApi.activeServiceProvidersUserLocationsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeServiceProvidersUserLocationsUpdate(
      id: string,
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activeServiceProvidersUserLocationsUpdate(
          id,
          userLocationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActiveServiceProvidersApi.activeServiceProvidersUserLocationsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ActiveServiceProvidersApi - factory interface
 */
export const ActiveServiceProvidersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ActiveServiceProvidersApiFp(configuration)
  return {
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsBulkCreateCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .activeServiceProvidersUserLocationsBulkCreateCreate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsBulkDeleteCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .activeServiceProvidersUserLocationsBulkDeleteCreate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsBulkUpdateUpdate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .activeServiceProvidersUserLocationsBulkUpdateUpdate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .activeServiceProvidersUserLocationsCreate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .activeServiceProvidersUserLocationsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedUserLocationList> {
      return localVarFp
        .activeServiceProvidersUserLocationsList($skip, $top, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsPartialUpdate(
      id: string,
      patchedUserLocationRequest?: PatchedUserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .activeServiceProvidersUserLocationsPartialUpdate(id, patchedUserLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .activeServiceProvidersUserLocationsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeServiceProvidersUserLocationsUpdate(
      id: string,
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .activeServiceProvidersUserLocationsUpdate(id, userLocationRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ActiveServiceProvidersApi - object-oriented interface
 */
export class ActiveServiceProvidersApi extends BaseAPI {
  /**
   * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsBulkCreateCreate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsBulkCreateCreate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsBulkDeleteCreate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsBulkDeleteCreate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get the last X locations for all KnownBusinessEntityContacts that have an active WorkPeriod. An active WorkPeriod is one where time_end is null.  Query params:     - limit: Number of locations per user (default: 1)
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsBulkUpdateUpdate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsBulkUpdateUpdate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsCreate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsCreate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsList(
    $skip?: number,
    $top?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsList($skip, $top, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsPartialUpdate(
    id: string,
    patchedUserLocationRequest?: PatchedUserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsPartialUpdate(id, patchedUserLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activeServiceProvidersUserLocationsUpdate(
    id: string,
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActiveServiceProvidersApiFp(this.configuration)
      .activeServiceProvidersUserLocationsUpdate(id, userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ActivitiesApi - axios parameter creator
 */
export const ActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesBulkCreateCreate: async (
      activityRequest: ActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'activityRequest' is not null or undefined
      assertParamExists("activitiesBulkCreateCreate", "activityRequest", activityRequest)
      const localVarPath = `/administration/activities/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        activityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesBulkDeleteCreate: async (
      activityRequest: ActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'activityRequest' is not null or undefined
      assertParamExists("activitiesBulkDeleteCreate", "activityRequest", activityRequest)
      const localVarPath = `/administration/activities/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        activityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesBulkUpdateUpdate: async (
      activityRequest: ActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'activityRequest' is not null or undefined
      assertParamExists("activitiesBulkUpdateUpdate", "activityRequest", activityRequest)
      const localVarPath = `/administration/activities/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        activityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesCreate: async (
      activityRequest: ActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'activityRequest' is not null or undefined
      assertParamExists("activitiesCreate", "activityRequest", activityRequest)
      const localVarPath = `/administration/activities/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        activityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activitiesDestroy", "id", id)
      const localVarPath = `/administration/activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/activities/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this activity.
     * @param {PatchedActivityRequest} [patchedActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesPartialUpdate: async (
      id: string,
      patchedActivityRequest?: PatchedActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activitiesPartialUpdate", "id", id)
      const localVarPath = `/administration/activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activitiesRetrieve", "id", id)
      const localVarPath = `/administration/activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this activity.
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesUpdate: async (
      id: string,
      activityRequest: ActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("activitiesUpdate", "id", id)
      // verify required parameter 'activityRequest' is not null or undefined
      assertParamExists("activitiesUpdate", "activityRequest", activityRequest)
      const localVarPath = `/administration/activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        activityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ActivitiesApi - functional programming interface
 */
export const ActivitiesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ActivitiesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesBulkCreateCreate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesBulkCreateCreate(
        activityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesBulkDeleteCreate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesBulkDeleteCreate(
        activityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesBulkUpdateUpdate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesBulkUpdateUpdate(
        activityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesCreate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesCreate(
        activityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedActivityList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this activity.
     * @param {PatchedActivityRequest} [patchedActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesPartialUpdate(
      id: string,
      patchedActivityRequest?: PatchedActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesPartialUpdate(
        id,
        patchedActivityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesPartialUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this activity.
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activitiesUpdate(
      id: string,
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activitiesUpdate(
        id,
        activityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ActivitiesApi.activitiesUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ActivitiesApi - factory interface
 */
export const ActivitiesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ActivitiesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesBulkCreateCreate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Activity> {
      return localVarFp
        .activitiesBulkCreateCreate(activityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesBulkDeleteCreate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Activity> {
      return localVarFp
        .activitiesBulkDeleteCreate(activityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesBulkUpdateUpdate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Activity> {
      return localVarFp
        .activitiesBulkUpdateUpdate(activityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesCreate(
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Activity> {
      return localVarFp
        .activitiesCreate(activityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.activitiesDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedActivityList> {
      return localVarFp
        .activitiesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this activity.
     * @param {PatchedActivityRequest} [patchedActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesPartialUpdate(
      id: string,
      patchedActivityRequest?: PatchedActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Activity> {
      return localVarFp
        .activitiesPartialUpdate(id, patchedActivityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Activity> {
      return localVarFp.activitiesRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this activity.
     * @param {ActivityRequest} activityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesUpdate(
      id: string,
      activityRequest: ActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Activity> {
      return localVarFp
        .activitiesUpdate(id, activityRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ActivitiesApi - object-oriented interface
 */
export class ActivitiesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ActivityRequest} activityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesBulkCreateCreate(
    activityRequest: ActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActivitiesApiFp(this.configuration)
      .activitiesBulkCreateCreate(activityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ActivityRequest} activityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesBulkDeleteCreate(
    activityRequest: ActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActivitiesApiFp(this.configuration)
      .activitiesBulkDeleteCreate(activityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ActivityRequest} activityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesBulkUpdateUpdate(
    activityRequest: ActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActivitiesApiFp(this.configuration)
      .activitiesBulkUpdateUpdate(activityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ActivityRequest} activityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesCreate(activityRequest: ActivityRequest, options?: RawAxiosRequestConfig) {
    return ActivitiesApiFp(this.configuration)
      .activitiesCreate(activityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this activity.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ActivitiesApiFp(this.configuration)
      .activitiesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ActivitiesApiFp(this.configuration)
      .activitiesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this activity.
   * @param {PatchedActivityRequest} [patchedActivityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesPartialUpdate(
    id: string,
    patchedActivityRequest?: PatchedActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActivitiesApiFp(this.configuration)
      .activitiesPartialUpdate(id, patchedActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this activity.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ActivitiesApiFp(this.configuration)
      .activitiesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this activity.
   * @param {ActivityRequest} activityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public activitiesUpdate(
    id: string,
    activityRequest: ActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ActivitiesApiFp(this.configuration)
      .activitiesUpdate(id, activityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminApi - axios parameter creator
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDailyMetricsCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/administration/admin/daily-metrics/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDailyMetricsRetrieve: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/admin/daily-metrics/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminRentalCalculationCreate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/admin/rental-calculation/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminRentalCalculationRetrieve: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/admin/rental-calculation/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminApi - functional programming interface
 */
export const AdminApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminDailyMetricsCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adminDailyMetricsCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.adminDailyMetricsCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminDailyMetricsRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adminDailyMetricsRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.adminDailyMetricsRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminRentalCalculationCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.adminRentalCalculationCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.adminRentalCalculationCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminRentalCalculationRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.adminRentalCalculationRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.adminRentalCalculationRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminApi - factory interface
 */
export const AdminApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDailyMetricsCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.adminDailyMetricsCreate(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDailyMetricsRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .adminDailyMetricsRetrieve(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminRentalCalculationCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .adminRentalCalculationCreate(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminRentalCalculationRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .adminRentalCalculationRetrieve(options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminApi - object-oriented interface
 */
export class AdminApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public adminDailyMetricsCreate(options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .adminDailyMetricsCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public adminDailyMetricsRetrieve(options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .adminDailyMetricsRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public adminRentalCalculationCreate(options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .adminRentalCalculationCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public adminRentalCalculationRetrieve(options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .adminRentalCalculationRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AuthenticationApi - axios parameter creator
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Registers a push notification token for the current user
     * @summary Add push notification token
     * @param {AddTokenCreateRequest} [addTokenCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTokenCreate: async (
      addTokenCreateRequest?: AddTokenCreateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/add-token/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addTokenCreateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns the currently authenticated user\'s information including tenant associations.
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentUserRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/current-user/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AuthenticationApi - functional programming interface
 */
export const AuthenticationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
  return {
    /**
     * Registers a push notification token for the current user
     * @summary Add push notification token
     * @param {AddTokenCreateRequest} [addTokenCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addTokenCreate(
      addTokenCreateRequest?: AddTokenCreateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addTokenCreate(
        addTokenCreateRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AuthenticationApi.addTokenCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Returns the currently authenticated user\'s information including tenant associations.
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currentUserRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.currentUserRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AuthenticationApi.currentUserRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AuthenticationApi - factory interface
 */
export const AuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthenticationApiFp(configuration)
  return {
    /**
     * Registers a push notification token for the current user
     * @summary Add push notification token
     * @param {AddTokenCreateRequest} [addTokenCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTokenCreate(
      addTokenCreateRequest?: AddTokenCreateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .addTokenCreate(addTokenCreateRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns the currently authenticated user\'s information including tenant associations.
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentUserRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<User> {
      return localVarFp.currentUserRetrieve(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * AuthenticationApi - object-oriented interface
 */
export class AuthenticationApi extends BaseAPI {
  /**
   * Registers a push notification token for the current user
   * @summary Add push notification token
   * @param {AddTokenCreateRequest} [addTokenCreateRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addTokenCreate(
    addTokenCreateRequest?: AddTokenCreateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .addTokenCreate(addTokenCreateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns the currently authenticated user\'s information including tenant associations.
   * @summary Get current user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public currentUserRetrieve(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .currentUserRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CurrentUserApi - axios parameter creator
 */
export const CurrentUserApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Update the current user\'s location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentUserLocationCreate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/current-user/location/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * CurrentUserApi - functional programming interface
 */
export const CurrentUserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CurrentUserApiAxiosParamCreator(configuration)
  return {
    /**
     * Update the current user\'s location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currentUserLocationCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.currentUserLocationCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CurrentUserApi.currentUserLocationCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * CurrentUserApi - factory interface
 */
export const CurrentUserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CurrentUserApiFp(configuration)
  return {
    /**
     * Update the current user\'s location.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentUserLocationCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .currentUserLocationCreate(options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * CurrentUserApi - object-oriented interface
 */
export class CurrentUserApi extends BaseAPI {
  /**
   * Update the current user\'s location.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public currentUserLocationCreate(options?: RawAxiosRequestConfig) {
    return CurrentUserApiFp(this.configuration)
      .currentUserLocationCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FileBucketsApi - axios parameter creator
 */
export const FileBucketsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Create a new FileRelation for the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileBucketsFileRelationsCreate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("fileBucketsFileRelationsCreate", "id", id)
      const localVarPath = `/core/file-buckets/{id}/file-relations/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Upload a file, and add a new FileRelation to the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileBucketsUploadCreate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("fileBucketsUploadCreate", "id", id)
      const localVarPath = `/core/file-buckets/{id}/upload/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FileBucketsApi - functional programming interface
 */
export const FileBucketsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FileBucketsApiAxiosParamCreator(configuration)
  return {
    /**
     * Create a new FileRelation for the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fileBucketsFileRelationsCreate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fileBucketsFileRelationsCreate(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FileBucketsApi.fileBucketsFileRelationsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Upload a file, and add a new FileRelation to the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fileBucketsUploadCreate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fileBucketsUploadCreate(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FileBucketsApi.fileBucketsUploadCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * FileBucketsApi - factory interface
 */
export const FileBucketsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FileBucketsApiFp(configuration)
  return {
    /**
     * Create a new FileRelation for the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileBucketsFileRelationsCreate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .fileBucketsFileRelationsCreate(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Upload a file, and add a new FileRelation to the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileBucketsUploadCreate(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .fileBucketsUploadCreate(id, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * FileBucketsApi - object-oriented interface
 */
export class FileBucketsApi extends BaseAPI {
  /**
   * Create a new FileRelation for the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public fileBucketsFileRelationsCreate(id: string, options?: RawAxiosRequestConfig) {
    return FileBucketsApiFp(this.configuration)
      .fileBucketsFileRelationsCreate(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Upload a file, and add a new FileRelation to the given FileBucket. If the FileBucket does not exist yet, the FileRelation will be associated to the FileBucket as soon as the FileBucket is created.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public fileBucketsUploadCreate(id: string, options?: RawAxiosRequestConfig) {
    return FileBucketsApiFp(this.configuration)
      .fileBucketsUploadCreate(id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FileRelationsApi - axios parameter creator
 */
export const FileRelationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileRelationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("fileRelationsDestroy", "id", id)
      const localVarPath = `/core/file-relations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FileRelationsApi - functional programming interface
 */
export const FileRelationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FileRelationsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fileRelationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fileRelationsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FileRelationsApi.fileRelationsDestroy"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * FileRelationsApi - factory interface
 */
export const FileRelationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FileRelationsApiFp(configuration)
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileRelationsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .fileRelationsDestroy(id, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * FileRelationsApi - object-oriented interface
 */
export class FileRelationsApi extends BaseAPI {
  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public fileRelationsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return FileRelationsApiFp(this.configuration)
      .fileRelationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FilesApi - axios parameter creator
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/core/files/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesModifyUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("filesModifyUpdate", "id", id)
      const localVarPath = `/core/files/{id}/modify/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesRotateUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("filesRotateUpdate", "id", id)
      const localVarPath = `/core/files/{id}/rotate/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FilesApi - functional programming interface
 */
export const FilesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async filesCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.filesCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FilesApi.filesCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async filesModifyUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.filesModifyUpdate(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FilesApi.filesModifyUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async filesRotateUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.filesRotateUpdate(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FilesApi.filesRotateUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * FilesApi - factory interface
 */
export const FilesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FilesApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.filesCreate(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesModifyUpdate(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.filesModifyUpdate(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesRotateUpdate(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.filesRotateUpdate(id, options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * FilesApi - object-oriented interface
 */
export class FilesApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public filesCreate(options?: RawAxiosRequestConfig) {
    return FilesApiFp(this.configuration)
      .filesCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public filesModifyUpdate(id: string, options?: RawAxiosRequestConfig) {
    return FilesApiFp(this.configuration)
      .filesModifyUpdate(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public filesRotateUpdate(id: string, options?: RawAxiosRequestConfig) {
    return FilesApiFp(this.configuration)
      .filesRotateUpdate(id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * HolidaysApi - axios parameter creator
 */
export const HolidaysApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysBulkCreateCreate: async (
      holidayRequest: HolidayRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'holidayRequest' is not null or undefined
      assertParamExists("holidaysBulkCreateCreate", "holidayRequest", holidayRequest)
      const localVarPath = `/planning/holidays/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        holidayRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysBulkDeleteCreate: async (
      holidayRequest: HolidayRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'holidayRequest' is not null or undefined
      assertParamExists("holidaysBulkDeleteCreate", "holidayRequest", holidayRequest)
      const localVarPath = `/planning/holidays/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        holidayRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysBulkUpdateUpdate: async (
      holidayRequest: HolidayRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'holidayRequest' is not null or undefined
      assertParamExists("holidaysBulkUpdateUpdate", "holidayRequest", holidayRequest)
      const localVarPath = `/planning/holidays/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        holidayRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysCreate: async (
      holidayRequest: HolidayRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'holidayRequest' is not null or undefined
      assertParamExists("holidaysCreate", "holidayRequest", holidayRequest)
      const localVarPath = `/planning/holidays/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        holidayRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("holidaysDestroy", "id", id)
      const localVarPath = `/planning/holidays/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/holidays/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {PatchedHolidayRequest} [patchedHolidayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysPartialUpdate: async (
      id: string,
      patchedHolidayRequest?: PatchedHolidayRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("holidaysPartialUpdate", "id", id)
      const localVarPath = `/planning/holidays/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedHolidayRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("holidaysRetrieve", "id", id)
      const localVarPath = `/planning/holidays/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysUpdate: async (
      id: string,
      holidayRequest: HolidayRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("holidaysUpdate", "id", id)
      // verify required parameter 'holidayRequest' is not null or undefined
      assertParamExists("holidaysUpdate", "holidayRequest", holidayRequest)
      const localVarPath = `/planning/holidays/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        holidayRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * HolidaysApi - functional programming interface
 */
export const HolidaysApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HolidaysApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysBulkCreateCreate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysBulkCreateCreate(
        holidayRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysBulkDeleteCreate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysBulkDeleteCreate(
        holidayRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysBulkUpdateUpdate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysBulkUpdateUpdate(
        holidayRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysCreate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysCreate(
        holidayRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedHolidayList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {PatchedHolidayRequest} [patchedHolidayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysPartialUpdate(
      id: string,
      patchedHolidayRequest?: PatchedHolidayRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysPartialUpdate(
        id,
        patchedHolidayRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysPartialUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async holidaysUpdate(
      id: string,
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.holidaysUpdate(
        id,
        holidayRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolidaysApi.holidaysUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * HolidaysApi - factory interface
 */
export const HolidaysApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HolidaysApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysBulkCreateCreate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Holiday> {
      return localVarFp
        .holidaysBulkCreateCreate(holidayRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysBulkDeleteCreate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Holiday> {
      return localVarFp
        .holidaysBulkDeleteCreate(holidayRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysBulkUpdateUpdate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Holiday> {
      return localVarFp
        .holidaysBulkUpdateUpdate(holidayRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysCreate(
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Holiday> {
      return localVarFp
        .holidaysCreate(holidayRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.holidaysDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedHolidayList> {
      return localVarFp
        .holidaysList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {PatchedHolidayRequest} [patchedHolidayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysPartialUpdate(
      id: string,
      patchedHolidayRequest?: PatchedHolidayRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Holiday> {
      return localVarFp
        .holidaysPartialUpdate(id, patchedHolidayRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Holiday> {
      return localVarFp.holidaysRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this feestdag.
     * @param {HolidayRequest} holidayRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    holidaysUpdate(
      id: string,
      holidayRequest: HolidayRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Holiday> {
      return localVarFp
        .holidaysUpdate(id, holidayRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * HolidaysApi - object-oriented interface
 */
export class HolidaysApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {HolidayRequest} holidayRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysBulkCreateCreate(holidayRequest: HolidayRequest, options?: RawAxiosRequestConfig) {
    return HolidaysApiFp(this.configuration)
      .holidaysBulkCreateCreate(holidayRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {HolidayRequest} holidayRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysBulkDeleteCreate(holidayRequest: HolidayRequest, options?: RawAxiosRequestConfig) {
    return HolidaysApiFp(this.configuration)
      .holidaysBulkDeleteCreate(holidayRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {HolidayRequest} holidayRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysBulkUpdateUpdate(holidayRequest: HolidayRequest, options?: RawAxiosRequestConfig) {
    return HolidaysApiFp(this.configuration)
      .holidaysBulkUpdateUpdate(holidayRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {HolidayRequest} holidayRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysCreate(holidayRequest: HolidayRequest, options?: RawAxiosRequestConfig) {
    return HolidaysApiFp(this.configuration)
      .holidaysCreate(holidayRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this feestdag.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysDestroy(id: string, options?: RawAxiosRequestConfig) {
    return HolidaysApiFp(this.configuration)
      .holidaysDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return HolidaysApiFp(this.configuration)
      .holidaysList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this feestdag.
   * @param {PatchedHolidayRequest} [patchedHolidayRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysPartialUpdate(
    id: string,
    patchedHolidayRequest?: PatchedHolidayRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HolidaysApiFp(this.configuration)
      .holidaysPartialUpdate(id, patchedHolidayRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this feestdag.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return HolidaysApiFp(this.configuration)
      .holidaysRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this feestdag.
   * @param {HolidayRequest} holidayRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public holidaysUpdate(
    id: string,
    holidayRequest: HolidayRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HolidaysApiFp(this.configuration)
      .holidaysUpdate(id, holidayRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * HtApi - axios parameter creator
 */
export const HtApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Handle GET requests for health check and return JSON response. Performs a simple database query to verify connectivity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    htApiRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/core/ht/api/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * HtApi - functional programming interface
 */
export const HtApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HtApiAxiosParamCreator(configuration)
  return {
    /**
     * Handle GET requests for health check and return JSON response. Performs a simple database query to verify connectivity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async htApiRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.htApiRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HtApi.htApiRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * HtApi - factory interface
 */
export const HtApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HtApiFp(configuration)
  return {
    /**
     * Handle GET requests for health check and return JSON response. Performs a simple database query to verify connectivity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    htApiRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.htApiRetrieve(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * HtApi - object-oriented interface
 */
export class HtApi extends BaseAPI {
  /**
   * Handle GET requests for health check and return JSON response. Performs a simple database query to verify connectivity.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public htApiRetrieve(options?: RawAxiosRequestConfig) {
    return HtApiFp(this.configuration)
      .htApiRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * IncomingInvoicesApi - axios parameter creator
 */
export const IncomingInvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesBulkCreateCreate: async (
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesBulkCreateCreate",
        "incomingInvoiceRequest",
        incomingInvoiceRequest
      )
      const localVarPath = `/administration/incoming-invoices/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesBulkDeleteCreate: async (
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesBulkDeleteCreate",
        "incomingInvoiceRequest",
        incomingInvoiceRequest
      )
      const localVarPath = `/administration/incoming-invoices/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesBulkUpdateUpdate: async (
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesBulkUpdateUpdate",
        "incomingInvoiceRequest",
        incomingInvoiceRequest
      )
      const localVarPath = `/administration/incoming-invoices/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesCreate: async (
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRequest' is not null or undefined
      assertParamExists("incomingInvoicesCreate", "incomingInvoiceRequest", incomingInvoiceRequest)
      const localVarPath = `/administration/incoming-invoices/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesDestroy", "id", id)
      const localVarPath = `/administration/incoming-invoices/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesList: async (
      $skip?: number,
      $top?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/incoming-invoices/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {PatchedIncomingInvoiceRequest} [patchedIncomingInvoiceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPartialUpdate: async (
      id: string,
      patchedIncomingInvoiceRequest?: PatchedIncomingInvoiceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesPartialUpdate", "id", id)
      const localVarPath = `/administration/incoming-invoices/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedIncomingInvoiceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesRetrieve", "id", id)
      const localVarPath = `/administration/incoming-invoices/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Wraps the base update to detect status transitions and send to SnelStart.
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesUpdate: async (
      id: string,
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesUpdate", "id", id)
      // verify required parameter 'incomingInvoiceRequest' is not null or undefined
      assertParamExists("incomingInvoicesUpdate", "incomingInvoiceRequest", incomingInvoiceRequest)
      const localVarPath = `/administration/incoming-invoices/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * IncomingInvoicesApi - functional programming interface
 */
export const IncomingInvoicesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IncomingInvoicesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesBulkCreateCreate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesBulkCreateCreate(
        incomingInvoiceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesBulkDeleteCreate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesBulkDeleteCreate(
        incomingInvoiceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesBulkUpdateUpdate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesBulkUpdateUpdate(
        incomingInvoiceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesCreate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesCreate(
        incomingInvoiceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedIncomingInvoiceList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesList(
        $skip,
        $top,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {PatchedIncomingInvoiceRequest} [patchedIncomingInvoiceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPartialUpdate(
      id: string,
      patchedIncomingInvoiceRequest?: PatchedIncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesPartialUpdate(
        id,
        patchedIncomingInvoiceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Wraps the base update to detect status transitions and send to SnelStart.
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesUpdate(
      id: string,
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesUpdate(
        id,
        incomingInvoiceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesApi.incomingInvoicesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * IncomingInvoicesApi - factory interface
 */
export const IncomingInvoicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = IncomingInvoicesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesBulkCreateCreate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoice> {
      return localVarFp
        .incomingInvoicesBulkCreateCreate(incomingInvoiceRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesBulkDeleteCreate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoice> {
      return localVarFp
        .incomingInvoicesBulkDeleteCreate(incomingInvoiceRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesBulkUpdateUpdate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoice> {
      return localVarFp
        .incomingInvoicesBulkUpdateUpdate(incomingInvoiceRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesCreate(
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoice> {
      return localVarFp
        .incomingInvoicesCreate(incomingInvoiceRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .incomingInvoicesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedIncomingInvoiceList> {
      return localVarFp
        .incomingInvoicesList($skip, $top, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {PatchedIncomingInvoiceRequest} [patchedIncomingInvoiceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPartialUpdate(
      id: string,
      patchedIncomingInvoiceRequest?: PatchedIncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoice> {
      return localVarFp
        .incomingInvoicesPartialUpdate(id, patchedIncomingInvoiceRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoice> {
      return localVarFp
        .incomingInvoicesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Wraps the base update to detect status transitions and send to SnelStart.
     * @param {string} id A UUID string identifying this Inkoopfactuur.
     * @param {IncomingInvoiceRequest} incomingInvoiceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesUpdate(
      id: string,
      incomingInvoiceRequest: IncomingInvoiceRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoice> {
      return localVarFp
        .incomingInvoicesUpdate(id, incomingInvoiceRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * IncomingInvoicesApi - object-oriented interface
 */
export class IncomingInvoicesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoiceRequest} incomingInvoiceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesBulkCreateCreate(
    incomingInvoiceRequest: IncomingInvoiceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesBulkCreateCreate(incomingInvoiceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoiceRequest} incomingInvoiceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesBulkDeleteCreate(
    incomingInvoiceRequest: IncomingInvoiceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesBulkDeleteCreate(incomingInvoiceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoiceRequest} incomingInvoiceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesBulkUpdateUpdate(
    incomingInvoiceRequest: IncomingInvoiceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesBulkUpdateUpdate(incomingInvoiceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {IncomingInvoiceRequest} incomingInvoiceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesCreate(
    incomingInvoiceRequest: IncomingInvoiceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesCreate(incomingInvoiceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesList($skip?: number, $top?: number, options?: RawAxiosRequestConfig) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesList($skip, $top, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur.
   * @param {PatchedIncomingInvoiceRequest} [patchedIncomingInvoiceRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPartialUpdate(
    id: string,
    patchedIncomingInvoiceRequest?: PatchedIncomingInvoiceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesPartialUpdate(id, patchedIncomingInvoiceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Wraps the base update to detect status transitions and send to SnelStart.
   * @param {string} id A UUID string identifying this Inkoopfactuur.
   * @param {IncomingInvoiceRequest} incomingInvoiceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesUpdate(
    id: string,
    incomingInvoiceRequest: IncomingInvoiceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesApiFp(this.configuration)
      .incomingInvoicesUpdate(id, incomingInvoiceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * IncomingInvoicesPurchasesApi - axios parameter creator
 */
export const IncomingInvoicesPurchasesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesBulkCreateCreate: async (
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoicePurchaseRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesPurchasesBulkCreateCreate",
        "incomingInvoicePurchaseRequest",
        incomingInvoicePurchaseRequest
      )
      const localVarPath = `/administration/incoming-invoices-purchases/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoicePurchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesBulkDeleteCreate: async (
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoicePurchaseRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesPurchasesBulkDeleteCreate",
        "incomingInvoicePurchaseRequest",
        incomingInvoicePurchaseRequest
      )
      const localVarPath = `/administration/incoming-invoices-purchases/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoicePurchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesBulkUpdateUpdate: async (
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoicePurchaseRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesPurchasesBulkUpdateUpdate",
        "incomingInvoicePurchaseRequest",
        incomingInvoicePurchaseRequest
      )
      const localVarPath = `/administration/incoming-invoices-purchases/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoicePurchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesCreate: async (
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoicePurchaseRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesPurchasesCreate",
        "incomingInvoicePurchaseRequest",
        incomingInvoicePurchaseRequest
      )
      const localVarPath = `/administration/incoming-invoices-purchases/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoicePurchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesPurchasesDestroy", "id", id)
      const localVarPath = `/administration/incoming-invoices-purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/incoming-invoices-purchases/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {PatchedIncomingInvoicePurchaseRequest} [patchedIncomingInvoicePurchaseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesPartialUpdate: async (
      id: string,
      patchedIncomingInvoicePurchaseRequest?: PatchedIncomingInvoicePurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesPurchasesPartialUpdate", "id", id)
      const localVarPath = `/administration/incoming-invoices-purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedIncomingInvoicePurchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesPurchasesRetrieve", "id", id)
      const localVarPath = `/administration/incoming-invoices-purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesUpdate: async (
      id: string,
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesPurchasesUpdate", "id", id)
      // verify required parameter 'incomingInvoicePurchaseRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesPurchasesUpdate",
        "incomingInvoicePurchaseRequest",
        incomingInvoicePurchaseRequest
      )
      const localVarPath = `/administration/incoming-invoices-purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoicePurchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * IncomingInvoicesPurchasesApi - functional programming interface
 */
export const IncomingInvoicesPurchasesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IncomingInvoicesPurchasesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesBulkCreateCreate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoicePurchase>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesPurchasesBulkCreateCreate(
          incomingInvoicePurchaseRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesBulkDeleteCreate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoicePurchase>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesPurchasesBulkDeleteCreate(
          incomingInvoicePurchaseRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesBulkUpdateUpdate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoicePurchase>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesPurchasesBulkUpdateUpdate(
          incomingInvoicePurchaseRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesCreate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoicePurchase>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesPurchasesCreate(
        incomingInvoicePurchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesPurchasesDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedIncomingInvoicePurchaseList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesPurchasesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {PatchedIncomingInvoicePurchaseRequest} [patchedIncomingInvoicePurchaseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesPartialUpdate(
      id: string,
      patchedIncomingInvoicePurchaseRequest?: PatchedIncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoicePurchase>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesPurchasesPartialUpdate(
          id,
          patchedIncomingInvoicePurchaseRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoicePurchase>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesPurchasesRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesPurchasesUpdate(
      id: string,
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoicePurchase>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.incomingInvoicesPurchasesUpdate(
        id,
        incomingInvoicePurchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["IncomingInvoicesPurchasesApi.incomingInvoicesPurchasesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * IncomingInvoicesPurchasesApi - factory interface
 */
export const IncomingInvoicesPurchasesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = IncomingInvoicesPurchasesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesBulkCreateCreate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoicePurchase> {
      return localVarFp
        .incomingInvoicesPurchasesBulkCreateCreate(incomingInvoicePurchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesBulkDeleteCreate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoicePurchase> {
      return localVarFp
        .incomingInvoicesPurchasesBulkDeleteCreate(incomingInvoicePurchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesBulkUpdateUpdate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoicePurchase> {
      return localVarFp
        .incomingInvoicesPurchasesBulkUpdateUpdate(incomingInvoicePurchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesCreate(
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoicePurchase> {
      return localVarFp
        .incomingInvoicesPurchasesCreate(incomingInvoicePurchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .incomingInvoicesPurchasesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedIncomingInvoicePurchaseList> {
      return localVarFp
        .incomingInvoicesPurchasesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {PatchedIncomingInvoicePurchaseRequest} [patchedIncomingInvoicePurchaseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesPartialUpdate(
      id: string,
      patchedIncomingInvoicePurchaseRequest?: PatchedIncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoicePurchase> {
      return localVarFp
        .incomingInvoicesPurchasesPartialUpdate(id, patchedIncomingInvoicePurchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoicePurchase> {
      return localVarFp
        .incomingInvoicesPurchasesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
     * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesPurchasesUpdate(
      id: string,
      incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoicePurchase> {
      return localVarFp
        .incomingInvoicesPurchasesUpdate(id, incomingInvoicePurchaseRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * IncomingInvoicesPurchasesApi - object-oriented interface
 */
export class IncomingInvoicesPurchasesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesBulkCreateCreate(
    incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesBulkCreateCreate(incomingInvoicePurchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesBulkDeleteCreate(
    incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesBulkDeleteCreate(incomingInvoicePurchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesBulkUpdateUpdate(
    incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesBulkUpdateUpdate(incomingInvoicePurchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesCreate(
    incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesCreate(incomingInvoicePurchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
   * @param {PatchedIncomingInvoicePurchaseRequest} [patchedIncomingInvoicePurchaseRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesPartialUpdate(
    id: string,
    patchedIncomingInvoicePurchaseRequest?: PatchedIncomingInvoicePurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesPartialUpdate(id, patchedIncomingInvoicePurchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inkoop.
   * @param {IncomingInvoicePurchaseRequest} incomingInvoicePurchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesPurchasesUpdate(
    id: string,
    incomingInvoicePurchaseRequest: IncomingInvoicePurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesPurchasesApiFp(this.configuration)
      .incomingInvoicesPurchasesUpdate(id, incomingInvoicePurchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * IncomingInvoicesRentalIntakeMaterializationsApi - axios parameter creator
 */
export const IncomingInvoicesRentalIntakeMaterializationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate: async (
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate",
        "incomingInvoiceRentalIntakeMaterializationRequest",
        incomingInvoiceRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/incoming-invoices-rental-intake-materializations/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate: async (
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate",
        "incomingInvoiceRentalIntakeMaterializationRequest",
        incomingInvoiceRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/incoming-invoices-rental-intake-materializations/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate: async (
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate",
        "incomingInvoiceRentalIntakeMaterializationRequest",
        incomingInvoiceRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/incoming-invoices-rental-intake-materializations/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsCreate: async (
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incomingInvoiceRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesRentalIntakeMaterializationsCreate",
        "incomingInvoiceRentalIntakeMaterializationRequest",
        incomingInvoiceRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/incoming-invoices-rental-intake-materializations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesRentalIntakeMaterializationsDestroy", "id", id)
      const localVarPath =
        `/administration/incoming-invoices-rental-intake-materializations/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/incoming-invoices-rental-intake-materializations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {PatchedIncomingInvoiceRentalIntakeMaterializationRequest} [patchedIncomingInvoiceRentalIntakeMaterializationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsPartialUpdate: async (
      id: string,
      patchedIncomingInvoiceRentalIntakeMaterializationRequest?: PatchedIncomingInvoiceRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesRentalIntakeMaterializationsPartialUpdate", "id", id)
      const localVarPath =
        `/administration/incoming-invoices-rental-intake-materializations/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedIncomingInvoiceRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesRentalIntakeMaterializationsRetrieve", "id", id)
      const localVarPath =
        `/administration/incoming-invoices-rental-intake-materializations/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsUpdate: async (
      id: string,
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("incomingInvoicesRentalIntakeMaterializationsUpdate", "id", id)
      // verify required parameter 'incomingInvoiceRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "incomingInvoicesRentalIntakeMaterializationsUpdate",
        "incomingInvoiceRentalIntakeMaterializationRequest",
        incomingInvoiceRentalIntakeMaterializationRequest
      )
      const localVarPath =
        `/administration/incoming-invoices-rental-intake-materializations/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        incomingInvoiceRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * IncomingInvoicesRentalIntakeMaterializationsApi - functional programming interface
 */
export const IncomingInvoicesRentalIntakeMaterializationsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    IncomingInvoicesRentalIntakeMaterializationsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IncomingInvoiceRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IncomingInvoiceRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IncomingInvoiceRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsCreate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IncomingInvoiceRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsCreate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsDestroy(
          id,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedIncomingInvoiceRentalIntakeMaterializationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {PatchedIncomingInvoiceRentalIntakeMaterializationRequest} [patchedIncomingInvoiceRentalIntakeMaterializationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsPartialUpdate(
      id: string,
      patchedIncomingInvoiceRentalIntakeMaterializationRequest?: PatchedIncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IncomingInvoiceRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsPartialUpdate(
          id,
          patchedIncomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IncomingInvoiceRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsRetrieve(
          id,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomingInvoicesRentalIntakeMaterializationsUpdate(
      id: string,
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IncomingInvoiceRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.incomingInvoicesRentalIntakeMaterializationsUpdate(
          id,
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "IncomingInvoicesRentalIntakeMaterializationsApi.incomingInvoicesRentalIntakeMaterializationsUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * IncomingInvoicesRentalIntakeMaterializationsApi - factory interface
 */
export const IncomingInvoicesRentalIntakeMaterializationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = IncomingInvoicesRentalIntakeMaterializationsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoiceRentalIntakeMaterialization> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoiceRentalIntakeMaterialization> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoiceRentalIntakeMaterialization> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsCreate(
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoiceRentalIntakeMaterialization> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsCreate(
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedIncomingInvoiceRentalIntakeMaterializationList> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {PatchedIncomingInvoiceRentalIntakeMaterializationRequest} [patchedIncomingInvoiceRentalIntakeMaterializationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsPartialUpdate(
      id: string,
      patchedIncomingInvoiceRentalIntakeMaterializationRequest?: PatchedIncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoiceRentalIntakeMaterialization> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsPartialUpdate(
          id,
          patchedIncomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoiceRentalIntakeMaterialization> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
     * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomingInvoicesRentalIntakeMaterializationsUpdate(
      id: string,
      incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<IncomingInvoiceRentalIntakeMaterialization> {
      return localVarFp
        .incomingInvoicesRentalIntakeMaterializationsUpdate(
          id,
          incomingInvoiceRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * IncomingInvoicesRentalIntakeMaterializationsApi - object-oriented interface
 */
export class IncomingInvoicesRentalIntakeMaterializationsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate(
    incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsBulkCreateCreate(
        incomingInvoiceRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate(
    incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsBulkDeleteCreate(
        incomingInvoiceRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate(
    incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsBulkUpdateUpdate(
        incomingInvoiceRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsCreate(
    incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsCreate(
        incomingInvoiceRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsDestroy(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
   * @param {PatchedIncomingInvoiceRentalIntakeMaterializationRequest} [patchedIncomingInvoiceRentalIntakeMaterializationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsPartialUpdate(
    id: string,
    patchedIncomingInvoiceRentalIntakeMaterializationRequest?: PatchedIncomingInvoiceRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsPartialUpdate(
        id,
        patchedIncomingInvoiceRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inkoopfactuur Inhuurmaterialisatie.
   * @param {IncomingInvoiceRentalIntakeMaterializationRequest} incomingInvoiceRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public incomingInvoicesRentalIntakeMaterializationsUpdate(
    id: string,
    incomingInvoiceRentalIntakeMaterializationRequest: IncomingInvoiceRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return IncomingInvoicesRentalIntakeMaterializationsApiFp(this.configuration)
      .incomingInvoicesRentalIntakeMaterializationsUpdate(
        id,
        incomingInvoiceRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * InstructionFeedbacksApi - axios parameter creator
 */
export const InstructionFeedbacksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksBulkCreateCreate: async (
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksBulkCreateCreate",
        "instructionFeedbackRequest",
        instructionFeedbackRequest
      )
      const localVarPath = `/planning/instruction-feedbacks/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksBulkDeleteCreate: async (
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksBulkDeleteCreate",
        "instructionFeedbackRequest",
        instructionFeedbackRequest
      )
      const localVarPath = `/planning/instruction-feedbacks/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksBulkUpdateUpdate: async (
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksBulkUpdateUpdate",
        "instructionFeedbackRequest",
        instructionFeedbackRequest
      )
      const localVarPath = `/planning/instruction-feedbacks/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksConfirmUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksConfirmUpdate", "id", id)
      const localVarPath = `/planning/instruction-feedbacks/{id}/confirm/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksCreate: async (
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksCreate",
        "instructionFeedbackRequest",
        instructionFeedbackRequest
      )
      const localVarPath = `/planning/instruction-feedbacks/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksDestroy", "id", id)
      const localVarPath = `/planning/instruction-feedbacks/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/instruction-feedbacks/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {PatchedInstructionFeedbackRequest} [patchedInstructionFeedbackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksPartialUpdate: async (
      id: string,
      patchedInstructionFeedbackRequest?: PatchedInstructionFeedbackRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksPartialUpdate", "id", id)
      const localVarPath = `/planning/instruction-feedbacks/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedInstructionFeedbackRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksRetrieve", "id", id)
      const localVarPath = `/planning/instruction-feedbacks/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksUpdate: async (
      id: string,
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksUpdate", "id", id)
      // verify required parameter 'instructionFeedbackRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksUpdate",
        "instructionFeedbackRequest",
        instructionFeedbackRequest
      )
      const localVarPath = `/planning/instruction-feedbacks/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * InstructionFeedbacksApi - functional programming interface
 */
export const InstructionFeedbacksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InstructionFeedbacksApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksBulkCreateCreate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedback>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksBulkCreateCreate(
          instructionFeedbackRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksBulkDeleteCreate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedback>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksBulkDeleteCreate(
          instructionFeedbackRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksBulkUpdateUpdate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedback>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksBulkUpdateUpdate(
          instructionFeedbackRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksConfirmUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksConfirmUpdate(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksConfirmUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksCreate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedback>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksCreate(
        instructionFeedbackRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedInstructionFeedbackList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {PatchedInstructionFeedbackRequest} [patchedInstructionFeedbackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksPartialUpdate(
      id: string,
      patchedInstructionFeedbackRequest?: PatchedInstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedback>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksPartialUpdate(
        id,
        patchedInstructionFeedbackRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedback>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksUpdate(
      id: string,
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedback>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksUpdate(
        id,
        instructionFeedbackRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionFeedbacksApi.instructionFeedbacksUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * InstructionFeedbacksApi - factory interface
 */
export const InstructionFeedbacksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InstructionFeedbacksApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksBulkCreateCreate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedback> {
      return localVarFp
        .instructionFeedbacksBulkCreateCreate(instructionFeedbackRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksBulkDeleteCreate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedback> {
      return localVarFp
        .instructionFeedbacksBulkDeleteCreate(instructionFeedbackRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksBulkUpdateUpdate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedback> {
      return localVarFp
        .instructionFeedbacksBulkUpdateUpdate(instructionFeedbackRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksConfirmUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionFeedbacksConfirmUpdate(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksCreate(
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedback> {
      return localVarFp
        .instructionFeedbacksCreate(instructionFeedbackRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .instructionFeedbacksDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedInstructionFeedbackList> {
      return localVarFp
        .instructionFeedbacksList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {PatchedInstructionFeedbackRequest} [patchedInstructionFeedbackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksPartialUpdate(
      id: string,
      patchedInstructionFeedbackRequest?: PatchedInstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedback> {
      return localVarFp
        .instructionFeedbacksPartialUpdate(id, patchedInstructionFeedbackRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedback> {
      return localVarFp
        .instructionFeedbacksRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this instructieterugkoppeling.
     * @param {InstructionFeedbackRequest} instructionFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksUpdate(
      id: string,
      instructionFeedbackRequest: InstructionFeedbackRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedback> {
      return localVarFp
        .instructionFeedbacksUpdate(id, instructionFeedbackRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * InstructionFeedbacksApi - object-oriented interface
 */
export class InstructionFeedbacksApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackRequest} instructionFeedbackRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksBulkCreateCreate(
    instructionFeedbackRequest: InstructionFeedbackRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksBulkCreateCreate(instructionFeedbackRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackRequest} instructionFeedbackRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksBulkDeleteCreate(
    instructionFeedbackRequest: InstructionFeedbackRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksBulkDeleteCreate(instructionFeedbackRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackRequest} instructionFeedbackRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksBulkUpdateUpdate(
    instructionFeedbackRequest: InstructionFeedbackRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksBulkUpdateUpdate(instructionFeedbackRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksConfirmUpdate(id: string, options?: RawAxiosRequestConfig) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksConfirmUpdate(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {InstructionFeedbackRequest} instructionFeedbackRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksCreate(
    instructionFeedbackRequest: InstructionFeedbackRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksCreate(instructionFeedbackRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this instructieterugkoppeling.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksDestroy(id: string, options?: RawAxiosRequestConfig) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this instructieterugkoppeling.
   * @param {PatchedInstructionFeedbackRequest} [patchedInstructionFeedbackRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksPartialUpdate(
    id: string,
    patchedInstructionFeedbackRequest?: PatchedInstructionFeedbackRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksPartialUpdate(id, patchedInstructionFeedbackRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this instructieterugkoppeling.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this instructieterugkoppeling.
   * @param {InstructionFeedbackRequest} instructionFeedbackRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksUpdate(
    id: string,
    instructionFeedbackRequest: InstructionFeedbackRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksApiFp(this.configuration)
      .instructionFeedbacksUpdate(id, instructionFeedbackRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * InstructionFeedbacksActivitiesApi - axios parameter creator
 */
export const InstructionFeedbacksActivitiesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesBulkCreateCreate: async (
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesBulkCreateCreate",
        "instructionFeedbackActivityRequest",
        instructionFeedbackActivityRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesBulkDeleteCreate: async (
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesBulkDeleteCreate",
        "instructionFeedbackActivityRequest",
        instructionFeedbackActivityRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesBulkUpdateUpdate: async (
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesBulkUpdateUpdate",
        "instructionFeedbackActivityRequest",
        instructionFeedbackActivityRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesCreate: async (
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesCreate",
        "instructionFeedbackActivityRequest",
        instructionFeedbackActivityRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesDestroy", "id", id)
      const localVarPath = `/planning/instruction-feedbacks-activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/instruction-feedbacks-activities/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {PatchedInstructionFeedbackActivityRequest} [patchedInstructionFeedbackActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesPartialUpdate: async (
      id: string,
      patchedInstructionFeedbackActivityRequest?: PatchedInstructionFeedbackActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesPartialUpdate", "id", id)
      const localVarPath = `/planning/instruction-feedbacks-activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedInstructionFeedbackActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesRetrieve", "id", id)
      const localVarPath = `/planning/instruction-feedbacks-activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesUpdate: async (
      id: string,
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesUpdate", "id", id)
      // verify required parameter 'instructionFeedbackActivityRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesUpdate",
        "instructionFeedbackActivityRequest",
        instructionFeedbackActivityRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * InstructionFeedbacksActivitiesApi - functional programming interface
 */
export const InstructionFeedbacksActivitiesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    InstructionFeedbacksActivitiesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesBulkCreateCreate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesBulkCreateCreate(
          instructionFeedbackActivityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesBulkDeleteCreate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesBulkDeleteCreate(
          instructionFeedbackActivityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesBulkUpdateUpdate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesBulkUpdateUpdate(
          instructionFeedbackActivityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesCreate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesCreate(
          instructionFeedbackActivityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedInstructionFeedbackActivityList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionFeedbacksActivitiesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {PatchedInstructionFeedbackActivityRequest} [patchedInstructionFeedbackActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesPartialUpdate(
      id: string,
      patchedInstructionFeedbackActivityRequest?: PatchedInstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesPartialUpdate(
          id,
          patchedInstructionFeedbackActivityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesUpdate(
      id: string,
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesUpdate(
          id,
          instructionFeedbackActivityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesApi.instructionFeedbacksActivitiesUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * InstructionFeedbacksActivitiesApi - factory interface
 */
export const InstructionFeedbacksActivitiesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InstructionFeedbacksActivitiesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesBulkCreateCreate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivity> {
      return localVarFp
        .instructionFeedbacksActivitiesBulkCreateCreate(instructionFeedbackActivityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesBulkDeleteCreate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivity> {
      return localVarFp
        .instructionFeedbacksActivitiesBulkDeleteCreate(instructionFeedbackActivityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesBulkUpdateUpdate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivity> {
      return localVarFp
        .instructionFeedbacksActivitiesBulkUpdateUpdate(instructionFeedbackActivityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesCreate(
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivity> {
      return localVarFp
        .instructionFeedbacksActivitiesCreate(instructionFeedbackActivityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionFeedbacksActivitiesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedInstructionFeedbackActivityList> {
      return localVarFp
        .instructionFeedbacksActivitiesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {PatchedInstructionFeedbackActivityRequest} [patchedInstructionFeedbackActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesPartialUpdate(
      id: string,
      patchedInstructionFeedbackActivityRequest?: PatchedInstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivity> {
      return localVarFp
        .instructionFeedbacksActivitiesPartialUpdate(
          id,
          patchedInstructionFeedbackActivityRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivity> {
      return localVarFp
        .instructionFeedbacksActivitiesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this instruction feedback activity.
     * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesUpdate(
      id: string,
      instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivity> {
      return localVarFp
        .instructionFeedbacksActivitiesUpdate(id, instructionFeedbackActivityRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * InstructionFeedbacksActivitiesApi - object-oriented interface
 */
export class InstructionFeedbacksActivitiesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesBulkCreateCreate(
    instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesBulkCreateCreate(instructionFeedbackActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesBulkDeleteCreate(
    instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesBulkDeleteCreate(instructionFeedbackActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesBulkUpdateUpdate(
    instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesBulkUpdateUpdate(instructionFeedbackActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesCreate(
    instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesCreate(instructionFeedbackActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this instruction feedback activity.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this instruction feedback activity.
   * @param {PatchedInstructionFeedbackActivityRequest} [patchedInstructionFeedbackActivityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesPartialUpdate(
    id: string,
    patchedInstructionFeedbackActivityRequest?: PatchedInstructionFeedbackActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesPartialUpdate(
        id,
        patchedInstructionFeedbackActivityRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this instruction feedback activity.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this instruction feedback activity.
   * @param {InstructionFeedbackActivityRequest} instructionFeedbackActivityRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesUpdate(
    id: string,
    instructionFeedbackActivityRequest: InstructionFeedbackActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesApiFp(this.configuration)
      .instructionFeedbacksActivitiesUpdate(id, instructionFeedbackActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * InstructionFeedbacksActivitiesProductsApi - axios parameter creator
 */
export const InstructionFeedbacksActivitiesProductsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsBulkCreateCreate: async (
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityProductRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesProductsBulkCreateCreate",
        "instructionFeedbackActivityProductRequest",
        instructionFeedbackActivityProductRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities-products/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityProductRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsBulkDeleteCreate: async (
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityProductRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesProductsBulkDeleteCreate",
        "instructionFeedbackActivityProductRequest",
        instructionFeedbackActivityProductRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities-products/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityProductRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsBulkUpdateUpdate: async (
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityProductRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesProductsBulkUpdateUpdate",
        "instructionFeedbackActivityProductRequest",
        instructionFeedbackActivityProductRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities-products/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityProductRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsCreate: async (
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionFeedbackActivityProductRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesProductsCreate",
        "instructionFeedbackActivityProductRequest",
        instructionFeedbackActivityProductRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities-products/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityProductRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesProductsDestroy", "id", id)
      const localVarPath = `/planning/instruction-feedbacks-activities-products/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/instruction-feedbacks-activities-products/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {PatchedInstructionFeedbackActivityProductRequest} [patchedInstructionFeedbackActivityProductRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsPartialUpdate: async (
      id: string,
      patchedInstructionFeedbackActivityProductRequest?: PatchedInstructionFeedbackActivityProductRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesProductsPartialUpdate", "id", id)
      const localVarPath = `/planning/instruction-feedbacks-activities-products/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedInstructionFeedbackActivityProductRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesProductsRetrieve", "id", id)
      const localVarPath = `/planning/instruction-feedbacks-activities-products/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsUpdate: async (
      id: string,
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionFeedbacksActivitiesProductsUpdate", "id", id)
      // verify required parameter 'instructionFeedbackActivityProductRequest' is not null or undefined
      assertParamExists(
        "instructionFeedbacksActivitiesProductsUpdate",
        "instructionFeedbackActivityProductRequest",
        instructionFeedbackActivityProductRequest
      )
      const localVarPath = `/planning/instruction-feedbacks-activities-products/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionFeedbackActivityProductRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * InstructionFeedbacksActivitiesProductsApi - functional programming interface
 */
export const InstructionFeedbacksActivitiesProductsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    InstructionFeedbacksActivitiesProductsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsBulkCreateCreate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivityProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsBulkCreateCreate(
          instructionFeedbackActivityProductRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsBulkDeleteCreate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivityProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsBulkDeleteCreate(
          instructionFeedbackActivityProductRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsBulkUpdateUpdate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivityProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsBulkUpdateUpdate(
          instructionFeedbackActivityProductRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsCreate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivityProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsCreate(
          instructionFeedbackActivityProductRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedInstructionFeedbackActivityProductList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {PatchedInstructionFeedbackActivityProductRequest} [patchedInstructionFeedbackActivityProductRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsPartialUpdate(
      id: string,
      patchedInstructionFeedbackActivityProductRequest?: PatchedInstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivityProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsPartialUpdate(
          id,
          patchedInstructionFeedbackActivityProductRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivityProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionFeedbacksActivitiesProductsUpdate(
      id: string,
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFeedbackActivityProduct>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionFeedbacksActivitiesProductsUpdate(
          id,
          instructionFeedbackActivityProductRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "InstructionFeedbacksActivitiesProductsApi.instructionFeedbacksActivitiesProductsUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * InstructionFeedbacksActivitiesProductsApi - factory interface
 */
export const InstructionFeedbacksActivitiesProductsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InstructionFeedbacksActivitiesProductsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsBulkCreateCreate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivityProduct> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsBulkCreateCreate(
          instructionFeedbackActivityProductRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsBulkDeleteCreate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivityProduct> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsBulkDeleteCreate(
          instructionFeedbackActivityProductRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsBulkUpdateUpdate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivityProduct> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsBulkUpdateUpdate(
          instructionFeedbackActivityProductRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsCreate(
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivityProduct> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsCreate(
          instructionFeedbackActivityProductRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedInstructionFeedbackActivityProductList> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {PatchedInstructionFeedbackActivityProductRequest} [patchedInstructionFeedbackActivityProductRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsPartialUpdate(
      id: string,
      patchedInstructionFeedbackActivityProductRequest?: PatchedInstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivityProduct> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsPartialUpdate(
          id,
          patchedInstructionFeedbackActivityProductRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivityProduct> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this instruction feedback activity product.
     * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionFeedbacksActivitiesProductsUpdate(
      id: string,
      instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionFeedbackActivityProduct> {
      return localVarFp
        .instructionFeedbacksActivitiesProductsUpdate(
          id,
          instructionFeedbackActivityProductRequest,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * InstructionFeedbacksActivitiesProductsApi - object-oriented interface
 */
export class InstructionFeedbacksActivitiesProductsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsBulkCreateCreate(
    instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsBulkCreateCreate(
        instructionFeedbackActivityProductRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsBulkDeleteCreate(
    instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsBulkDeleteCreate(
        instructionFeedbackActivityProductRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsBulkUpdateUpdate(
    instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsBulkUpdateUpdate(
        instructionFeedbackActivityProductRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsCreate(
    instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsCreate(
        instructionFeedbackActivityProductRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this instruction feedback activity product.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsDestroy(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this instruction feedback activity product.
   * @param {PatchedInstructionFeedbackActivityProductRequest} [patchedInstructionFeedbackActivityProductRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsPartialUpdate(
    id: string,
    patchedInstructionFeedbackActivityProductRequest?: PatchedInstructionFeedbackActivityProductRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsPartialUpdate(
        id,
        patchedInstructionFeedbackActivityProductRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this instruction feedback activity product.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this instruction feedback activity product.
   * @param {InstructionFeedbackActivityProductRequest} instructionFeedbackActivityProductRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionFeedbacksActivitiesProductsUpdate(
    id: string,
    instructionFeedbackActivityProductRequest: InstructionFeedbackActivityProductRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionFeedbacksActivitiesProductsApiFp(this.configuration)
      .instructionFeedbacksActivitiesProductsUpdate(
        id,
        instructionFeedbackActivityProductRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * InstructionsApi - axios parameter creator
 */
export const InstructionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsBulkCreateCreate: async (
      instructionRequest: InstructionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionRequest' is not null or undefined
      assertParamExists("instructionsBulkCreateCreate", "instructionRequest", instructionRequest)
      const localVarPath = `/planning/instructions/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsBulkDeleteCreate: async (
      instructionRequest: InstructionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionRequest' is not null or undefined
      assertParamExists("instructionsBulkDeleteCreate", "instructionRequest", instructionRequest)
      const localVarPath = `/planning/instructions/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsBulkUpdateUpdate: async (
      instructionRequest: InstructionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionRequest' is not null or undefined
      assertParamExists("instructionsBulkUpdateUpdate", "instructionRequest", instructionRequest)
      const localVarPath = `/planning/instructions/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsCreate: async (
      instructionRequest: InstructionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionRequest' is not null or undefined
      assertParamExists("instructionsCreate", "instructionRequest", instructionRequest)
      const localVarPath = `/planning/instructions/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instructie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsDestroy", "id", id)
      const localVarPath = `/planning/instructions/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} instructionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsFeedbackCreate: async (
      instructionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionId' is not null or undefined
      assertParamExists("instructionsFeedbackCreate", "instructionId", instructionId)
      const localVarPath = `/planning/instructions/{instructionId}/feedback/`.replace(
        `{${"instructionId"}}`,
        encodeURIComponent(String(instructionId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Return the built context for an Instruction as plain text. URL kwarg \'pk\' should be the Instruction\'s primary key.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsGetContextTextRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsGetContextTextRetrieve", "id", id)
      const localVarPath = `/planning/instructions/{id}/get-context-text/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Return the built context for an Instruction as structured JSON. URL kwarg \'pk\' should be the Instruction\'s primary key.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsGetContextTextV2Retrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsGetContextTextV2Retrieve", "id", id)
      const localVarPath = `/planning/instructions/{id}/get-context-text-v2/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/instructions/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsLockCreate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsLockCreate", "id", id)
      const localVarPath = `/planning/instructions/{id}/lock/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsLockDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsLockDestroy", "id", id)
      const localVarPath = `/planning/instructions/{id}/lock/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsLocksRetrieve: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/instructions/locks/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instructie.
     * @param {PatchedInstructionRequest} [patchedInstructionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsPartialUpdate: async (
      id: string,
      patchedInstructionRequest?: PatchedInstructionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsPartialUpdate", "id", id)
      const localVarPath = `/planning/instructions/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedInstructionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this instructie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsRetrieve", "id", id)
      const localVarPath = `/planning/instructions/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsSuggestSummaryTextUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsSuggestSummaryTextUpdate", "id", id)
      const localVarPath = `/planning/instructions/{id}/suggest-summary-text/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this instructie.
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsUpdate: async (
      id: string,
      instructionRequest: InstructionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("instructionsUpdate", "id", id)
      // verify required parameter 'instructionRequest' is not null or undefined
      assertParamExists("instructionsUpdate", "instructionRequest", instructionRequest)
      const localVarPath = `/planning/instructions/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * InstructionsApi - functional programming interface
 */
export const InstructionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InstructionsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsBulkCreateCreate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instruction>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsBulkCreateCreate(
        instructionRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsBulkDeleteCreate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instruction>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsBulkDeleteCreate(
        instructionRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsBulkUpdateUpdate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instruction>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsBulkUpdateUpdate(
        instructionRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsCreate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instruction>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsCreate(
        instructionRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instructie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsDestroy"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} instructionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsFeedbackCreate(
      instructionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsFeedbackCreate(
        instructionId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsFeedbackCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Return the built context for an Instruction as plain text. URL kwarg \'pk\' should be the Instruction\'s primary key.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsGetContextTextRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsGetContextTextRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsGetContextTextRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Return the built context for an Instruction as structured JSON. URL kwarg \'pk\' should be the Instruction\'s primary key.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsGetContextTextV2Retrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionsGetContextTextV2Retrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsGetContextTextV2Retrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedInstructionList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsLockCreate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsLockCreate(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsLockCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsLockDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsLockDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsLockDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsLocksRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsLocksRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsLocksRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instructie.
     * @param {PatchedInstructionRequest} [patchedInstructionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsPartialUpdate(
      id: string,
      patchedInstructionRequest?: PatchedInstructionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instruction>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsPartialUpdate(
        id,
        patchedInstructionRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this instructie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instruction>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsSuggestSummaryTextUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionsSuggestSummaryTextUpdate(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsSuggestSummaryTextUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this instructie.
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsUpdate(
      id: string,
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instruction>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsUpdate(
        id,
        instructionRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InstructionsApi.instructionsUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * InstructionsApi - factory interface
 */
export const InstructionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InstructionsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsBulkCreateCreate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Instruction> {
      return localVarFp
        .instructionsBulkCreateCreate(instructionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsBulkDeleteCreate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Instruction> {
      return localVarFp
        .instructionsBulkDeleteCreate(instructionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsBulkUpdateUpdate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Instruction> {
      return localVarFp
        .instructionsBulkUpdateUpdate(instructionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsCreate(
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Instruction> {
      return localVarFp
        .instructionsCreate(instructionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this instructie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.instructionsDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} instructionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsFeedbackCreate(
      instructionId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionsFeedbackCreate(instructionId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Return the built context for an Instruction as plain text. URL kwarg \'pk\' should be the Instruction\'s primary key.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsGetContextTextRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionsGetContextTextRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Return the built context for an Instruction as structured JSON. URL kwarg \'pk\' should be the Instruction\'s primary key.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsGetContextTextV2Retrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionsGetContextTextV2Retrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedInstructionList> {
      return localVarFp
        .instructionsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsLockCreate(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .instructionsLockCreate(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsLockDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .instructionsLockDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsLocksRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .instructionsLocksRetrieve(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this instructie.
     * @param {PatchedInstructionRequest} [patchedInstructionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsPartialUpdate(
      id: string,
      patchedInstructionRequest?: PatchedInstructionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Instruction> {
      return localVarFp
        .instructionsPartialUpdate(id, patchedInstructionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this instructie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Instruction> {
      return localVarFp
        .instructionsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsSuggestSummaryTextUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionsSuggestSummaryTextUpdate(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this instructie.
     * @param {InstructionRequest} instructionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsUpdate(
      id: string,
      instructionRequest: InstructionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Instruction> {
      return localVarFp
        .instructionsUpdate(id, instructionRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * InstructionsApi - object-oriented interface
 */
export class InstructionsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionRequest} instructionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsBulkCreateCreate(
    instructionRequest: InstructionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsBulkCreateCreate(instructionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionRequest} instructionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsBulkDeleteCreate(
    instructionRequest: InstructionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsBulkDeleteCreate(instructionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {InstructionRequest} instructionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsBulkUpdateUpdate(
    instructionRequest: InstructionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsBulkUpdateUpdate(instructionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {InstructionRequest} instructionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsCreate(
    instructionRequest: InstructionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsCreate(instructionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this instructie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} instructionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsFeedbackCreate(instructionId: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsFeedbackCreate(instructionId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Return the built context for an Instruction as plain text. URL kwarg \'pk\' should be the Instruction\'s primary key.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsGetContextTextRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsGetContextTextRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Return the built context for an Instruction as structured JSON. URL kwarg \'pk\' should be the Instruction\'s primary key.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsGetContextTextV2Retrieve(id: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsGetContextTextV2Retrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsLockCreate(id: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsLockCreate(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsLockDestroy(id: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsLockDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsLocksRetrieve(options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsLocksRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this instructie.
   * @param {PatchedInstructionRequest} [patchedInstructionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsPartialUpdate(
    id: string,
    patchedInstructionRequest?: PatchedInstructionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsPartialUpdate(id, patchedInstructionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this instructie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsSuggestSummaryTextUpdate(id: string, options?: RawAxiosRequestConfig) {
    return InstructionsApiFp(this.configuration)
      .instructionsSuggestSummaryTextUpdate(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this instructie.
   * @param {InstructionRequest} instructionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public instructionsUpdate(
    id: string,
    instructionRequest: InstructionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsUpdate(id, instructionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * KnownBusinessEntitiesApi - axios parameter creator
 */
export const KnownBusinessEntitiesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesBulkCreateCreate: async (
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/known-business-entities/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesBulkDeleteCreate: async (
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/known-business-entities/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesBulkUpdateUpdate: async (
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/known-business-entities/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a KnownBusinessEntity, linking to or creating a RegisteredBusinessEntity when possible.
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesCreate: async (
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/known-business-entities/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesDestroy", "id", id)
      const localVarPath = `/core/known-business-entities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/known-business-entities/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {PatchedKnownBusinessEntityRequest} [patchedKnownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesPartialUpdate: async (
      id: string,
      patchedKnownBusinessEntityRequest?: PatchedKnownBusinessEntityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesPartialUpdate", "id", id)
      const localVarPath = `/core/known-business-entities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedKnownBusinessEntityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesRetrieve", "id", id)
      const localVarPath = `/core/known-business-entities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesUpdate: async (
      id: string,
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesUpdate", "id", id)
      const localVarPath = `/core/known-business-entities/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * KnownBusinessEntitiesApi - functional programming interface
 */
export const KnownBusinessEntitiesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = KnownBusinessEntitiesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesBulkCreateCreate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntity>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesBulkCreateCreate(
          knownBusinessEntityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesBulkDeleteCreate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntity>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesBulkDeleteCreate(
          knownBusinessEntityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesBulkUpdateUpdate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntity>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesBulkUpdateUpdate(
          knownBusinessEntityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a KnownBusinessEntity, linking to or creating a RegisteredBusinessEntity when possible.
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesCreate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesCreate(
        knownBusinessEntityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedKnownBusinessEntityList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {PatchedKnownBusinessEntityRequest} [patchedKnownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesPartialUpdate(
      id: string,
      patchedKnownBusinessEntityRequest?: PatchedKnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesPartialUpdate(
        id,
        patchedKnownBusinessEntityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesUpdate(
      id: string,
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesUpdate(
        id,
        knownBusinessEntityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesApi.knownBusinessEntitiesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * KnownBusinessEntitiesApi - factory interface
 */
export const KnownBusinessEntitiesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = KnownBusinessEntitiesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesBulkCreateCreate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntity> {
      return localVarFp
        .knownBusinessEntitiesBulkCreateCreate(knownBusinessEntityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesBulkDeleteCreate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntity> {
      return localVarFp
        .knownBusinessEntitiesBulkDeleteCreate(knownBusinessEntityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesBulkUpdateUpdate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntity> {
      return localVarFp
        .knownBusinessEntitiesBulkUpdateUpdate(knownBusinessEntityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a KnownBusinessEntity, linking to or creating a RegisteredBusinessEntity when possible.
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesCreate(
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntity> {
      return localVarFp
        .knownBusinessEntitiesCreate(knownBusinessEntityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .knownBusinessEntitiesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedKnownBusinessEntityList> {
      return localVarFp
        .knownBusinessEntitiesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {PatchedKnownBusinessEntityRequest} [patchedKnownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesPartialUpdate(
      id: string,
      patchedKnownBusinessEntityRequest?: PatchedKnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntity> {
      return localVarFp
        .knownBusinessEntitiesPartialUpdate(id, patchedKnownBusinessEntityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntity> {
      return localVarFp
        .knownBusinessEntitiesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Bedrijf.
     * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesUpdate(
      id: string,
      knownBusinessEntityRequest?: KnownBusinessEntityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntity> {
      return localVarFp
        .knownBusinessEntitiesUpdate(id, knownBusinessEntityRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * KnownBusinessEntitiesApi - object-oriented interface
 */
export class KnownBusinessEntitiesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesBulkCreateCreate(
    knownBusinessEntityRequest?: KnownBusinessEntityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesBulkCreateCreate(knownBusinessEntityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesBulkDeleteCreate(
    knownBusinessEntityRequest?: KnownBusinessEntityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesBulkDeleteCreate(knownBusinessEntityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesBulkUpdateUpdate(
    knownBusinessEntityRequest?: KnownBusinessEntityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesBulkUpdateUpdate(knownBusinessEntityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a KnownBusinessEntity, linking to or creating a RegisteredBusinessEntity when possible.
   * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesCreate(
    knownBusinessEntityRequest?: KnownBusinessEntityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesCreate(knownBusinessEntityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Bedrijf.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Bedrijf.
   * @param {PatchedKnownBusinessEntityRequest} [patchedKnownBusinessEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesPartialUpdate(
    id: string,
    patchedKnownBusinessEntityRequest?: PatchedKnownBusinessEntityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesPartialUpdate(id, patchedKnownBusinessEntityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Bedrijf.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Bedrijf.
   * @param {KnownBusinessEntityRequest} [knownBusinessEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesUpdate(
    id: string,
    knownBusinessEntityRequest?: KnownBusinessEntityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesApiFp(this.configuration)
      .knownBusinessEntitiesUpdate(id, knownBusinessEntityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * KnownBusinessEntitiesContactsApi - axios parameter creator
 */
export const KnownBusinessEntitiesContactsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsBulkCreateCreate: async (
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityContactRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesContactsBulkCreateCreate",
        "knownBusinessEntityContactRequest",
        knownBusinessEntityContactRequest
      )
      const localVarPath = `/core/known-business-entities-contacts/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityContactRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsBulkDeleteCreate: async (
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityContactRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesContactsBulkDeleteCreate",
        "knownBusinessEntityContactRequest",
        knownBusinessEntityContactRequest
      )
      const localVarPath = `/core/known-business-entities-contacts/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityContactRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsBulkUpdateUpdate: async (
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityContactRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesContactsBulkUpdateUpdate",
        "knownBusinessEntityContactRequest",
        knownBusinessEntityContactRequest
      )
      const localVarPath = `/core/known-business-entities-contacts/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityContactRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsCreate: async (
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityContactRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesContactsCreate",
        "knownBusinessEntityContactRequest",
        knownBusinessEntityContactRequest
      )
      const localVarPath = `/core/known-business-entities-contacts/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityContactRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsDestroy", "id", id)
      const localVarPath = `/core/known-business-entities-contacts/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/known-business-entities-contacts/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {PatchedKnownBusinessEntityContactRequest} [patchedKnownBusinessEntityContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsPartialUpdate: async (
      id: string,
      patchedKnownBusinessEntityContactRequest?: PatchedKnownBusinessEntityContactRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsPartialUpdate", "id", id)
      const localVarPath = `/core/known-business-entities-contacts/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedKnownBusinessEntityContactRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsRetrieve", "id", id)
      const localVarPath = `/core/known-business-entities-contacts/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} kbecId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRolesCreate: async (
      kbecId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'kbecId' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsRolesCreate", "kbecId", kbecId)
      const localVarPath = `/core/known-business-entities-contacts/{kbecId}/roles/`.replace(
        `{${"kbecId"}}`,
        encodeURIComponent(String(kbecId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} kbecId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRolesDestroy: async (
      kbecId: string,
      roleId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'kbecId' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsRolesDestroy", "kbecId", kbecId)
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsRolesDestroy", "roleId", roleId)
      const localVarPath = `/core/known-business-entities-contacts/{kbecId}/roles/{roleId}/`
        .replace(`{${"kbecId"}}`, encodeURIComponent(String(kbecId)))
        .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} kbecId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRolesUpdate: async (
      kbecId: string,
      roleId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'kbecId' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsRolesUpdate", "kbecId", kbecId)
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsRolesUpdate", "roleId", roleId)
      const localVarPath = `/core/known-business-entities-contacts/{kbecId}/roles/{roleId}/`
        .replace(`{${"kbecId"}}`, encodeURIComponent(String(kbecId)))
        .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsUpdate: async (
      id: string,
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesContactsUpdate", "id", id)
      // verify required parameter 'knownBusinessEntityContactRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesContactsUpdate",
        "knownBusinessEntityContactRequest",
        knownBusinessEntityContactRequest
      )
      const localVarPath = `/core/known-business-entities-contacts/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityContactRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * KnownBusinessEntitiesContactsApi - functional programming interface
 */
export const KnownBusinessEntitiesContactsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = KnownBusinessEntitiesContactsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsBulkCreateCreate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntityContact>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsBulkCreateCreate(
          knownBusinessEntityContactRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsBulkDeleteCreate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntityContact>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsBulkDeleteCreate(
          knownBusinessEntityContactRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsBulkUpdateUpdate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntityContact>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsBulkUpdateUpdate(
          knownBusinessEntityContactRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsCreate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntityContact>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesContactsCreate(
        knownBusinessEntityContactRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedKnownBusinessEntityContactList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesContactsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {PatchedKnownBusinessEntityContactRequest} [patchedKnownBusinessEntityContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsPartialUpdate(
      id: string,
      patchedKnownBusinessEntityContactRequest?: PatchedKnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntityContact>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsPartialUpdate(
          id,
          patchedKnownBusinessEntityContactRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntityContact>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} kbecId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsRolesCreate(
      kbecId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsRolesCreate(kbecId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsRolesCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} kbecId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsRolesDestroy(
      kbecId: string,
      roleId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsRolesDestroy(
          kbecId,
          roleId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsRolesDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} kbecId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsRolesUpdate(
      kbecId: string,
      roleId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesContactsRolesUpdate(
          kbecId,
          roleId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsRolesUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesContactsUpdate(
      id: string,
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntityContact>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesContactsUpdate(
        id,
        knownBusinessEntityContactRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesContactsApi.knownBusinessEntitiesContactsUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * KnownBusinessEntitiesContactsApi - factory interface
 */
export const KnownBusinessEntitiesContactsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = KnownBusinessEntitiesContactsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsBulkCreateCreate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityContact> {
      return localVarFp
        .knownBusinessEntitiesContactsBulkCreateCreate(knownBusinessEntityContactRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsBulkDeleteCreate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityContact> {
      return localVarFp
        .knownBusinessEntitiesContactsBulkDeleteCreate(knownBusinessEntityContactRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsBulkUpdateUpdate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityContact> {
      return localVarFp
        .knownBusinessEntitiesContactsBulkUpdateUpdate(knownBusinessEntityContactRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsCreate(
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityContact> {
      return localVarFp
        .knownBusinessEntitiesContactsCreate(knownBusinessEntityContactRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .knownBusinessEntitiesContactsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedKnownBusinessEntityContactList> {
      return localVarFp
        .knownBusinessEntitiesContactsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {PatchedKnownBusinessEntityContactRequest} [patchedKnownBusinessEntityContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsPartialUpdate(
      id: string,
      patchedKnownBusinessEntityContactRequest?: PatchedKnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityContact> {
      return localVarFp
        .knownBusinessEntitiesContactsPartialUpdate(
          id,
          patchedKnownBusinessEntityContactRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityContact> {
      return localVarFp
        .knownBusinessEntitiesContactsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} kbecId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRolesCreate(
      kbecId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .knownBusinessEntitiesContactsRolesCreate(kbecId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} kbecId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRolesDestroy(
      kbecId: string,
      roleId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .knownBusinessEntitiesContactsRolesDestroy(kbecId, roleId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} kbecId
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsRolesUpdate(
      kbecId: string,
      roleId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .knownBusinessEntitiesContactsRolesUpdate(kbecId, roleId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this bedrijfspersoon.
     * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesContactsUpdate(
      id: string,
      knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityContact> {
      return localVarFp
        .knownBusinessEntitiesContactsUpdate(id, knownBusinessEntityContactRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * KnownBusinessEntitiesContactsApi - object-oriented interface
 */
export class KnownBusinessEntitiesContactsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsBulkCreateCreate(
    knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsBulkCreateCreate(knownBusinessEntityContactRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsBulkDeleteCreate(
    knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsBulkDeleteCreate(knownBusinessEntityContactRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsBulkUpdateUpdate(
    knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsBulkUpdateUpdate(knownBusinessEntityContactRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsCreate(
    knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsCreate(knownBusinessEntityContactRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this bedrijfspersoon.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this bedrijfspersoon.
   * @param {PatchedKnownBusinessEntityContactRequest} [patchedKnownBusinessEntityContactRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsPartialUpdate(
    id: string,
    patchedKnownBusinessEntityContactRequest?: PatchedKnownBusinessEntityContactRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsPartialUpdate(
        id,
        patchedKnownBusinessEntityContactRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this bedrijfspersoon.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} kbecId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsRolesCreate(kbecId: string, options?: RawAxiosRequestConfig) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsRolesCreate(kbecId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} kbecId
   * @param {string} roleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsRolesDestroy(
    kbecId: string,
    roleId: string,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsRolesDestroy(kbecId, roleId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} kbecId
   * @param {string} roleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsRolesUpdate(
    kbecId: string,
    roleId: string,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsRolesUpdate(kbecId, roleId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this bedrijfspersoon.
   * @param {KnownBusinessEntityContactRequest} knownBusinessEntityContactRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesContactsUpdate(
    id: string,
    knownBusinessEntityContactRequest: KnownBusinessEntityContactRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesContactsApiFp(this.configuration)
      .knownBusinessEntitiesContactsUpdate(id, knownBusinessEntityContactRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * KnownBusinessEntitiesRentalDispenseItemsApi - axios parameter creator
 */
export const KnownBusinessEntitiesRentalDispenseItemsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate: async (
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate",
        "knownBusinessEntityRentalDispenseItemRequest",
        knownBusinessEntityRentalDispenseItemRequest
      )
      const localVarPath = `/administration/known-business-entities-rental-dispense-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate: async (
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate",
        "knownBusinessEntityRentalDispenseItemRequest",
        knownBusinessEntityRentalDispenseItemRequest
      )
      const localVarPath = `/administration/known-business-entities-rental-dispense-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate: async (
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate",
        "knownBusinessEntityRentalDispenseItemRequest",
        knownBusinessEntityRentalDispenseItemRequest
      )
      const localVarPath = `/administration/known-business-entities-rental-dispense-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsCreate: async (
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntityRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesRentalDispenseItemsCreate",
        "knownBusinessEntityRentalDispenseItemRequest",
        knownBusinessEntityRentalDispenseItemRequest
      )
      const localVarPath = `/administration/known-business-entities-rental-dispense-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesRentalDispenseItemsDestroy", "id", id)
      const localVarPath =
        `/administration/known-business-entities-rental-dispense-items/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/known-business-entities-rental-dispense-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {PatchedKnownBusinessEntityRentalDispenseItemRequest} [patchedKnownBusinessEntityRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsPartialUpdate: async (
      id: string,
      patchedKnownBusinessEntityRentalDispenseItemRequest?: PatchedKnownBusinessEntityRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesRentalDispenseItemsPartialUpdate", "id", id)
      const localVarPath =
        `/administration/known-business-entities-rental-dispense-items/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedKnownBusinessEntityRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesRentalDispenseItemsRetrieve", "id", id)
      const localVarPath =
        `/administration/known-business-entities-rental-dispense-items/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsUpdate: async (
      id: string,
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesRentalDispenseItemsUpdate", "id", id)
      // verify required parameter 'knownBusinessEntityRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesRentalDispenseItemsUpdate",
        "knownBusinessEntityRentalDispenseItemRequest",
        knownBusinessEntityRentalDispenseItemRequest
      )
      const localVarPath =
        `/administration/known-business-entities-rental-dispense-items/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntityRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * KnownBusinessEntitiesRentalDispenseItemsApi - functional programming interface
 */
export const KnownBusinessEntitiesRentalDispenseItemsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    KnownBusinessEntitiesRentalDispenseItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<KnownBusinessEntityRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<KnownBusinessEntityRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<KnownBusinessEntityRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsCreate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<KnownBusinessEntityRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsCreate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedKnownBusinessEntityRentalDispenseItemList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {PatchedKnownBusinessEntityRentalDispenseItemRequest} [patchedKnownBusinessEntityRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsPartialUpdate(
      id: string,
      patchedKnownBusinessEntityRentalDispenseItemRequest?: PatchedKnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<KnownBusinessEntityRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsPartialUpdate(
          id,
          patchedKnownBusinessEntityRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<KnownBusinessEntityRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsRetrieve(
          id,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesRentalDispenseItemsUpdate(
      id: string,
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<KnownBusinessEntityRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesRentalDispenseItemsUpdate(
          id,
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesRentalDispenseItemsApi.knownBusinessEntitiesRentalDispenseItemsUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * KnownBusinessEntitiesRentalDispenseItemsApi - factory interface
 */
export const KnownBusinessEntitiesRentalDispenseItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = KnownBusinessEntitiesRentalDispenseItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityRentalDispenseItem> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityRentalDispenseItem> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityRentalDispenseItem> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsCreate(
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityRentalDispenseItem> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsCreate(
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedKnownBusinessEntityRentalDispenseItemList> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {PatchedKnownBusinessEntityRentalDispenseItemRequest} [patchedKnownBusinessEntityRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsPartialUpdate(
      id: string,
      patchedKnownBusinessEntityRentalDispenseItemRequest?: PatchedKnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityRentalDispenseItem> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsPartialUpdate(
          id,
          patchedKnownBusinessEntityRentalDispenseItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityRentalDispenseItem> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
     * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesRentalDispenseItemsUpdate(
      id: string,
      knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntityRentalDispenseItem> {
      return localVarFp
        .knownBusinessEntitiesRentalDispenseItemsUpdate(
          id,
          knownBusinessEntityRentalDispenseItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * KnownBusinessEntitiesRentalDispenseItemsApi - object-oriented interface
 */
export class KnownBusinessEntitiesRentalDispenseItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate(
    knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsBulkCreateCreate(
        knownBusinessEntityRentalDispenseItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate(
    knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsBulkDeleteCreate(
        knownBusinessEntityRentalDispenseItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate(
    knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsBulkUpdateUpdate(
        knownBusinessEntityRentalDispenseItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsCreate(
    knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsCreate(
        knownBusinessEntityRentalDispenseItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsDestroy(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
   * @param {PatchedKnownBusinessEntityRentalDispenseItemRequest} [patchedKnownBusinessEntityRentalDispenseItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsPartialUpdate(
    id: string,
    patchedKnownBusinessEntityRentalDispenseItemRequest?: PatchedKnownBusinessEntityRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsPartialUpdate(
        id,
        patchedKnownBusinessEntityRentalDispenseItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (bedrijf).
   * @param {KnownBusinessEntityRentalDispenseItemRequest} knownBusinessEntityRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesRentalDispenseItemsUpdate(
    id: string,
    knownBusinessEntityRentalDispenseItemRequest: KnownBusinessEntityRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesRentalDispenseItemsApiFp(this.configuration)
      .knownBusinessEntitiesRentalDispenseItemsUpdate(
        id,
        knownBusinessEntityRentalDispenseItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * KnownBusinessEntitiesSaleItemsApi - axios parameter creator
 */
export const KnownBusinessEntitiesSaleItemsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsBulkCreateCreate: async (
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntitySaleItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesSaleItemsBulkCreateCreate",
        "knownBusinessEntitySaleItemRequest",
        knownBusinessEntitySaleItemRequest
      )
      const localVarPath = `/administration/known-business-entities-sale-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntitySaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsBulkDeleteCreate: async (
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntitySaleItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesSaleItemsBulkDeleteCreate",
        "knownBusinessEntitySaleItemRequest",
        knownBusinessEntitySaleItemRequest
      )
      const localVarPath = `/administration/known-business-entities-sale-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntitySaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsBulkUpdateUpdate: async (
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntitySaleItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesSaleItemsBulkUpdateUpdate",
        "knownBusinessEntitySaleItemRequest",
        knownBusinessEntitySaleItemRequest
      )
      const localVarPath = `/administration/known-business-entities-sale-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntitySaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsCreate: async (
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'knownBusinessEntitySaleItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesSaleItemsCreate",
        "knownBusinessEntitySaleItemRequest",
        knownBusinessEntitySaleItemRequest
      )
      const localVarPath = `/administration/known-business-entities-sale-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntitySaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesSaleItemsDestroy", "id", id)
      const localVarPath = `/administration/known-business-entities-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/known-business-entities-sale-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {PatchedKnownBusinessEntitySaleItemRequest} [patchedKnownBusinessEntitySaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsPartialUpdate: async (
      id: string,
      patchedKnownBusinessEntitySaleItemRequest?: PatchedKnownBusinessEntitySaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesSaleItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/known-business-entities-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedKnownBusinessEntitySaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesSaleItemsRetrieve", "id", id)
      const localVarPath = `/administration/known-business-entities-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsUpdate: async (
      id: string,
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("knownBusinessEntitiesSaleItemsUpdate", "id", id)
      // verify required parameter 'knownBusinessEntitySaleItemRequest' is not null or undefined
      assertParamExists(
        "knownBusinessEntitiesSaleItemsUpdate",
        "knownBusinessEntitySaleItemRequest",
        knownBusinessEntitySaleItemRequest
      )
      const localVarPath = `/administration/known-business-entities-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        knownBusinessEntitySaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * KnownBusinessEntitiesSaleItemsApi - functional programming interface
 */
export const KnownBusinessEntitiesSaleItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    KnownBusinessEntitiesSaleItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsBulkCreateCreate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntitySaleItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsBulkCreateCreate(
          knownBusinessEntitySaleItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsBulkDeleteCreate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntitySaleItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsBulkDeleteCreate(
          knownBusinessEntitySaleItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsBulkUpdateUpdate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntitySaleItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsBulkUpdateUpdate(
          knownBusinessEntitySaleItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsCreate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntitySaleItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsCreate(
          knownBusinessEntitySaleItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedKnownBusinessEntitySaleItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {PatchedKnownBusinessEntitySaleItemRequest} [patchedKnownBusinessEntitySaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsPartialUpdate(
      id: string,
      patchedKnownBusinessEntitySaleItemRequest?: PatchedKnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntitySaleItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsPartialUpdate(
          id,
          patchedKnownBusinessEntitySaleItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntitySaleItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async knownBusinessEntitiesSaleItemsUpdate(
      id: string,
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnownBusinessEntitySaleItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.knownBusinessEntitiesSaleItemsUpdate(
          id,
          knownBusinessEntitySaleItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "KnownBusinessEntitiesSaleItemsApi.knownBusinessEntitiesSaleItemsUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * KnownBusinessEntitiesSaleItemsApi - factory interface
 */
export const KnownBusinessEntitiesSaleItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = KnownBusinessEntitiesSaleItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsBulkCreateCreate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntitySaleItem> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsBulkCreateCreate(knownBusinessEntitySaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsBulkDeleteCreate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntitySaleItem> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsBulkDeleteCreate(knownBusinessEntitySaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsBulkUpdateUpdate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntitySaleItem> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsBulkUpdateUpdate(knownBusinessEntitySaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsCreate(
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntitySaleItem> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsCreate(knownBusinessEntitySaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedKnownBusinessEntitySaleItemList> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {PatchedKnownBusinessEntitySaleItemRequest} [patchedKnownBusinessEntitySaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsPartialUpdate(
      id: string,
      patchedKnownBusinessEntitySaleItemRequest?: PatchedKnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntitySaleItem> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsPartialUpdate(
          id,
          patchedKnownBusinessEntitySaleItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntitySaleItem> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
     * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    knownBusinessEntitiesSaleItemsUpdate(
      id: string,
      knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<KnownBusinessEntitySaleItem> {
      return localVarFp
        .knownBusinessEntitiesSaleItemsUpdate(id, knownBusinessEntitySaleItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * KnownBusinessEntitiesSaleItemsApi - object-oriented interface
 */
export class KnownBusinessEntitiesSaleItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsBulkCreateCreate(
    knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsBulkCreateCreate(knownBusinessEntitySaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsBulkDeleteCreate(
    knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsBulkDeleteCreate(knownBusinessEntitySaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsBulkUpdateUpdate(
    knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsBulkUpdateUpdate(knownBusinessEntitySaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsCreate(
    knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsCreate(knownBusinessEntitySaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
   * @param {PatchedKnownBusinessEntitySaleItemRequest} [patchedKnownBusinessEntitySaleItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsPartialUpdate(
    id: string,
    patchedKnownBusinessEntitySaleItemRequest?: PatchedKnownBusinessEntitySaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsPartialUpdate(
        id,
        patchedKnownBusinessEntitySaleItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (bedrijf).
   * @param {KnownBusinessEntitySaleItemRequest} knownBusinessEntitySaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public knownBusinessEntitiesSaleItemsUpdate(
    id: string,
    knownBusinessEntitySaleItemRequest: KnownBusinessEntitySaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return KnownBusinessEntitiesSaleItemsApiFp(this.configuration)
      .knownBusinessEntitiesSaleItemsUpdate(id, knownBusinessEntitySaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * LocationsApi - axios parameter creator
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsBulkCreateCreate: async (
      locationRequest?: LocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/locations/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        locationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsBulkDeleteCreate: async (
      locationRequest?: LocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/locations/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        locationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsBulkUpdateUpdate: async (
      locationRequest?: LocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/locations/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        locationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsCreate: async (
      locationRequest?: LocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/locations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        locationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("locationsDestroy", "id", id)
      const localVarPath = `/core/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/locations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {PatchedLocationRequest} [patchedLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsPartialUpdate: async (
      id: string,
      patchedLocationRequest?: PatchedLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("locationsPartialUpdate", "id", id)
      const localVarPath = `/core/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("locationsRetrieve", "id", id)
      const localVarPath = `/core/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsUpdate: async (
      id: string,
      locationRequest?: LocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("locationsUpdate", "id", id)
      const localVarPath = `/core/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        locationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * LocationsApi - functional programming interface
 */
export const LocationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsBulkCreateCreate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsBulkCreateCreate(
        locationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsBulkDeleteCreate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsBulkDeleteCreate(
        locationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsBulkUpdateUpdate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsBulkUpdateUpdate(
        locationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsCreate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsCreate(
        locationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLocationList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {PatchedLocationRequest} [patchedLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsPartialUpdate(
      id: string,
      patchedLocationRequest?: PatchedLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsPartialUpdate(
        id,
        patchedLocationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsPartialUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsUpdate(
      id: string,
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.locationsUpdate(
        id,
        locationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LocationsApi.locationsUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * LocationsApi - factory interface
 */
export const LocationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = LocationsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsBulkCreateCreate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .locationsBulkCreateCreate(locationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsBulkDeleteCreate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .locationsBulkDeleteCreate(locationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsBulkUpdateUpdate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .locationsBulkUpdateUpdate(locationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsCreate(
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .locationsCreate(locationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.locationsDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedLocationList> {
      return localVarFp
        .locationsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {PatchedLocationRequest} [patchedLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsPartialUpdate(
      id: string,
      patchedLocationRequest?: PatchedLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .locationsPartialUpdate(id, patchedLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Location> {
      return localVarFp.locationsRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this locatie.
     * @param {LocationRequest} [locationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsUpdate(
      id: string,
      locationRequest?: LocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .locationsUpdate(id, locationRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * LocationsApi - object-oriented interface
 */
export class LocationsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {LocationRequest} [locationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsBulkCreateCreate(
    locationRequest?: LocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LocationsApiFp(this.configuration)
      .locationsBulkCreateCreate(locationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {LocationRequest} [locationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsBulkDeleteCreate(
    locationRequest?: LocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LocationsApiFp(this.configuration)
      .locationsBulkDeleteCreate(locationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {LocationRequest} [locationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsBulkUpdateUpdate(
    locationRequest?: LocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LocationsApiFp(this.configuration)
      .locationsBulkUpdateUpdate(locationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {LocationRequest} [locationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsCreate(locationRequest?: LocationRequest, options?: RawAxiosRequestConfig) {
    return LocationsApiFp(this.configuration)
      .locationsCreate(locationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this locatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return LocationsApiFp(this.configuration)
      .locationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return LocationsApiFp(this.configuration)
      .locationsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this locatie.
   * @param {PatchedLocationRequest} [patchedLocationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsPartialUpdate(
    id: string,
    patchedLocationRequest?: PatchedLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LocationsApiFp(this.configuration)
      .locationsPartialUpdate(id, patchedLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this locatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return LocationsApiFp(this.configuration)
      .locationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this locatie.
   * @param {LocationRequest} [locationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public locationsUpdate(
    id: string,
    locationRequest?: LocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LocationsApiFp(this.configuration)
      .locationsUpdate(id, locationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MachinesApi - axios parameter creator
 */
export const MachinesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesBulkCreateCreate: async (
      machineRequest: MachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'machineRequest' is not null or undefined
      assertParamExists("machinesBulkCreateCreate", "machineRequest", machineRequest)
      const localVarPath = `/planning/machines/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        machineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesBulkDeleteCreate: async (
      machineRequest: MachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'machineRequest' is not null or undefined
      assertParamExists("machinesBulkDeleteCreate", "machineRequest", machineRequest)
      const localVarPath = `/planning/machines/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        machineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesBulkUpdateUpdate: async (
      machineRequest: MachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'machineRequest' is not null or undefined
      assertParamExists("machinesBulkUpdateUpdate", "machineRequest", machineRequest)
      const localVarPath = `/planning/machines/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        machineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesCreate: async (
      machineRequest: MachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'machineRequest' is not null or undefined
      assertParamExists("machinesCreate", "machineRequest", machineRequest)
      const localVarPath = `/planning/machines/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        machineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("machinesDestroy", "id", id)
      const localVarPath = `/planning/machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/machines/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {PatchedMachineRequest} [patchedMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesPartialUpdate: async (
      id: string,
      patchedMachineRequest?: PatchedMachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("machinesPartialUpdate", "id", id)
      const localVarPath = `/planning/machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedMachineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("machinesRetrieve", "id", id)
      const localVarPath = `/planning/machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesUpdate: async (
      id: string,
      machineRequest: MachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("machinesUpdate", "id", id)
      // verify required parameter 'machineRequest' is not null or undefined
      assertParamExists("machinesUpdate", "machineRequest", machineRequest)
      const localVarPath = `/planning/machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        machineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MachinesApi - functional programming interface
 */
export const MachinesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MachinesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesBulkCreateCreate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Machine>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesBulkCreateCreate(
        machineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesBulkDeleteCreate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Machine>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesBulkDeleteCreate(
        machineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesBulkUpdateUpdate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Machine>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesBulkUpdateUpdate(
        machineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesCreate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Machine>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesCreate(
        machineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMachineList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {PatchedMachineRequest} [patchedMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesPartialUpdate(
      id: string,
      patchedMachineRequest?: PatchedMachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Machine>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesPartialUpdate(
        id,
        patchedMachineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesPartialUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Machine>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async machinesUpdate(
      id: string,
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Machine>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.machinesUpdate(
        id,
        machineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MachinesApi.machinesUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * MachinesApi - factory interface
 */
export const MachinesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MachinesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesBulkCreateCreate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Machine> {
      return localVarFp
        .machinesBulkCreateCreate(machineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesBulkDeleteCreate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Machine> {
      return localVarFp
        .machinesBulkDeleteCreate(machineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesBulkUpdateUpdate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Machine> {
      return localVarFp
        .machinesBulkUpdateUpdate(machineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesCreate(
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Machine> {
      return localVarFp
        .machinesCreate(machineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.machinesDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedMachineList> {
      return localVarFp
        .machinesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {PatchedMachineRequest} [patchedMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesPartialUpdate(
      id: string,
      patchedMachineRequest?: PatchedMachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Machine> {
      return localVarFp
        .machinesPartialUpdate(id, patchedMachineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Machine> {
      return localVarFp.machinesRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this machine.
     * @param {MachineRequest} machineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    machinesUpdate(
      id: string,
      machineRequest: MachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Machine> {
      return localVarFp
        .machinesUpdate(id, machineRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * MachinesApi - object-oriented interface
 */
export class MachinesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {MachineRequest} machineRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesBulkCreateCreate(machineRequest: MachineRequest, options?: RawAxiosRequestConfig) {
    return MachinesApiFp(this.configuration)
      .machinesBulkCreateCreate(machineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {MachineRequest} machineRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesBulkDeleteCreate(machineRequest: MachineRequest, options?: RawAxiosRequestConfig) {
    return MachinesApiFp(this.configuration)
      .machinesBulkDeleteCreate(machineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {MachineRequest} machineRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesBulkUpdateUpdate(machineRequest: MachineRequest, options?: RawAxiosRequestConfig) {
    return MachinesApiFp(this.configuration)
      .machinesBulkUpdateUpdate(machineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {MachineRequest} machineRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesCreate(machineRequest: MachineRequest, options?: RawAxiosRequestConfig) {
    return MachinesApiFp(this.configuration)
      .machinesCreate(machineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this machine.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return MachinesApiFp(this.configuration)
      .machinesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return MachinesApiFp(this.configuration)
      .machinesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this machine.
   * @param {PatchedMachineRequest} [patchedMachineRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesPartialUpdate(
    id: string,
    patchedMachineRequest?: PatchedMachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MachinesApiFp(this.configuration)
      .machinesPartialUpdate(id, patchedMachineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this machine.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return MachinesApiFp(this.configuration)
      .machinesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this machine.
   * @param {MachineRequest} machineRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public machinesUpdate(
    id: string,
    machineRequest: MachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MachinesApiFp(this.configuration)
      .machinesUpdate(id, machineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MessagesApi - axios parameter creator
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesBulkCreateCreate: async (
      messageRequest: MessageRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageRequest' is not null or undefined
      assertParamExists("messagesBulkCreateCreate", "messageRequest", messageRequest)
      const localVarPath = `/planning/messages/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        messageRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesBulkDeleteCreate: async (
      messageRequest: MessageRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageRequest' is not null or undefined
      assertParamExists("messagesBulkDeleteCreate", "messageRequest", messageRequest)
      const localVarPath = `/planning/messages/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        messageRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesBulkUpdateUpdate: async (
      messageRequest: MessageRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageRequest' is not null or undefined
      assertParamExists("messagesBulkUpdateUpdate", "messageRequest", messageRequest)
      const localVarPath = `/planning/messages/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        messageRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesCreate: async (
      messageRequest: MessageRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageRequest' is not null or undefined
      assertParamExists("messagesCreate", "messageRequest", messageRequest)
      const localVarPath = `/planning/messages/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        messageRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("messagesDestroy", "id", id)
      const localVarPath = `/planning/messages/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/messages/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {PatchedMessageRequest} [patchedMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesPartialUpdate: async (
      id: string,
      patchedMessageRequest?: PatchedMessageRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("messagesPartialUpdate", "id", id)
      const localVarPath = `/planning/messages/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedMessageRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("messagesRetrieve", "id", id)
      const localVarPath = `/planning/messages/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesUpdate: async (
      id: string,
      messageRequest: MessageRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("messagesUpdate", "id", id)
      // verify required parameter 'messageRequest' is not null or undefined
      assertParamExists("messagesUpdate", "messageRequest", messageRequest)
      const localVarPath = `/planning/messages/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        messageRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MessagesApi - functional programming interface
 */
export const MessagesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesBulkCreateCreate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesBulkCreateCreate(
        messageRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesBulkDeleteCreate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesBulkDeleteCreate(
        messageRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesBulkUpdateUpdate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesBulkUpdateUpdate(
        messageRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesCreate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesCreate(
        messageRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMessageList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {PatchedMessageRequest} [patchedMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesPartialUpdate(
      id: string,
      patchedMessageRequest?: PatchedMessageRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesPartialUpdate(
        id,
        patchedMessageRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesPartialUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async messagesUpdate(
      id: string,
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.messagesUpdate(
        id,
        messageRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.messagesUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * MessagesApi - factory interface
 */
export const MessagesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MessagesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesBulkCreateCreate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Message> {
      return localVarFp
        .messagesBulkCreateCreate(messageRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesBulkDeleteCreate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Message> {
      return localVarFp
        .messagesBulkDeleteCreate(messageRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesBulkUpdateUpdate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Message> {
      return localVarFp
        .messagesBulkUpdateUpdate(messageRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesCreate(
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Message> {
      return localVarFp
        .messagesCreate(messageRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.messagesDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedMessageList> {
      return localVarFp
        .messagesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {PatchedMessageRequest} [patchedMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesPartialUpdate(
      id: string,
      patchedMessageRequest?: PatchedMessageRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Message> {
      return localVarFp
        .messagesPartialUpdate(id, patchedMessageRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
      return localVarFp.messagesRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this boodschap.
     * @param {MessageRequest} messageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    messagesUpdate(
      id: string,
      messageRequest: MessageRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Message> {
      return localVarFp
        .messagesUpdate(id, messageRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * MessagesApi - object-oriented interface
 */
export class MessagesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {MessageRequest} messageRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesBulkCreateCreate(messageRequest: MessageRequest, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .messagesBulkCreateCreate(messageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {MessageRequest} messageRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesBulkDeleteCreate(messageRequest: MessageRequest, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .messagesBulkDeleteCreate(messageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {MessageRequest} messageRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesBulkUpdateUpdate(messageRequest: MessageRequest, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .messagesBulkUpdateUpdate(messageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {MessageRequest} messageRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesCreate(messageRequest: MessageRequest, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .messagesCreate(messageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this boodschap.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .messagesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return MessagesApiFp(this.configuration)
      .messagesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this boodschap.
   * @param {PatchedMessageRequest} [patchedMessageRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesPartialUpdate(
    id: string,
    patchedMessageRequest?: PatchedMessageRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MessagesApiFp(this.configuration)
      .messagesPartialUpdate(id, patchedMessageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this boodschap.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .messagesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this boodschap.
   * @param {MessageRequest} messageRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public messagesUpdate(
    id: string,
    messageRequest: MessageRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MessagesApiFp(this.configuration)
      .messagesUpdate(id, messageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * OrdersApi - axios parameter creator
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersBulkCreateCreate: async (
      orderRequest: OrderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderRequest' is not null or undefined
      assertParamExists("ordersBulkCreateCreate", "orderRequest", orderRequest)
      const localVarPath = `/planning/orders/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersBulkDeleteCreate: async (
      orderRequest: OrderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderRequest' is not null or undefined
      assertParamExists("ordersBulkDeleteCreate", "orderRequest", orderRequest)
      const localVarPath = `/planning/orders/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersBulkUpdateUpdate: async (
      orderRequest: OrderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderRequest' is not null or undefined
      assertParamExists("ordersBulkUpdateUpdate", "orderRequest", orderRequest)
      const localVarPath = `/planning/orders/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersCreate: async (
      orderRequest: OrderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderRequest' is not null or undefined
      assertParamExists("ordersCreate", "orderRequest", orderRequest)
      const localVarPath = `/planning/orders/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("ordersDestroy", "id", id)
      const localVarPath = `/planning/orders/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/orders/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersMergeCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/planning/orders/merge/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {PatchedOrderRequest} [patchedOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersPartialUpdate: async (
      id: string,
      patchedOrderRequest?: PatchedOrderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("ordersPartialUpdate", "id", id)
      const localVarPath = `/planning/orders/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedOrderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("ordersRetrieve", "id", id)
      const localVarPath = `/planning/orders/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Overide the update method to prevent returning serializer.data, which takes a lot of time to serialize
     * @param {string} id A UUID string identifying this order.
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersUpdate: async (
      id: string,
      orderRequest: OrderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("ordersUpdate", "id", id)
      // verify required parameter 'orderRequest' is not null or undefined
      assertParamExists("ordersUpdate", "orderRequest", orderRequest)
      const localVarPath = `/planning/orders/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        orderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * OrdersApi - functional programming interface
 */
export const OrdersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersBulkCreateCreate(
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersBulkCreateCreate(
        orderRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersBulkCreateCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersBulkDeleteCreate(
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersBulkDeleteCreate(
        orderRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersBulkDeleteCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersBulkUpdateUpdate(
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersBulkUpdateUpdate(
        orderRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersBulkUpdateUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersCreate(
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersCreate(orderRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOrderReadList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersMergeCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersMergeCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersMergeCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {PatchedOrderRequest} [patchedOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersPartialUpdate(
      id: string,
      patchedOrderRequest?: PatchedOrderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersPartialUpdate(
        id,
        patchedOrderRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersPartialUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Overide the update method to prevent returning serializer.data, which takes a lot of time to serialize
     * @param {string} id A UUID string identifying this order.
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersUpdate(
      id: string,
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ordersUpdate(
        id,
        orderRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OrdersApi.ordersUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * OrdersApi - factory interface
 */
export const OrdersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = OrdersApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersBulkCreateCreate(
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Order> {
      return localVarFp
        .ordersBulkCreateCreate(orderRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersBulkDeleteCreate(
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Order> {
      return localVarFp
        .ordersBulkDeleteCreate(orderRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersBulkUpdateUpdate(
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Order> {
      return localVarFp
        .ordersBulkUpdateUpdate(orderRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersCreate(orderRequest: OrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Order> {
      return localVarFp
        .ordersCreate(orderRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.ordersDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedOrderReadList> {
      return localVarFp
        .ordersList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersMergeCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.ordersMergeCreate(options).then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {PatchedOrderRequest} [patchedOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersPartialUpdate(
      id: string,
      patchedOrderRequest?: PatchedOrderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Order> {
      return localVarFp
        .ordersPartialUpdate(id, patchedOrderRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderRead> {
      return localVarFp.ordersRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Overide the update method to prevent returning serializer.data, which takes a lot of time to serialize
     * @param {string} id A UUID string identifying this order.
     * @param {OrderRequest} orderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersUpdate(
      id: string,
      orderRequest: OrderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Order> {
      return localVarFp
        .ordersUpdate(id, orderRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * OrdersApi - object-oriented interface
 */
export class OrdersApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {OrderRequest} orderRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersBulkCreateCreate(orderRequest: OrderRequest, options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersBulkCreateCreate(orderRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {OrderRequest} orderRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersBulkDeleteCreate(orderRequest: OrderRequest, options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersBulkDeleteCreate(orderRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {OrderRequest} orderRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersBulkUpdateUpdate(orderRequest: OrderRequest, options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersBulkUpdateUpdate(orderRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {OrderRequest} orderRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersCreate(orderRequest: OrderRequest, options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersCreate(orderRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this order.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersDestroy(id: string, options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return OrdersApiFp(this.configuration)
      .ordersList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersMergeCreate(options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersMergeCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this order.
   * @param {PatchedOrderRequest} [patchedOrderRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersPartialUpdate(
    id: string,
    patchedOrderRequest?: PatchedOrderRequest,
    options?: RawAxiosRequestConfig
  ) {
    return OrdersApiFp(this.configuration)
      .ordersPartialUpdate(id, patchedOrderRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this order.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Overide the update method to prevent returning serializer.data, which takes a lot of time to serialize
   * @param {string} id A UUID string identifying this order.
   * @param {OrderRequest} orderRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ordersUpdate(id: string, orderRequest: OrderRequest, options?: RawAxiosRequestConfig) {
    return OrdersApiFp(this.configuration)
      .ordersUpdate(id, orderRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PersonsApi - axios parameter creator
 */
export const PersonsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsBulkCreateCreate: async (
      personRequest: PersonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personRequest' is not null or undefined
      assertParamExists("personsBulkCreateCreate", "personRequest", personRequest)
      const localVarPath = `/core/persons/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        personRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsBulkDeleteCreate: async (
      personRequest: PersonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personRequest' is not null or undefined
      assertParamExists("personsBulkDeleteCreate", "personRequest", personRequest)
      const localVarPath = `/core/persons/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        personRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsBulkUpdateUpdate: async (
      personRequest: PersonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personRequest' is not null or undefined
      assertParamExists("personsBulkUpdateUpdate", "personRequest", personRequest)
      const localVarPath = `/core/persons/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        personRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsCreate: async (
      personRequest: PersonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personRequest' is not null or undefined
      assertParamExists("personsCreate", "personRequest", personRequest)
      const localVarPath = `/core/persons/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        personRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("personsDestroy", "id", id)
      const localVarPath = `/core/persons/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/persons/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {PatchedPersonRequest} [patchedPersonRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsPartialUpdate: async (
      id: string,
      patchedPersonRequest?: PatchedPersonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("personsPartialUpdate", "id", id)
      const localVarPath = `/core/persons/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedPersonRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("personsRetrieve", "id", id)
      const localVarPath = `/core/persons/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsUpdate: async (
      id: string,
      personRequest: PersonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("personsUpdate", "id", id)
      // verify required parameter 'personRequest' is not null or undefined
      assertParamExists("personsUpdate", "personRequest", personRequest)
      const localVarPath = `/core/persons/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        personRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PersonsApi - functional programming interface
 */
export const PersonsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PersonsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsBulkCreateCreate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsBulkCreateCreate(
        personRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsBulkDeleteCreate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsBulkDeleteCreate(
        personRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsBulkUpdateUpdate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsBulkUpdateUpdate(
        personRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsCreate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsCreate(
        personRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPersonList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {PatchedPersonRequest} [patchedPersonRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsPartialUpdate(
      id: string,
      patchedPersonRequest?: PatchedPersonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsPartialUpdate(
        id,
        patchedPersonRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsPartialUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personsUpdate(
      id: string,
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.personsUpdate(
        id,
        personRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PersonsApi.personsUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PersonsApi - factory interface
 */
export const PersonsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PersonsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsBulkCreateCreate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Person> {
      return localVarFp
        .personsBulkCreateCreate(personRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsBulkDeleteCreate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Person> {
      return localVarFp
        .personsBulkDeleteCreate(personRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsBulkUpdateUpdate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Person> {
      return localVarFp
        .personsBulkUpdateUpdate(personRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsCreate(
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Person> {
      return localVarFp
        .personsCreate(personRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.personsDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedPersonList> {
      return localVarFp
        .personsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {PatchedPersonRequest} [patchedPersonRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsPartialUpdate(
      id: string,
      patchedPersonRequest?: PatchedPersonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Person> {
      return localVarFp
        .personsPartialUpdate(id, patchedPersonRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Person> {
      return localVarFp.personsRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this person.
     * @param {PersonRequest} personRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personsUpdate(
      id: string,
      personRequest: PersonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Person> {
      return localVarFp
        .personsUpdate(id, personRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * PersonsApi - object-oriented interface
 */
export class PersonsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PersonRequest} personRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsBulkCreateCreate(personRequest: PersonRequest, options?: RawAxiosRequestConfig) {
    return PersonsApiFp(this.configuration)
      .personsBulkCreateCreate(personRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PersonRequest} personRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsBulkDeleteCreate(personRequest: PersonRequest, options?: RawAxiosRequestConfig) {
    return PersonsApiFp(this.configuration)
      .personsBulkDeleteCreate(personRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PersonRequest} personRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsBulkUpdateUpdate(personRequest: PersonRequest, options?: RawAxiosRequestConfig) {
    return PersonsApiFp(this.configuration)
      .personsBulkUpdateUpdate(personRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {PersonRequest} personRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsCreate(personRequest: PersonRequest, options?: RawAxiosRequestConfig) {
    return PersonsApiFp(this.configuration)
      .personsCreate(personRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this person.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return PersonsApiFp(this.configuration)
      .personsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return PersonsApiFp(this.configuration)
      .personsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this person.
   * @param {PatchedPersonRequest} [patchedPersonRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsPartialUpdate(
    id: string,
    patchedPersonRequest?: PatchedPersonRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PersonsApiFp(this.configuration)
      .personsPartialUpdate(id, patchedPersonRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this person.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return PersonsApiFp(this.configuration)
      .personsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this person.
   * @param {PersonRequest} personRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public personsUpdate(id: string, personRequest: PersonRequest, options?: RawAxiosRequestConfig) {
    return PersonsApiFp(this.configuration)
      .personsUpdate(id, personRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProductsApi - axios parameter creator
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/products/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("productsRetrieve", "id", id)
      const localVarPath = `/planning/products/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProductsApi - functional programming interface
 */
export const ProductsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProductList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.productsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.productsRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProductsApi - factory interface
 */
export const ProductsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProductsApiFp(configuration)
  return {
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProductList> {
      return localVarFp
        .productsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Product> {
      return localVarFp.productsRetrieve(id, options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * ProductsApi - object-oriented interface
 */
export class ProductsApi extends BaseAPI {
  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public productsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ProductsApiFp(this.configuration)
      .productsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this product.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public productsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ProductsApiFp(this.configuration)
      .productsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectsApi - axios parameter creator
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsBulkCreateCreate: async (
      projectRequest: ProjectRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRequest' is not null or undefined
      assertParamExists("projectsBulkCreateCreate", "projectRequest", projectRequest)
      const localVarPath = `/core/projects/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsBulkDeleteCreate: async (
      projectRequest: ProjectRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRequest' is not null or undefined
      assertParamExists("projectsBulkDeleteCreate", "projectRequest", projectRequest)
      const localVarPath = `/core/projects/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsBulkUpdateUpdate: async (
      projectRequest: ProjectRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRequest' is not null or undefined
      assertParamExists("projectsBulkUpdateUpdate", "projectRequest", projectRequest)
      const localVarPath = `/core/projects/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCreate: async (
      projectRequest: ProjectRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRequest' is not null or undefined
      assertParamExists("projectsCreate", "projectRequest", projectRequest)
      const localVarPath = `/core/projects/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsDestroy", "id", id)
      const localVarPath = `/core/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/projects/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {PatchedProjectRequest} [patchedProjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPartialUpdate: async (
      id: string,
      patchedProjectRequest?: PatchedProjectRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsPartialUpdate", "id", id)
      const localVarPath = `/core/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedProjectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRetrieve", "id", id)
      const localVarPath = `/core/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUpdate: async (
      id: string,
      projectRequest: ProjectRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsUpdate", "id", id)
      // verify required parameter 'projectRequest' is not null or undefined
      assertParamExists("projectsUpdate", "projectRequest", projectRequest)
      const localVarPath = `/core/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProjectsApi - functional programming interface
 */
export const ProjectsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsBulkCreateCreate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsBulkCreateCreate(
        projectRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsBulkDeleteCreate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsBulkDeleteCreate(
        projectRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsBulkUpdateUpdate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsBulkUpdateUpdate(
        projectRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsCreate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsCreate(
        projectRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProjectList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {PatchedProjectRequest} [patchedProjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPartialUpdate(
      id: string,
      patchedProjectRequest?: PatchedProjectRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPartialUpdate(
        id,
        patchedProjectRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsPartialUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsUpdate(
      id: string,
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsUpdate(
        id,
        projectRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsApi.projectsUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProjectsApi - factory interface
 */
export const ProjectsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsBulkCreateCreate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .projectsBulkCreateCreate(projectRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsBulkDeleteCreate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .projectsBulkDeleteCreate(projectRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsBulkUpdateUpdate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .projectsBulkUpdateUpdate(projectRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCreate(
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .projectsCreate(projectRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.projectsDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProjectList> {
      return localVarFp
        .projectsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {PatchedProjectRequest} [patchedProjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPartialUpdate(
      id: string,
      patchedProjectRequest?: PatchedProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .projectsPartialUpdate(id, patchedProjectRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Project> {
      return localVarFp.projectsRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this project.
     * @param {ProjectRequest} projectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsUpdate(
      id: string,
      projectRequest: ProjectRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .projectsUpdate(id, projectRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ProjectsApi - object-oriented interface
 */
export class ProjectsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRequest} projectRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsBulkCreateCreate(projectRequest: ProjectRequest, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsBulkCreateCreate(projectRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRequest} projectRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsBulkDeleteCreate(projectRequest: ProjectRequest, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsBulkDeleteCreate(projectRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRequest} projectRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsBulkUpdateUpdate(projectRequest: ProjectRequest, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsBulkUpdateUpdate(projectRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {ProjectRequest} projectRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsCreate(projectRequest: ProjectRequest, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsCreate(projectRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this project.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this project.
   * @param {PatchedProjectRequest} [patchedProjectRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPartialUpdate(
    id: string,
    patchedProjectRequest?: PatchedProjectRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsPartialUpdate(id, patchedProjectRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this project.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this project.
   * @param {ProjectRequest} projectRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsUpdate(
    id: string,
    projectRequest: ProjectRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsUpdate(id, projectRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectsPurchaseItemsApi - axios parameter creator
 */
export const ProjectsPurchaseItemsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsBulkCreateCreate: async (
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectPurchaseItemRequest' is not null or undefined
      assertParamExists(
        "projectsPurchaseItemsBulkCreateCreate",
        "projectPurchaseItemRequest",
        projectPurchaseItemRequest
      )
      const localVarPath = `/administration/projects-purchase-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectPurchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsBulkDeleteCreate: async (
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectPurchaseItemRequest' is not null or undefined
      assertParamExists(
        "projectsPurchaseItemsBulkDeleteCreate",
        "projectPurchaseItemRequest",
        projectPurchaseItemRequest
      )
      const localVarPath = `/administration/projects-purchase-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectPurchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsBulkUpdateUpdate: async (
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectPurchaseItemRequest' is not null or undefined
      assertParamExists(
        "projectsPurchaseItemsBulkUpdateUpdate",
        "projectPurchaseItemRequest",
        projectPurchaseItemRequest
      )
      const localVarPath = `/administration/projects-purchase-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectPurchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsCreate: async (
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectPurchaseItemRequest' is not null or undefined
      assertParamExists(
        "projectsPurchaseItemsCreate",
        "projectPurchaseItemRequest",
        projectPurchaseItemRequest
      )
      const localVarPath = `/administration/projects-purchase-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectPurchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsPurchaseItemsDestroy", "id", id)
      const localVarPath = `/administration/projects-purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/projects-purchase-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {PatchedProjectPurchaseItemRequest} [patchedProjectPurchaseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsPartialUpdate: async (
      id: string,
      patchedProjectPurchaseItemRequest?: PatchedProjectPurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsPurchaseItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/projects-purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedProjectPurchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsPurchaseItemsRetrieve", "id", id)
      const localVarPath = `/administration/projects-purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsUpdate: async (
      id: string,
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsPurchaseItemsUpdate", "id", id)
      // verify required parameter 'projectPurchaseItemRequest' is not null or undefined
      assertParamExists(
        "projectsPurchaseItemsUpdate",
        "projectPurchaseItemRequest",
        projectPurchaseItemRequest
      )
      const localVarPath = `/administration/projects-purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectPurchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProjectsPurchaseItemsApi - functional programming interface
 */
export const ProjectsPurchaseItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsPurchaseItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsBulkCreateCreate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPurchaseItem>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsPurchaseItemsBulkCreateCreate(
          projectPurchaseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsBulkDeleteCreate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPurchaseItem>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsPurchaseItemsBulkDeleteCreate(
          projectPurchaseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsBulkUpdateUpdate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPurchaseItem>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsPurchaseItemsBulkUpdateUpdate(
          projectPurchaseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsCreate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPurchaseItemsCreate(
        projectPurchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPurchaseItemsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProjectPurchaseItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPurchaseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {PatchedProjectPurchaseItemRequest} [patchedProjectPurchaseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsPartialUpdate(
      id: string,
      patchedProjectPurchaseItemRequest?: PatchedProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPurchaseItemsPartialUpdate(
        id,
        patchedProjectPurchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPurchaseItemsRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPurchaseItemsUpdate(
      id: string,
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPurchaseItemsUpdate(
        id,
        projectPurchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsPurchaseItemsApi.projectsPurchaseItemsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProjectsPurchaseItemsApi - factory interface
 */
export const ProjectsPurchaseItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectsPurchaseItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsBulkCreateCreate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectPurchaseItem> {
      return localVarFp
        .projectsPurchaseItemsBulkCreateCreate(projectPurchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsBulkDeleteCreate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectPurchaseItem> {
      return localVarFp
        .projectsPurchaseItemsBulkDeleteCreate(projectPurchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsBulkUpdateUpdate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectPurchaseItem> {
      return localVarFp
        .projectsPurchaseItemsBulkUpdateUpdate(projectPurchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsCreate(
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectPurchaseItem> {
      return localVarFp
        .projectsPurchaseItemsCreate(projectPurchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .projectsPurchaseItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProjectPurchaseItemList> {
      return localVarFp
        .projectsPurchaseItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {PatchedProjectPurchaseItemRequest} [patchedProjectPurchaseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsPartialUpdate(
      id: string,
      patchedProjectPurchaseItemRequest?: PatchedProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectPurchaseItem> {
      return localVarFp
        .projectsPurchaseItemsPartialUpdate(id, patchedProjectPurchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectPurchaseItem> {
      return localVarFp
        .projectsPurchaseItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
     * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPurchaseItemsUpdate(
      id: string,
      projectPurchaseItemRequest: ProjectPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectPurchaseItem> {
      return localVarFp
        .projectsPurchaseItemsUpdate(id, projectPurchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ProjectsPurchaseItemsApi - object-oriented interface
 */
export class ProjectsPurchaseItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsBulkCreateCreate(
    projectPurchaseItemRequest: ProjectPurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsBulkCreateCreate(projectPurchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsBulkDeleteCreate(
    projectPurchaseItemRequest: ProjectPurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsBulkDeleteCreate(projectPurchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsBulkUpdateUpdate(
    projectPurchaseItemRequest: ProjectPurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsBulkUpdateUpdate(projectPurchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsCreate(
    projectPurchaseItemRequest: ProjectPurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsCreate(projectPurchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
   * @param {PatchedProjectPurchaseItemRequest} [patchedProjectPurchaseItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsPartialUpdate(
    id: string,
    patchedProjectPurchaseItemRequest?: PatchedProjectPurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsPartialUpdate(id, patchedProjectPurchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inkoopprijsafspraak (project).
   * @param {ProjectPurchaseItemRequest} projectPurchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsPurchaseItemsUpdate(
    id: string,
    projectPurchaseItemRequest: ProjectPurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsPurchaseItemsApiFp(this.configuration)
      .projectsPurchaseItemsUpdate(id, projectPurchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectsRentalDispenseItemsApi - axios parameter creator
 */
export const ProjectsRentalDispenseItemsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsBulkCreateCreate: async (
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalDispenseItemsBulkCreateCreate",
        "projectRentalDispenseItemRequest",
        projectRentalDispenseItemRequest
      )
      const localVarPath = `/administration/projects-rental-dispense-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsBulkDeleteCreate: async (
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalDispenseItemsBulkDeleteCreate",
        "projectRentalDispenseItemRequest",
        projectRentalDispenseItemRequest
      )
      const localVarPath = `/administration/projects-rental-dispense-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsBulkUpdateUpdate: async (
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalDispenseItemsBulkUpdateUpdate",
        "projectRentalDispenseItemRequest",
        projectRentalDispenseItemRequest
      )
      const localVarPath = `/administration/projects-rental-dispense-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsCreate: async (
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalDispenseItemsCreate",
        "projectRentalDispenseItemRequest",
        projectRentalDispenseItemRequest
      )
      const localVarPath = `/administration/projects-rental-dispense-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalDispenseItemsDestroy", "id", id)
      const localVarPath = `/administration/projects-rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/projects-rental-dispense-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {PatchedProjectRentalDispenseItemRequest} [patchedProjectRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsPartialUpdate: async (
      id: string,
      patchedProjectRentalDispenseItemRequest?: PatchedProjectRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalDispenseItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/projects-rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedProjectRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalDispenseItemsRetrieve", "id", id)
      const localVarPath = `/administration/projects-rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsUpdate: async (
      id: string,
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalDispenseItemsUpdate", "id", id)
      // verify required parameter 'projectRentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalDispenseItemsUpdate",
        "projectRentalDispenseItemRequest",
        projectRentalDispenseItemRequest
      )
      const localVarPath = `/administration/projects-rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProjectsRentalDispenseItemsApi - functional programming interface
 */
export const ProjectsRentalDispenseItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsRentalDispenseItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsBulkCreateCreate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalDispenseItemsBulkCreateCreate(
          projectRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsBulkDeleteCreate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalDispenseItemsBulkDeleteCreate(
          projectRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsBulkUpdateUpdate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalDispenseItemsBulkUpdateUpdate(
          projectRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsCreate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalDispenseItem>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalDispenseItemsCreate(
        projectRentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalDispenseItemsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedProjectRentalDispenseItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalDispenseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {PatchedProjectRentalDispenseItemRequest} [patchedProjectRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsPartialUpdate(
      id: string,
      patchedProjectRentalDispenseItemRequest?: PatchedProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalDispenseItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalDispenseItemsPartialUpdate(
          id,
          patchedProjectRentalDispenseItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalDispenseItem>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalDispenseItemsRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalDispenseItemsUpdate(
      id: string,
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalDispenseItem>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalDispenseItemsUpdate(
        id,
        projectRentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalDispenseItemsApi.projectsRentalDispenseItemsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProjectsRentalDispenseItemsApi - factory interface
 */
export const ProjectsRentalDispenseItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectsRentalDispenseItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsBulkCreateCreate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalDispenseItem> {
      return localVarFp
        .projectsRentalDispenseItemsBulkCreateCreate(projectRentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsBulkDeleteCreate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalDispenseItem> {
      return localVarFp
        .projectsRentalDispenseItemsBulkDeleteCreate(projectRentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsBulkUpdateUpdate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalDispenseItem> {
      return localVarFp
        .projectsRentalDispenseItemsBulkUpdateUpdate(projectRentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsCreate(
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalDispenseItem> {
      return localVarFp
        .projectsRentalDispenseItemsCreate(projectRentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .projectsRentalDispenseItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProjectRentalDispenseItemList> {
      return localVarFp
        .projectsRentalDispenseItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {PatchedProjectRentalDispenseItemRequest} [patchedProjectRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsPartialUpdate(
      id: string,
      patchedProjectRentalDispenseItemRequest?: PatchedProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalDispenseItem> {
      return localVarFp
        .projectsRentalDispenseItemsPartialUpdate(
          id,
          patchedProjectRentalDispenseItemRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalDispenseItem> {
      return localVarFp
        .projectsRentalDispenseItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
     * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalDispenseItemsUpdate(
      id: string,
      projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalDispenseItem> {
      return localVarFp
        .projectsRentalDispenseItemsUpdate(id, projectRentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ProjectsRentalDispenseItemsApi - object-oriented interface
 */
export class ProjectsRentalDispenseItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsBulkCreateCreate(
    projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsBulkCreateCreate(projectRentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsBulkDeleteCreate(
    projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsBulkDeleteCreate(projectRentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsBulkUpdateUpdate(
    projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsBulkUpdateUpdate(projectRentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsCreate(
    projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsCreate(projectRentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
   * @param {PatchedProjectRentalDispenseItemRequest} [patchedProjectRentalDispenseItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsPartialUpdate(
    id: string,
    patchedProjectRentalDispenseItemRequest?: PatchedProjectRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsPartialUpdate(
        id,
        patchedProjectRentalDispenseItemRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Verhuurprijsafspraak (project).
   * @param {ProjectRentalDispenseItemRequest} projectRentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalDispenseItemsUpdate(
    id: string,
    projectRentalDispenseItemRequest: ProjectRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalDispenseItemsApiFp(this.configuration)
      .projectsRentalDispenseItemsUpdate(id, projectRentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectsRentalIntakeItemsApi - axios parameter creator
 */
export const ProjectsRentalIntakeItemsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsBulkCreateCreate: async (
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalIntakeItemsBulkCreateCreate",
        "projectRentalIntakeItemRequest",
        projectRentalIntakeItemRequest
      )
      const localVarPath = `/administration/projects-rental-intake-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsBulkDeleteCreate: async (
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalIntakeItemsBulkDeleteCreate",
        "projectRentalIntakeItemRequest",
        projectRentalIntakeItemRequest
      )
      const localVarPath = `/administration/projects-rental-intake-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsBulkUpdateUpdate: async (
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalIntakeItemsBulkUpdateUpdate",
        "projectRentalIntakeItemRequest",
        projectRentalIntakeItemRequest
      )
      const localVarPath = `/administration/projects-rental-intake-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsCreate: async (
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectRentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalIntakeItemsCreate",
        "projectRentalIntakeItemRequest",
        projectRentalIntakeItemRequest
      )
      const localVarPath = `/administration/projects-rental-intake-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalIntakeItemsDestroy", "id", id)
      const localVarPath = `/administration/projects-rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/projects-rental-intake-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {PatchedProjectRentalIntakeItemRequest} [patchedProjectRentalIntakeItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsPartialUpdate: async (
      id: string,
      patchedProjectRentalIntakeItemRequest?: PatchedProjectRentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalIntakeItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/projects-rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedProjectRentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalIntakeItemsRetrieve", "id", id)
      const localVarPath = `/administration/projects-rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsUpdate: async (
      id: string,
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsRentalIntakeItemsUpdate", "id", id)
      // verify required parameter 'projectRentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "projectsRentalIntakeItemsUpdate",
        "projectRentalIntakeItemRequest",
        projectRentalIntakeItemRequest
      )
      const localVarPath = `/administration/projects-rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectRentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProjectsRentalIntakeItemsApi - functional programming interface
 */
export const ProjectsRentalIntakeItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsRentalIntakeItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsBulkCreateCreate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalIntakeItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalIntakeItemsBulkCreateCreate(
          projectRentalIntakeItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsBulkDeleteCreate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalIntakeItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalIntakeItemsBulkDeleteCreate(
          projectRentalIntakeItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsBulkUpdateUpdate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalIntakeItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalIntakeItemsBulkUpdateUpdate(
          projectRentalIntakeItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsCreate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalIntakeItem>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalIntakeItemsCreate(
        projectRentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalIntakeItemsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedProjectRentalIntakeItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalIntakeItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {PatchedProjectRentalIntakeItemRequest} [patchedProjectRentalIntakeItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsPartialUpdate(
      id: string,
      patchedProjectRentalIntakeItemRequest?: PatchedProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalIntakeItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.projectsRentalIntakeItemsPartialUpdate(
          id,
          patchedProjectRentalIntakeItemRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalIntakeItem>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalIntakeItemsRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsRentalIntakeItemsUpdate(
      id: string,
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRentalIntakeItem>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsRentalIntakeItemsUpdate(
        id,
        projectRentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsRentalIntakeItemsApi.projectsRentalIntakeItemsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProjectsRentalIntakeItemsApi - factory interface
 */
export const ProjectsRentalIntakeItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectsRentalIntakeItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsBulkCreateCreate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalIntakeItem> {
      return localVarFp
        .projectsRentalIntakeItemsBulkCreateCreate(projectRentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsBulkDeleteCreate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalIntakeItem> {
      return localVarFp
        .projectsRentalIntakeItemsBulkDeleteCreate(projectRentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsBulkUpdateUpdate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalIntakeItem> {
      return localVarFp
        .projectsRentalIntakeItemsBulkUpdateUpdate(projectRentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsCreate(
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalIntakeItem> {
      return localVarFp
        .projectsRentalIntakeItemsCreate(projectRentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .projectsRentalIntakeItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProjectRentalIntakeItemList> {
      return localVarFp
        .projectsRentalIntakeItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {PatchedProjectRentalIntakeItemRequest} [patchedProjectRentalIntakeItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsPartialUpdate(
      id: string,
      patchedProjectRentalIntakeItemRequest?: PatchedProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalIntakeItem> {
      return localVarFp
        .projectsRentalIntakeItemsPartialUpdate(id, patchedProjectRentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalIntakeItem> {
      return localVarFp
        .projectsRentalIntakeItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
     * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsRentalIntakeItemsUpdate(
      id: string,
      projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectRentalIntakeItem> {
      return localVarFp
        .projectsRentalIntakeItemsUpdate(id, projectRentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ProjectsRentalIntakeItemsApi - object-oriented interface
 */
export class ProjectsRentalIntakeItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsBulkCreateCreate(
    projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsBulkCreateCreate(projectRentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsBulkDeleteCreate(
    projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsBulkDeleteCreate(projectRentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsBulkUpdateUpdate(
    projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsBulkUpdateUpdate(projectRentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsCreate(
    projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsCreate(projectRentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
   * @param {PatchedProjectRentalIntakeItemRequest} [patchedProjectRentalIntakeItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsPartialUpdate(
    id: string,
    patchedProjectRentalIntakeItemRequest?: PatchedProjectRentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsPartialUpdate(id, patchedProjectRentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inhuurprijsafspraak (project).
   * @param {ProjectRentalIntakeItemRequest} projectRentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsRentalIntakeItemsUpdate(
    id: string,
    projectRentalIntakeItemRequest: ProjectRentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsRentalIntakeItemsApiFp(this.configuration)
      .projectsRentalIntakeItemsUpdate(id, projectRentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProjectsSaleItemsApi - axios parameter creator
 */
export const ProjectsSaleItemsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsBulkCreateCreate: async (
      projectSaleItemRequest: ProjectSaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectSaleItemRequest' is not null or undefined
      assertParamExists(
        "projectsSaleItemsBulkCreateCreate",
        "projectSaleItemRequest",
        projectSaleItemRequest
      )
      const localVarPath = `/administration/projects-sale-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectSaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsBulkDeleteCreate: async (
      projectSaleItemRequest: ProjectSaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectSaleItemRequest' is not null or undefined
      assertParamExists(
        "projectsSaleItemsBulkDeleteCreate",
        "projectSaleItemRequest",
        projectSaleItemRequest
      )
      const localVarPath = `/administration/projects-sale-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectSaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsBulkUpdateUpdate: async (
      projectSaleItemRequest: ProjectSaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectSaleItemRequest' is not null or undefined
      assertParamExists(
        "projectsSaleItemsBulkUpdateUpdate",
        "projectSaleItemRequest",
        projectSaleItemRequest
      )
      const localVarPath = `/administration/projects-sale-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectSaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsCreate: async (
      projectSaleItemRequest: ProjectSaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectSaleItemRequest' is not null or undefined
      assertParamExists("projectsSaleItemsCreate", "projectSaleItemRequest", projectSaleItemRequest)
      const localVarPath = `/administration/projects-sale-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectSaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsSaleItemsDestroy", "id", id)
      const localVarPath = `/administration/projects-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/projects-sale-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {PatchedProjectSaleItemRequest} [patchedProjectSaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsPartialUpdate: async (
      id: string,
      patchedProjectSaleItemRequest?: PatchedProjectSaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsSaleItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/projects-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedProjectSaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsSaleItemsRetrieve", "id", id)
      const localVarPath = `/administration/projects-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsUpdate: async (
      id: string,
      projectSaleItemRequest: ProjectSaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("projectsSaleItemsUpdate", "id", id)
      // verify required parameter 'projectSaleItemRequest' is not null or undefined
      assertParamExists("projectsSaleItemsUpdate", "projectSaleItemRequest", projectSaleItemRequest)
      const localVarPath = `/administration/projects-sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectSaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ProjectsSaleItemsApi - functional programming interface
 */
export const ProjectsSaleItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsSaleItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsBulkCreateCreate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsBulkCreateCreate(
        projectSaleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsBulkDeleteCreate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsBulkDeleteCreate(
        projectSaleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsBulkUpdateUpdate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsBulkUpdateUpdate(
        projectSaleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsCreate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsCreate(
        projectSaleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProjectSaleItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {PatchedProjectSaleItemRequest} [patchedProjectSaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsPartialUpdate(
      id: string,
      patchedProjectSaleItemRequest?: PatchedProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsPartialUpdate(
        id,
        patchedProjectSaleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsSaleItemsUpdate(
      id: string,
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsSaleItemsUpdate(
        id,
        projectSaleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProjectsSaleItemsApi.projectsSaleItemsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ProjectsSaleItemsApi - factory interface
 */
export const ProjectsSaleItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectsSaleItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsBulkCreateCreate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectSaleItem> {
      return localVarFp
        .projectsSaleItemsBulkCreateCreate(projectSaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsBulkDeleteCreate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectSaleItem> {
      return localVarFp
        .projectsSaleItemsBulkDeleteCreate(projectSaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsBulkUpdateUpdate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectSaleItem> {
      return localVarFp
        .projectsSaleItemsBulkUpdateUpdate(projectSaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsCreate(
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectSaleItem> {
      return localVarFp
        .projectsSaleItemsCreate(projectSaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .projectsSaleItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProjectSaleItemList> {
      return localVarFp
        .projectsSaleItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {PatchedProjectSaleItemRequest} [patchedProjectSaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsPartialUpdate(
      id: string,
      patchedProjectSaleItemRequest?: PatchedProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectSaleItem> {
      return localVarFp
        .projectsSaleItemsPartialUpdate(id, patchedProjectSaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectSaleItem> {
      return localVarFp
        .projectsSaleItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
     * @param {ProjectSaleItemRequest} projectSaleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsSaleItemsUpdate(
      id: string,
      projectSaleItemRequest: ProjectSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectSaleItem> {
      return localVarFp
        .projectsSaleItemsUpdate(id, projectSaleItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ProjectsSaleItemsApi - object-oriented interface
 */
export class ProjectsSaleItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectSaleItemRequest} projectSaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsBulkCreateCreate(
    projectSaleItemRequest: ProjectSaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsBulkCreateCreate(projectSaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectSaleItemRequest} projectSaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsBulkDeleteCreate(
    projectSaleItemRequest: ProjectSaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsBulkDeleteCreate(projectSaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ProjectSaleItemRequest} projectSaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsBulkUpdateUpdate(
    projectSaleItemRequest: ProjectSaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsBulkUpdateUpdate(projectSaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {ProjectSaleItemRequest} projectSaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsCreate(
    projectSaleItemRequest: ProjectSaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsCreate(projectSaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
   * @param {PatchedProjectSaleItemRequest} [patchedProjectSaleItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsPartialUpdate(
    id: string,
    patchedProjectSaleItemRequest?: PatchedProjectSaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsPartialUpdate(id, patchedProjectSaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Verkoopprijsafspraak (project).
   * @param {ProjectSaleItemRequest} projectSaleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectsSaleItemsUpdate(
    id: string,
    projectSaleItemRequest: ProjectSaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsSaleItemsApiFp(this.configuration)
      .projectsSaleItemsUpdate(id, projectSaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PurchaseItemsApi - axios parameter creator
 */
export const PurchaseItemsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsBulkCreateCreate: async (
      purchaseItemRequest: PurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseItemRequest' is not null or undefined
      assertParamExists("purchaseItemsBulkCreateCreate", "purchaseItemRequest", purchaseItemRequest)
      const localVarPath = `/administration/purchase-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsBulkDeleteCreate: async (
      purchaseItemRequest: PurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseItemRequest' is not null or undefined
      assertParamExists("purchaseItemsBulkDeleteCreate", "purchaseItemRequest", purchaseItemRequest)
      const localVarPath = `/administration/purchase-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsBulkUpdateUpdate: async (
      purchaseItemRequest: PurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseItemRequest' is not null or undefined
      assertParamExists("purchaseItemsBulkUpdateUpdate", "purchaseItemRequest", purchaseItemRequest)
      const localVarPath = `/administration/purchase-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsCreate: async (
      purchaseItemRequest: PurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseItemRequest' is not null or undefined
      assertParamExists("purchaseItemsCreate", "purchaseItemRequest", purchaseItemRequest)
      const localVarPath = `/administration/purchase-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseItemsDestroy", "id", id)
      const localVarPath = `/administration/purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/purchase-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {PatchedPurchaseItemRequest} [patchedPurchaseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsPartialUpdate: async (
      id: string,
      patchedPurchaseItemRequest?: PatchedPurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedPurchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseItemsRetrieve", "id", id)
      const localVarPath = `/administration/purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsUpdate: async (
      id: string,
      purchaseItemRequest: PurchaseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseItemsUpdate", "id", id)
      // verify required parameter 'purchaseItemRequest' is not null or undefined
      assertParamExists("purchaseItemsUpdate", "purchaseItemRequest", purchaseItemRequest)
      const localVarPath = `/administration/purchase-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PurchaseItemsApi - functional programming interface
 */
export const PurchaseItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PurchaseItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsBulkCreateCreate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsBulkCreateCreate(
        purchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsBulkDeleteCreate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsBulkDeleteCreate(
        purchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsBulkUpdateUpdate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsBulkUpdateUpdate(
        purchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsCreate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsCreate(
        purchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsDestroy"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPurchaseItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsList"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {PatchedPurchaseItemRequest} [patchedPurchaseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsPartialUpdate(
      id: string,
      patchedPurchaseItemRequest?: PatchedPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsPartialUpdate(
        id,
        patchedPurchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseItemsUpdate(
      id: string,
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseItemsUpdate(
        id,
        purchaseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseItemsApi.purchaseItemsUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PurchaseItemsApi - factory interface
 */
export const PurchaseItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PurchaseItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsBulkCreateCreate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseItem> {
      return localVarFp
        .purchaseItemsBulkCreateCreate(purchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsBulkDeleteCreate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseItem> {
      return localVarFp
        .purchaseItemsBulkDeleteCreate(purchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsBulkUpdateUpdate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseItem> {
      return localVarFp
        .purchaseItemsBulkUpdateUpdate(purchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsCreate(
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseItem> {
      return localVarFp
        .purchaseItemsCreate(purchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .purchaseItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedPurchaseItemList> {
      return localVarFp
        .purchaseItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {PatchedPurchaseItemRequest} [patchedPurchaseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsPartialUpdate(
      id: string,
      patchedPurchaseItemRequest?: PatchedPurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseItem> {
      return localVarFp
        .purchaseItemsPartialUpdate(id, patchedPurchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseItem> {
      return localVarFp
        .purchaseItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkoopartikel.
     * @param {PurchaseItemRequest} purchaseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseItemsUpdate(
      id: string,
      purchaseItemRequest: PurchaseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseItem> {
      return localVarFp
        .purchaseItemsUpdate(id, purchaseItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * PurchaseItemsApi - object-oriented interface
 */
export class PurchaseItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseItemRequest} purchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsBulkCreateCreate(
    purchaseItemRequest: PurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsBulkCreateCreate(purchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseItemRequest} purchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsBulkDeleteCreate(
    purchaseItemRequest: PurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsBulkDeleteCreate(purchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseItemRequest} purchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsBulkUpdateUpdate(
    purchaseItemRequest: PurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsBulkUpdateUpdate(purchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {PurchaseItemRequest} purchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsCreate(
    purchaseItemRequest: PurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsCreate(purchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inkoopartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inkoopartikel.
   * @param {PatchedPurchaseItemRequest} [patchedPurchaseItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsPartialUpdate(
    id: string,
    patchedPurchaseItemRequest?: PatchedPurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsPartialUpdate(id, patchedPurchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inkoopartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inkoopartikel.
   * @param {PurchaseItemRequest} purchaseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseItemsUpdate(
    id: string,
    purchaseItemRequest: PurchaseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseItemsApiFp(this.configuration)
      .purchaseItemsUpdate(id, purchaseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PurchaseSurchargePeriodsApi - axios parameter creator
 */
export const PurchaseSurchargePeriodsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsBulkCreateCreate: async (
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseSurchargePeriodRequest' is not null or undefined
      assertParamExists(
        "purchaseSurchargePeriodsBulkCreateCreate",
        "purchaseSurchargePeriodRequest",
        purchaseSurchargePeriodRequest
      )
      const localVarPath = `/administration/purchase-surcharge-periods/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseSurchargePeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsBulkDeleteCreate: async (
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseSurchargePeriodRequest' is not null or undefined
      assertParamExists(
        "purchaseSurchargePeriodsBulkDeleteCreate",
        "purchaseSurchargePeriodRequest",
        purchaseSurchargePeriodRequest
      )
      const localVarPath = `/administration/purchase-surcharge-periods/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseSurchargePeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsBulkUpdateUpdate: async (
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseSurchargePeriodRequest' is not null or undefined
      assertParamExists(
        "purchaseSurchargePeriodsBulkUpdateUpdate",
        "purchaseSurchargePeriodRequest",
        purchaseSurchargePeriodRequest
      )
      const localVarPath = `/administration/purchase-surcharge-periods/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseSurchargePeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsCreate: async (
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseSurchargePeriodRequest' is not null or undefined
      assertParamExists(
        "purchaseSurchargePeriodsCreate",
        "purchaseSurchargePeriodRequest",
        purchaseSurchargePeriodRequest
      )
      const localVarPath = `/administration/purchase-surcharge-periods/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseSurchargePeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseSurchargePeriodsDestroy", "id", id)
      const localVarPath = `/administration/purchase-surcharge-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/purchase-surcharge-periods/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {PatchedPurchaseSurchargePeriodRequest} [patchedPurchaseSurchargePeriodRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsPartialUpdate: async (
      id: string,
      patchedPurchaseSurchargePeriodRequest?: PatchedPurchaseSurchargePeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseSurchargePeriodsPartialUpdate", "id", id)
      const localVarPath = `/administration/purchase-surcharge-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedPurchaseSurchargePeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseSurchargePeriodsRetrieve", "id", id)
      const localVarPath = `/administration/purchase-surcharge-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsUpdate: async (
      id: string,
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchaseSurchargePeriodsUpdate", "id", id)
      // verify required parameter 'purchaseSurchargePeriodRequest' is not null or undefined
      assertParamExists(
        "purchaseSurchargePeriodsUpdate",
        "purchaseSurchargePeriodRequest",
        purchaseSurchargePeriodRequest
      )
      const localVarPath = `/administration/purchase-surcharge-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseSurchargePeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PurchaseSurchargePeriodsApi - functional programming interface
 */
export const PurchaseSurchargePeriodsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PurchaseSurchargePeriodsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsBulkCreateCreate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSurchargePeriod>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.purchaseSurchargePeriodsBulkCreateCreate(
          purchaseSurchargePeriodRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsBulkDeleteCreate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSurchargePeriod>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.purchaseSurchargePeriodsBulkDeleteCreate(
          purchaseSurchargePeriodRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsBulkUpdateUpdate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSurchargePeriod>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.purchaseSurchargePeriodsBulkUpdateUpdate(
          purchaseSurchargePeriodRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsCreate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSurchargePeriod>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseSurchargePeriodsCreate(
        purchaseSurchargePeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseSurchargePeriodsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedPurchaseSurchargePeriodList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseSurchargePeriodsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {PatchedPurchaseSurchargePeriodRequest} [patchedPurchaseSurchargePeriodRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsPartialUpdate(
      id: string,
      patchedPurchaseSurchargePeriodRequest?: PatchedPurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSurchargePeriod>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.purchaseSurchargePeriodsPartialUpdate(
          id,
          patchedPurchaseSurchargePeriodRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSurchargePeriod>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseSurchargePeriodsRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseSurchargePeriodsUpdate(
      id: string,
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSurchargePeriod>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseSurchargePeriodsUpdate(
        id,
        purchaseSurchargePeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchaseSurchargePeriodsApi.purchaseSurchargePeriodsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PurchaseSurchargePeriodsApi - factory interface
 */
export const PurchaseSurchargePeriodsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PurchaseSurchargePeriodsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsBulkCreateCreate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseSurchargePeriod> {
      return localVarFp
        .purchaseSurchargePeriodsBulkCreateCreate(purchaseSurchargePeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsBulkDeleteCreate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseSurchargePeriod> {
      return localVarFp
        .purchaseSurchargePeriodsBulkDeleteCreate(purchaseSurchargePeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsBulkUpdateUpdate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseSurchargePeriod> {
      return localVarFp
        .purchaseSurchargePeriodsBulkUpdateUpdate(purchaseSurchargePeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsCreate(
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseSurchargePeriod> {
      return localVarFp
        .purchaseSurchargePeriodsCreate(purchaseSurchargePeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .purchaseSurchargePeriodsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedPurchaseSurchargePeriodList> {
      return localVarFp
        .purchaseSurchargePeriodsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {PatchedPurchaseSurchargePeriodRequest} [patchedPurchaseSurchargePeriodRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsPartialUpdate(
      id: string,
      patchedPurchaseSurchargePeriodRequest?: PatchedPurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseSurchargePeriod> {
      return localVarFp
        .purchaseSurchargePeriodsPartialUpdate(id, patchedPurchaseSurchargePeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseSurchargePeriod> {
      return localVarFp
        .purchaseSurchargePeriodsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
     * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseSurchargePeriodsUpdate(
      id: string,
      purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PurchaseSurchargePeriod> {
      return localVarFp
        .purchaseSurchargePeriodsUpdate(id, purchaseSurchargePeriodRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * PurchaseSurchargePeriodsApi - object-oriented interface
 */
export class PurchaseSurchargePeriodsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsBulkCreateCreate(
    purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsBulkCreateCreate(purchaseSurchargePeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsBulkDeleteCreate(
    purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsBulkDeleteCreate(purchaseSurchargePeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsBulkUpdateUpdate(
    purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsBulkUpdateUpdate(purchaseSurchargePeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsCreate(
    purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsCreate(purchaseSurchargePeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
   * @param {PatchedPurchaseSurchargePeriodRequest} [patchedPurchaseSurchargePeriodRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsPartialUpdate(
    id: string,
    patchedPurchaseSurchargePeriodRequest?: PatchedPurchaseSurchargePeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsPartialUpdate(id, patchedPurchaseSurchargePeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inkooptoeslagperiode.
   * @param {PurchaseSurchargePeriodRequest} purchaseSurchargePeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchaseSurchargePeriodsUpdate(
    id: string,
    purchaseSurchargePeriodRequest: PurchaseSurchargePeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchaseSurchargePeriodsApiFp(this.configuration)
      .purchaseSurchargePeriodsUpdate(id, purchaseSurchargePeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PurchasesApi - axios parameter creator
 */
export const PurchasesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesApplyPricesRetroactivelyUpdate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/purchases/apply-prices-retroactively/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesBulkCreateCreate: async (
      purchaseRequest: PurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseRequest' is not null or undefined
      assertParamExists("purchasesBulkCreateCreate", "purchaseRequest", purchaseRequest)
      const localVarPath = `/administration/purchases/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesBulkDeleteCreate: async (
      purchaseRequest: PurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseRequest' is not null or undefined
      assertParamExists("purchasesBulkDeleteCreate", "purchaseRequest", purchaseRequest)
      const localVarPath = `/administration/purchases/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesBulkUpdateUpdate: async (
      purchaseRequest: PurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseRequest' is not null or undefined
      assertParamExists("purchasesBulkUpdateUpdate", "purchaseRequest", purchaseRequest)
      const localVarPath = `/administration/purchases/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesCreate: async (
      purchaseRequest: PurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'purchaseRequest' is not null or undefined
      assertParamExists("purchasesCreate", "purchaseRequest", purchaseRequest)
      const localVarPath = `/administration/purchases/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchasesDestroy", "id", id)
      const localVarPath = `/administration/purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesList: async (
      $skip?: number,
      $top?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/purchases/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this inkoop.
     * @param {PatchedPurchaseRequest} [patchedPurchaseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesPartialUpdate: async (
      id: string,
      patchedPurchaseRequest?: PatchedPurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchasesPartialUpdate", "id", id)
      const localVarPath = `/administration/purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedPurchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchasesRetrieve", "id", id)
      const localVarPath = `/administration/purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this inkoop.
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesUpdate: async (
      id: string,
      purchaseRequest: PurchaseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("purchasesUpdate", "id", id)
      // verify required parameter 'purchaseRequest' is not null or undefined
      assertParamExists("purchasesUpdate", "purchaseRequest", purchaseRequest)
      const localVarPath = `/administration/purchases/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        purchaseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PurchasesApi - functional programming interface
 */
export const PurchasesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PurchasesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesApplyPricesRetroactivelyUpdate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.purchasesApplyPricesRetroactivelyUpdate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesApplyPricesRetroactivelyUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesBulkCreateCreate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Purchase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesBulkCreateCreate(
        purchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesBulkDeleteCreate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Purchase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesBulkDeleteCreate(
        purchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesBulkUpdateUpdate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Purchase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesBulkUpdateUpdate(
        purchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesCreate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Purchase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesCreate(
        purchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPurchaseList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesList($skip, $top, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this inkoop.
     * @param {PatchedPurchaseRequest} [patchedPurchaseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesPartialUpdate(
      id: string,
      patchedPurchaseRequest?: PatchedPurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Purchase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesPartialUpdate(
        id,
        patchedPurchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesPartialUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Purchase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this inkoop.
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchasesUpdate(
      id: string,
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Purchase>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchasesUpdate(
        id,
        purchaseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PurchasesApi.purchasesUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PurchasesApi - factory interface
 */
export const PurchasesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PurchasesApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesApplyPricesRetroactivelyUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .purchasesApplyPricesRetroactivelyUpdate(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesBulkCreateCreate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Purchase> {
      return localVarFp
        .purchasesBulkCreateCreate(purchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesBulkDeleteCreate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Purchase> {
      return localVarFp
        .purchasesBulkDeleteCreate(purchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesBulkUpdateUpdate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Purchase> {
      return localVarFp
        .purchasesBulkUpdateUpdate(purchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesCreate(
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Purchase> {
      return localVarFp
        .purchasesCreate(purchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.purchasesDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedPurchaseList> {
      return localVarFp
        .purchasesList($skip, $top, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this inkoop.
     * @param {PatchedPurchaseRequest} [patchedPurchaseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesPartialUpdate(
      id: string,
      patchedPurchaseRequest?: PatchedPurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Purchase> {
      return localVarFp
        .purchasesPartialUpdate(id, patchedPurchaseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this inkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Purchase> {
      return localVarFp.purchasesRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this inkoop.
     * @param {PurchaseRequest} purchaseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasesUpdate(
      id: string,
      purchaseRequest: PurchaseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Purchase> {
      return localVarFp
        .purchasesUpdate(id, purchaseRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * PurchasesApi - object-oriented interface
 */
export class PurchasesApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesApplyPricesRetroactivelyUpdate(options?: RawAxiosRequestConfig) {
    return PurchasesApiFp(this.configuration)
      .purchasesApplyPricesRetroactivelyUpdate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseRequest} purchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesBulkCreateCreate(
    purchaseRequest: PurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchasesApiFp(this.configuration)
      .purchasesBulkCreateCreate(purchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseRequest} purchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesBulkDeleteCreate(
    purchaseRequest: PurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchasesApiFp(this.configuration)
      .purchasesBulkDeleteCreate(purchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseRequest} purchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesBulkUpdateUpdate(
    purchaseRequest: PurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchasesApiFp(this.configuration)
      .purchasesBulkUpdateUpdate(purchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {PurchaseRequest} purchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesCreate(purchaseRequest: PurchaseRequest, options?: RawAxiosRequestConfig) {
    return PurchasesApiFp(this.configuration)
      .purchasesCreate(purchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this inkoop.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return PurchasesApiFp(this.configuration)
      .purchasesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesList($skip?: number, $top?: number, options?: RawAxiosRequestConfig) {
    return PurchasesApiFp(this.configuration)
      .purchasesList($skip, $top, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this inkoop.
   * @param {PatchedPurchaseRequest} [patchedPurchaseRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesPartialUpdate(
    id: string,
    patchedPurchaseRequest?: PatchedPurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchasesApiFp(this.configuration)
      .purchasesPartialUpdate(id, patchedPurchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this inkoop.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return PurchasesApiFp(this.configuration)
      .purchasesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this inkoop.
   * @param {PurchaseRequest} purchaseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public purchasesUpdate(
    id: string,
    purchaseRequest: PurchaseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PurchasesApiFp(this.configuration)
      .purchasesUpdate(id, purchaseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RentalDispenseItemsApi - axios parameter creator
 */
export const RentalDispenseItemsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsBulkCreateCreate: async (
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "rentalDispenseItemsBulkCreateCreate",
        "rentalDispenseItemRequest",
        rentalDispenseItemRequest
      )
      const localVarPath = `/administration/rental-dispense-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsBulkDeleteCreate: async (
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "rentalDispenseItemsBulkDeleteCreate",
        "rentalDispenseItemRequest",
        rentalDispenseItemRequest
      )
      const localVarPath = `/administration/rental-dispense-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsBulkUpdateUpdate: async (
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "rentalDispenseItemsBulkUpdateUpdate",
        "rentalDispenseItemRequest",
        rentalDispenseItemRequest
      )
      const localVarPath = `/administration/rental-dispense-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsCreate: async (
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "rentalDispenseItemsCreate",
        "rentalDispenseItemRequest",
        rentalDispenseItemRequest
      )
      const localVarPath = `/administration/rental-dispense-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispenseItemsDestroy", "id", id)
      const localVarPath = `/administration/rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/rental-dispense-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {PatchedRentalDispenseItemRequest} [patchedRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsPartialUpdate: async (
      id: string,
      patchedRentalDispenseItemRequest?: PatchedRentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispenseItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedRentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispenseItemsRetrieve", "id", id)
      const localVarPath = `/administration/rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsUpdate: async (
      id: string,
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispenseItemsUpdate", "id", id)
      // verify required parameter 'rentalDispenseItemRequest' is not null or undefined
      assertParamExists(
        "rentalDispenseItemsUpdate",
        "rentalDispenseItemRequest",
        rentalDispenseItemRequest
      )
      const localVarPath = `/administration/rental-dispense-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RentalDispenseItemsApi - functional programming interface
 */
export const RentalDispenseItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RentalDispenseItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsBulkCreateCreate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispenseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsBulkCreateCreate(
        rentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsBulkDeleteCreate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispenseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsBulkDeleteCreate(
        rentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsBulkUpdateUpdate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispenseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsBulkUpdateUpdate(
        rentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsCreate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispenseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsCreate(
        rentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRentalDispenseItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {PatchedRentalDispenseItemRequest} [patchedRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsPartialUpdate(
      id: string,
      patchedRentalDispenseItemRequest?: PatchedRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispenseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsPartialUpdate(
        id,
        patchedRentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispenseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispenseItemsUpdate(
      id: string,
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispenseItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispenseItemsUpdate(
        id,
        rentalDispenseItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispenseItemsApi.rentalDispenseItemsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RentalDispenseItemsApi - factory interface
 */
export const RentalDispenseItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RentalDispenseItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsBulkCreateCreate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispenseItem> {
      return localVarFp
        .rentalDispenseItemsBulkCreateCreate(rentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsBulkDeleteCreate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispenseItem> {
      return localVarFp
        .rentalDispenseItemsBulkDeleteCreate(rentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsBulkUpdateUpdate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispenseItem> {
      return localVarFp
        .rentalDispenseItemsBulkUpdateUpdate(rentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsCreate(
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispenseItem> {
      return localVarFp
        .rentalDispenseItemsCreate(rentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .rentalDispenseItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedRentalDispenseItemList> {
      return localVarFp
        .rentalDispenseItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {PatchedRentalDispenseItemRequest} [patchedRentalDispenseItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsPartialUpdate(
      id: string,
      patchedRentalDispenseItemRequest?: PatchedRentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispenseItem> {
      return localVarFp
        .rentalDispenseItemsPartialUpdate(id, patchedRentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispenseItem> {
      return localVarFp
        .rentalDispenseItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verhuurartikel.
     * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispenseItemsUpdate(
      id: string,
      rentalDispenseItemRequest: RentalDispenseItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispenseItem> {
      return localVarFp
        .rentalDispenseItemsUpdate(id, rentalDispenseItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RentalDispenseItemsApi - object-oriented interface
 */
export class RentalDispenseItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsBulkCreateCreate(
    rentalDispenseItemRequest: RentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsBulkCreateCreate(rentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsBulkDeleteCreate(
    rentalDispenseItemRequest: RentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsBulkDeleteCreate(rentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsBulkUpdateUpdate(
    rentalDispenseItemRequest: RentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsBulkUpdateUpdate(rentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsCreate(
    rentalDispenseItemRequest: RentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsCreate(rentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Verhuurartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Verhuurartikel.
   * @param {PatchedRentalDispenseItemRequest} [patchedRentalDispenseItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsPartialUpdate(
    id: string,
    patchedRentalDispenseItemRequest?: PatchedRentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsPartialUpdate(id, patchedRentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Verhuurartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Verhuurartikel.
   * @param {RentalDispenseItemRequest} rentalDispenseItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispenseItemsUpdate(
    id: string,
    rentalDispenseItemRequest: RentalDispenseItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispenseItemsApiFp(this.configuration)
      .rentalDispenseItemsUpdate(id, rentalDispenseItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RentalDispensesApi - axios parameter creator
 */
export const RentalDispensesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesBulkCreateCreate: async (
      rentalDispenseRequest: RentalDispenseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseRequest' is not null or undefined
      assertParamExists(
        "rentalDispensesBulkCreateCreate",
        "rentalDispenseRequest",
        rentalDispenseRequest
      )
      const localVarPath = `/administration/rental-dispenses/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesBulkDeleteCreate: async (
      rentalDispenseRequest: RentalDispenseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseRequest' is not null or undefined
      assertParamExists(
        "rentalDispensesBulkDeleteCreate",
        "rentalDispenseRequest",
        rentalDispenseRequest
      )
      const localVarPath = `/administration/rental-dispenses/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesBulkUpdateUpdate: async (
      rentalDispenseRequest: RentalDispenseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseRequest' is not null or undefined
      assertParamExists(
        "rentalDispensesBulkUpdateUpdate",
        "rentalDispenseRequest",
        rentalDispenseRequest
      )
      const localVarPath = `/administration/rental-dispenses/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesCreate: async (
      rentalDispenseRequest: RentalDispenseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalDispenseRequest' is not null or undefined
      assertParamExists("rentalDispensesCreate", "rentalDispenseRequest", rentalDispenseRequest)
      const localVarPath = `/administration/rental-dispenses/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispensesDestroy", "id", id)
      const localVarPath = `/administration/rental-dispenses/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesList: async (
      $skip?: number,
      $top?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/rental-dispenses/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {PatchedRentalDispenseRequest} [patchedRentalDispenseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesPartialUpdate: async (
      id: string,
      patchedRentalDispenseRequest?: PatchedRentalDispenseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispensesPartialUpdate", "id", id)
      const localVarPath = `/administration/rental-dispenses/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedRentalDispenseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispensesRetrieve", "id", id)
      const localVarPath = `/administration/rental-dispenses/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesUpdate: async (
      id: string,
      rentalDispenseRequest: RentalDispenseRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalDispensesUpdate", "id", id)
      // verify required parameter 'rentalDispenseRequest' is not null or undefined
      assertParamExists("rentalDispensesUpdate", "rentalDispenseRequest", rentalDispenseRequest)
      const localVarPath = `/administration/rental-dispenses/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalDispenseRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RentalDispensesApi - functional programming interface
 */
export const RentalDispensesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RentalDispensesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesBulkCreateCreate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispense>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesBulkCreateCreate(
        rentalDispenseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesBulkDeleteCreate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispense>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesBulkDeleteCreate(
        rentalDispenseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesBulkUpdateUpdate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispense>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesBulkUpdateUpdate(
        rentalDispenseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesCreate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispense>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesCreate(
        rentalDispenseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRentalDispenseList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesList(
        $skip,
        $top,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesList"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {PatchedRentalDispenseRequest} [patchedRentalDispenseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesPartialUpdate(
      id: string,
      patchedRentalDispenseRequest?: PatchedRentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispense>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesPartialUpdate(
        id,
        patchedRentalDispenseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispense>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalDispensesUpdate(
      id: string,
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalDispense>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalDispensesUpdate(
        id,
        rentalDispenseRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalDispensesApi.rentalDispensesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RentalDispensesApi - factory interface
 */
export const RentalDispensesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RentalDispensesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesBulkCreateCreate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispense> {
      return localVarFp
        .rentalDispensesBulkCreateCreate(rentalDispenseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesBulkDeleteCreate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispense> {
      return localVarFp
        .rentalDispensesBulkDeleteCreate(rentalDispenseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesBulkUpdateUpdate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispense> {
      return localVarFp
        .rentalDispensesBulkUpdateUpdate(rentalDispenseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesCreate(
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispense> {
      return localVarFp
        .rentalDispensesCreate(rentalDispenseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .rentalDispensesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedRentalDispenseList> {
      return localVarFp
        .rentalDispensesList($skip, $top, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {PatchedRentalDispenseRequest} [patchedRentalDispenseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesPartialUpdate(
      id: string,
      patchedRentalDispenseRequest?: PatchedRentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispense> {
      return localVarFp
        .rentalDispensesPartialUpdate(id, patchedRentalDispenseRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispense> {
      return localVarFp
        .rentalDispensesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Verhuurmutatie.
     * @param {RentalDispenseRequest} rentalDispenseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalDispensesUpdate(
      id: string,
      rentalDispenseRequest: RentalDispenseRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalDispense> {
      return localVarFp
        .rentalDispensesUpdate(id, rentalDispenseRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RentalDispensesApi - object-oriented interface
 */
export class RentalDispensesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalDispenseRequest} rentalDispenseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesBulkCreateCreate(
    rentalDispenseRequest: RentalDispenseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesBulkCreateCreate(rentalDispenseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalDispenseRequest} rentalDispenseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesBulkDeleteCreate(
    rentalDispenseRequest: RentalDispenseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesBulkDeleteCreate(rentalDispenseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalDispenseRequest} rentalDispenseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesBulkUpdateUpdate(
    rentalDispenseRequest: RentalDispenseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesBulkUpdateUpdate(rentalDispenseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {RentalDispenseRequest} rentalDispenseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesCreate(
    rentalDispenseRequest: RentalDispenseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesCreate(rentalDispenseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this Verhuurmutatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesList($skip?: number, $top?: number, options?: RawAxiosRequestConfig) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesList($skip, $top, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Verhuurmutatie.
   * @param {PatchedRentalDispenseRequest} [patchedRentalDispenseRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesPartialUpdate(
    id: string,
    patchedRentalDispenseRequest?: PatchedRentalDispenseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesPartialUpdate(id, patchedRentalDispenseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Verhuurmutatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this Verhuurmutatie.
   * @param {RentalDispenseRequest} rentalDispenseRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalDispensesUpdate(
    id: string,
    rentalDispenseRequest: RentalDispenseRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalDispensesApiFp(this.configuration)
      .rentalDispensesUpdate(id, rentalDispenseRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RentalIntakeItemsApi - axios parameter creator
 */
export const RentalIntakeItemsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsBulkCreateCreate: async (
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeItemsBulkCreateCreate",
        "rentalIntakeItemRequest",
        rentalIntakeItemRequest
      )
      const localVarPath = `/administration/rental-intake-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsBulkDeleteCreate: async (
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeItemsBulkDeleteCreate",
        "rentalIntakeItemRequest",
        rentalIntakeItemRequest
      )
      const localVarPath = `/administration/rental-intake-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsBulkUpdateUpdate: async (
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeItemsBulkUpdateUpdate",
        "rentalIntakeItemRequest",
        rentalIntakeItemRequest
      )
      const localVarPath = `/administration/rental-intake-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsCreate: async (
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeItemsCreate",
        "rentalIntakeItemRequest",
        rentalIntakeItemRequest
      )
      const localVarPath = `/administration/rental-intake-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeItemsDestroy", "id", id)
      const localVarPath = `/administration/rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/rental-intake-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {PatchedRentalIntakeItemRequest} [patchedRentalIntakeItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsPartialUpdate: async (
      id: string,
      patchedRentalIntakeItemRequest?: PatchedRentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedRentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeItemsRetrieve", "id", id)
      const localVarPath = `/administration/rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsUpdate: async (
      id: string,
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeItemsUpdate", "id", id)
      // verify required parameter 'rentalIntakeItemRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeItemsUpdate",
        "rentalIntakeItemRequest",
        rentalIntakeItemRequest
      )
      const localVarPath = `/administration/rental-intake-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RentalIntakeItemsApi - functional programming interface
 */
export const RentalIntakeItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RentalIntakeItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsBulkCreateCreate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntakeItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsBulkCreateCreate(
        rentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsBulkDeleteCreate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntakeItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsBulkDeleteCreate(
        rentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsBulkUpdateUpdate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntakeItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsBulkUpdateUpdate(
        rentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsCreate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntakeItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsCreate(
        rentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRentalIntakeItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {PatchedRentalIntakeItemRequest} [patchedRentalIntakeItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsPartialUpdate(
      id: string,
      patchedRentalIntakeItemRequest?: PatchedRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntakeItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsPartialUpdate(
        id,
        patchedRentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntakeItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeItemsUpdate(
      id: string,
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntakeItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeItemsUpdate(
        id,
        rentalIntakeItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeItemsApi.rentalIntakeItemsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RentalIntakeItemsApi - factory interface
 */
export const RentalIntakeItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RentalIntakeItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsBulkCreateCreate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntakeItem> {
      return localVarFp
        .rentalIntakeItemsBulkCreateCreate(rentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsBulkDeleteCreate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntakeItem> {
      return localVarFp
        .rentalIntakeItemsBulkDeleteCreate(rentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsBulkUpdateUpdate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntakeItem> {
      return localVarFp
        .rentalIntakeItemsBulkUpdateUpdate(rentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsCreate(
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntakeItem> {
      return localVarFp
        .rentalIntakeItemsCreate(rentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .rentalIntakeItemsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedRentalIntakeItemList> {
      return localVarFp
        .rentalIntakeItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {PatchedRentalIntakeItemRequest} [patchedRentalIntakeItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsPartialUpdate(
      id: string,
      patchedRentalIntakeItemRequest?: PatchedRentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntakeItem> {
      return localVarFp
        .rentalIntakeItemsPartialUpdate(id, patchedRentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntakeItem> {
      return localVarFp
        .rentalIntakeItemsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurartikel.
     * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeItemsUpdate(
      id: string,
      rentalIntakeItemRequest: RentalIntakeItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntakeItem> {
      return localVarFp
        .rentalIntakeItemsUpdate(id, rentalIntakeItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RentalIntakeItemsApi - object-oriented interface
 */
export class RentalIntakeItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsBulkCreateCreate(
    rentalIntakeItemRequest: RentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsBulkCreateCreate(rentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsBulkDeleteCreate(
    rentalIntakeItemRequest: RentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsBulkDeleteCreate(rentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsBulkUpdateUpdate(
    rentalIntakeItemRequest: RentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsBulkUpdateUpdate(rentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsCreate(
    rentalIntakeItemRequest: RentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsCreate(rentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inhuurartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inhuurartikel.
   * @param {PatchedRentalIntakeItemRequest} [patchedRentalIntakeItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsPartialUpdate(
    id: string,
    patchedRentalIntakeItemRequest?: PatchedRentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsPartialUpdate(id, patchedRentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inhuurartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inhuurartikel.
   * @param {RentalIntakeItemRequest} rentalIntakeItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeItemsUpdate(
    id: string,
    rentalIntakeItemRequest: RentalIntakeItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeItemsApiFp(this.configuration)
      .rentalIntakeItemsUpdate(id, rentalIntakeItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RentalIntakeMaterializationsApi - axios parameter creator
 */
export const RentalIntakeMaterializationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsBulkCreateCreate: async (
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'shallowRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeMaterializationsBulkCreateCreate",
        "shallowRentalIntakeMaterializationRequest",
        shallowRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/rental-intake-materializations/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shallowRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsBulkDeleteCreate: async (
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'shallowRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeMaterializationsBulkDeleteCreate",
        "shallowRentalIntakeMaterializationRequest",
        shallowRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/rental-intake-materializations/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shallowRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsBulkUpdateUpdate: async (
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'shallowRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeMaterializationsBulkUpdateUpdate",
        "shallowRentalIntakeMaterializationRequest",
        shallowRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/rental-intake-materializations/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shallowRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsCreate: async (
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'shallowRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeMaterializationsCreate",
        "shallowRentalIntakeMaterializationRequest",
        shallowRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/rental-intake-materializations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shallowRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeMaterializationsDestroy", "id", id)
      const localVarPath = `/administration/rental-intake-materializations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsList: async (
      $skip?: number,
      $top?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/rental-intake-materializations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {PatchedShallowRentalIntakeMaterializationRequest} [patchedShallowRentalIntakeMaterializationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsPartialUpdate: async (
      id: string,
      patchedShallowRentalIntakeMaterializationRequest?: PatchedShallowRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeMaterializationsPartialUpdate", "id", id)
      const localVarPath = `/administration/rental-intake-materializations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedShallowRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeMaterializationsRetrieve", "id", id)
      const localVarPath = `/administration/rental-intake-materializations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsUpdate: async (
      id: string,
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakeMaterializationsUpdate", "id", id)
      // verify required parameter 'shallowRentalIntakeMaterializationRequest' is not null or undefined
      assertParamExists(
        "rentalIntakeMaterializationsUpdate",
        "shallowRentalIntakeMaterializationRequest",
        shallowRentalIntakeMaterializationRequest
      )
      const localVarPath = `/administration/rental-intake-materializations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shallowRentalIntakeMaterializationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RentalIntakeMaterializationsApi - functional programming interface
 */
export const RentalIntakeMaterializationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RentalIntakeMaterializationsApiAxiosParamCreator(configuration)
  return {
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsBulkCreateCreate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShallowRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rentalIntakeMaterializationsBulkCreateCreate(
          shallowRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RentalIntakeMaterializationsApi.rentalIntakeMaterializationsBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsBulkDeleteCreate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShallowRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rentalIntakeMaterializationsBulkDeleteCreate(
          shallowRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RentalIntakeMaterializationsApi.rentalIntakeMaterializationsBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsBulkUpdateUpdate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShallowRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rentalIntakeMaterializationsBulkUpdateUpdate(
          shallowRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RentalIntakeMaterializationsApi.rentalIntakeMaterializationsBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsCreate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShallowRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeMaterializationsCreate(
        shallowRentalIntakeMaterializationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeMaterializationsApi.rentalIntakeMaterializationsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeMaterializationsDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeMaterializationsApi.rentalIntakeMaterializationsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedShallowRentalIntakeMaterializationList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeMaterializationsList(
        $skip,
        $top,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeMaterializationsApi.rentalIntakeMaterializationsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {PatchedShallowRentalIntakeMaterializationRequest} [patchedShallowRentalIntakeMaterializationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsPartialUpdate(
      id: string,
      patchedShallowRentalIntakeMaterializationRequest?: PatchedShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShallowRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rentalIntakeMaterializationsPartialUpdate(
          id,
          patchedShallowRentalIntakeMaterializationRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RentalIntakeMaterializationsApi.rentalIntakeMaterializationsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShallowRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.rentalIntakeMaterializationsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RentalIntakeMaterializationsApi.rentalIntakeMaterializationsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakeMaterializationsUpdate(
      id: string,
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShallowRentalIntakeMaterialization>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakeMaterializationsUpdate(
        id,
        shallowRentalIntakeMaterializationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakeMaterializationsApi.rentalIntakeMaterializationsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RentalIntakeMaterializationsApi - factory interface
 */
export const RentalIntakeMaterializationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RentalIntakeMaterializationsApiFp(configuration)
  return {
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsBulkCreateCreate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ShallowRentalIntakeMaterialization> {
      return localVarFp
        .rentalIntakeMaterializationsBulkCreateCreate(
          shallowRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsBulkDeleteCreate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ShallowRentalIntakeMaterialization> {
      return localVarFp
        .rentalIntakeMaterializationsBulkDeleteCreate(
          shallowRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsBulkUpdateUpdate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ShallowRentalIntakeMaterialization> {
      return localVarFp
        .rentalIntakeMaterializationsBulkUpdateUpdate(
          shallowRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsCreate(
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ShallowRentalIntakeMaterialization> {
      return localVarFp
        .rentalIntakeMaterializationsCreate(shallowRentalIntakeMaterializationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .rentalIntakeMaterializationsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedShallowRentalIntakeMaterializationList> {
      return localVarFp
        .rentalIntakeMaterializationsList($skip, $top, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {PatchedShallowRentalIntakeMaterializationRequest} [patchedShallowRentalIntakeMaterializationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsPartialUpdate(
      id: string,
      patchedShallowRentalIntakeMaterializationRequest?: PatchedShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ShallowRentalIntakeMaterialization> {
      return localVarFp
        .rentalIntakeMaterializationsPartialUpdate(
          id,
          patchedShallowRentalIntakeMaterializationRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ShallowRentalIntakeMaterialization> {
      return localVarFp
        .rentalIntakeMaterializationsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
     * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakeMaterializationsUpdate(
      id: string,
      shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ShallowRentalIntakeMaterialization> {
      return localVarFp
        .rentalIntakeMaterializationsUpdate(id, shallowRentalIntakeMaterializationRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RentalIntakeMaterializationsApi - object-oriented interface
 */
export class RentalIntakeMaterializationsApi extends BaseAPI {
  /**
   * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
   * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsBulkCreateCreate(
    shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsBulkCreateCreate(
        shallowRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
   * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsBulkDeleteCreate(
    shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsBulkDeleteCreate(
        shallowRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * ViewSet for managing RentalIntakeMaterialization entities. Uses a shallow serializer for performance and annotates key related fields for filtering and display purposes. This way of working is possible because RentalIntakeMaterialization is created by a controlled process and immutable after creation. Therefore we do not have to worry about data integrity issues when denormalizing related fields.
   * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsBulkUpdateUpdate(
    shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsBulkUpdateUpdate(
        shallowRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsCreate(
    shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsCreate(shallowRentalIntakeMaterializationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsList(
    $skip?: number,
    $top?: number,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsList($skip, $top, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
   * @param {PatchedShallowRentalIntakeMaterializationRequest} [patchedShallowRentalIntakeMaterializationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsPartialUpdate(
    id: string,
    patchedShallowRentalIntakeMaterializationRequest?: PatchedShallowRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsPartialUpdate(
        id,
        patchedShallowRentalIntakeMaterializationRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Inhuurmaterialisatie.
   * @param {ShallowRentalIntakeMaterializationRequest} shallowRentalIntakeMaterializationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakeMaterializationsUpdate(
    id: string,
    shallowRentalIntakeMaterializationRequest: ShallowRentalIntakeMaterializationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakeMaterializationsApiFp(this.configuration)
      .rentalIntakeMaterializationsUpdate(id, shallowRentalIntakeMaterializationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RentalIntakesApi - axios parameter creator
 */
export const RentalIntakesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesBulkCreateCreate: async (
      rentalIntakeRequest: RentalIntakeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeRequest' is not null or undefined
      assertParamExists("rentalIntakesBulkCreateCreate", "rentalIntakeRequest", rentalIntakeRequest)
      const localVarPath = `/administration/rental-intakes/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesBulkDeleteCreate: async (
      rentalIntakeRequest: RentalIntakeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeRequest' is not null or undefined
      assertParamExists("rentalIntakesBulkDeleteCreate", "rentalIntakeRequest", rentalIntakeRequest)
      const localVarPath = `/administration/rental-intakes/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesBulkUpdateUpdate: async (
      rentalIntakeRequest: RentalIntakeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeRequest' is not null or undefined
      assertParamExists("rentalIntakesBulkUpdateUpdate", "rentalIntakeRequest", rentalIntakeRequest)
      const localVarPath = `/administration/rental-intakes/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesCreate: async (
      rentalIntakeRequest: RentalIntakeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'rentalIntakeRequest' is not null or undefined
      assertParamExists("rentalIntakesCreate", "rentalIntakeRequest", rentalIntakeRequest)
      const localVarPath = `/administration/rental-intakes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakesDestroy", "id", id)
      const localVarPath = `/administration/rental-intakes/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesList: async (
      $skip?: number,
      $top?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/rental-intakes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {PatchedRentalIntakeRequest} [patchedRentalIntakeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesPartialUpdate: async (
      id: string,
      patchedRentalIntakeRequest?: PatchedRentalIntakeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakesPartialUpdate", "id", id)
      const localVarPath = `/administration/rental-intakes/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedRentalIntakeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakesRetrieve", "id", id)
      const localVarPath = `/administration/rental-intakes/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesUpdate: async (
      id: string,
      rentalIntakeRequest: RentalIntakeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("rentalIntakesUpdate", "id", id)
      // verify required parameter 'rentalIntakeRequest' is not null or undefined
      assertParamExists("rentalIntakesUpdate", "rentalIntakeRequest", rentalIntakeRequest)
      const localVarPath = `/administration/rental-intakes/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        rentalIntakeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RentalIntakesApi - functional programming interface
 */
export const RentalIntakesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RentalIntakesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesBulkCreateCreate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntake>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesBulkCreateCreate(
        rentalIntakeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesBulkDeleteCreate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntake>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesBulkDeleteCreate(
        rentalIntakeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesBulkUpdateUpdate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntake>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesBulkUpdateUpdate(
        rentalIntakeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesCreate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntake>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesCreate(
        rentalIntakeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesDestroy"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRentalIntakeList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesList(
        $skip,
        $top,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesList"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {PatchedRentalIntakeRequest} [patchedRentalIntakeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesPartialUpdate(
      id: string,
      patchedRentalIntakeRequest?: PatchedRentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntake>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesPartialUpdate(
        id,
        patchedRentalIntakeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntake>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalIntakesUpdate(
      id: string,
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalIntake>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rentalIntakesUpdate(
        id,
        rentalIntakeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RentalIntakesApi.rentalIntakesUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RentalIntakesApi - factory interface
 */
export const RentalIntakesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RentalIntakesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesBulkCreateCreate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntake> {
      return localVarFp
        .rentalIntakesBulkCreateCreate(rentalIntakeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesBulkDeleteCreate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntake> {
      return localVarFp
        .rentalIntakesBulkDeleteCreate(rentalIntakeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesBulkUpdateUpdate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntake> {
      return localVarFp
        .rentalIntakesBulkUpdateUpdate(rentalIntakeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesCreate(
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntake> {
      return localVarFp
        .rentalIntakesCreate(rentalIntakeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .rentalIntakesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedRentalIntakeList> {
      return localVarFp
        .rentalIntakesList($skip, $top, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {PatchedRentalIntakeRequest} [patchedRentalIntakeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesPartialUpdate(
      id: string,
      patchedRentalIntakeRequest?: PatchedRentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntake> {
      return localVarFp
        .rentalIntakesPartialUpdate(id, patchedRentalIntakeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RentalIntake> {
      return localVarFp
        .rentalIntakesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Inhuurmutatie.
     * @param {RentalIntakeRequest} rentalIntakeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalIntakesUpdate(
      id: string,
      rentalIntakeRequest: RentalIntakeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RentalIntake> {
      return localVarFp
        .rentalIntakesUpdate(id, rentalIntakeRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RentalIntakesApi - object-oriented interface
 */
export class RentalIntakesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalIntakeRequest} rentalIntakeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesBulkCreateCreate(
    rentalIntakeRequest: RentalIntakeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesBulkCreateCreate(rentalIntakeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalIntakeRequest} rentalIntakeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesBulkDeleteCreate(
    rentalIntakeRequest: RentalIntakeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesBulkDeleteCreate(rentalIntakeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RentalIntakeRequest} rentalIntakeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesBulkUpdateUpdate(
    rentalIntakeRequest: RentalIntakeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesBulkUpdateUpdate(rentalIntakeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {RentalIntakeRequest} rentalIntakeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesCreate(
    rentalIntakeRequest: RentalIntakeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesCreate(rentalIntakeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this Inhuurmutatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override list() to support progressive fetching when a progressive_limit is provided. Almost identical to the default implementation, except for the progressive fetching part.
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesList($skip?: number, $top?: number, options?: RawAxiosRequestConfig) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesList($skip, $top, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Inhuurmutatie.
   * @param {PatchedRentalIntakeRequest} [patchedRentalIntakeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesPartialUpdate(
    id: string,
    patchedRentalIntakeRequest?: PatchedRentalIntakeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesPartialUpdate(id, patchedRentalIntakeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Inhuurmutatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this Inhuurmutatie.
   * @param {RentalIntakeRequest} rentalIntakeRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rentalIntakesUpdate(
    id: string,
    rentalIntakeRequest: RentalIntakeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RentalIntakesApiFp(this.configuration)
      .rentalIntakesUpdate(id, rentalIntakeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ResetDataApi - axios parameter creator
 */
export const ResetDataApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetDataDestroy: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/core/reset-data/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ResetDataApi - functional programming interface
 */
export const ResetDataApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ResetDataApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetDataDestroy(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resetDataDestroy(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ResetDataApi.resetDataDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ResetDataApi - factory interface
 */
export const ResetDataApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ResetDataApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetDataDestroy(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.resetDataDestroy(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * ResetDataApi - object-oriented interface
 */
export class ResetDataApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public resetDataDestroy(options?: RawAxiosRequestConfig) {
    return ResetDataApiFp(this.configuration)
      .resetDataDestroy(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RoleServiceProviderMachinesApi - axios parameter creator
 */
export const RoleServiceProviderMachinesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesBulkCreateCreate: async (
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/role-service-provider-machines/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleServiceProviderMachineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesBulkDeleteCreate: async (
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/role-service-provider-machines/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleServiceProviderMachineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesBulkUpdateUpdate: async (
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/role-service-provider-machines/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleServiceProviderMachineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesCreate: async (
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/role-service-provider-machines/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleServiceProviderMachineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("roleServiceProviderMachinesDestroy", "id", id)
      const localVarPath = `/core/role-service-provider-machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/core/role-service-provider-machines/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {PatchedRoleServiceProviderMachineRequest} [patchedRoleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesPartialUpdate: async (
      id: string,
      patchedRoleServiceProviderMachineRequest?: PatchedRoleServiceProviderMachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("roleServiceProviderMachinesPartialUpdate", "id", id)
      const localVarPath = `/core/role-service-provider-machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedRoleServiceProviderMachineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("roleServiceProviderMachinesRetrieve", "id", id)
      const localVarPath = `/core/role-service-provider-machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesUpdate: async (
      id: string,
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("roleServiceProviderMachinesUpdate", "id", id)
      const localVarPath = `/core/role-service-provider-machines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleServiceProviderMachineRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RoleServiceProviderMachinesApi - functional programming interface
 */
export const RoleServiceProviderMachinesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoleServiceProviderMachinesApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesBulkCreateCreate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleServiceProviderMachine>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.roleServiceProviderMachinesBulkCreateCreate(
          roleServiceProviderMachineRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RoleServiceProviderMachinesApi.roleServiceProviderMachinesBulkCreateCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesBulkDeleteCreate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleServiceProviderMachine>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.roleServiceProviderMachinesBulkDeleteCreate(
          roleServiceProviderMachineRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RoleServiceProviderMachinesApi.roleServiceProviderMachinesBulkDeleteCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesBulkUpdateUpdate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleServiceProviderMachine>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.roleServiceProviderMachinesBulkUpdateUpdate(
          roleServiceProviderMachineRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RoleServiceProviderMachinesApi.roleServiceProviderMachinesBulkUpdateUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesCreate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleServiceProviderMachine>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceProviderMachinesCreate(
        roleServiceProviderMachineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RoleServiceProviderMachinesApi.roleServiceProviderMachinesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceProviderMachinesDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RoleServiceProviderMachinesApi.roleServiceProviderMachinesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedRoleServiceProviderMachineList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceProviderMachinesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RoleServiceProviderMachinesApi.roleServiceProviderMachinesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {PatchedRoleServiceProviderMachineRequest} [patchedRoleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesPartialUpdate(
      id: string,
      patchedRoleServiceProviderMachineRequest?: PatchedRoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleServiceProviderMachine>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.roleServiceProviderMachinesPartialUpdate(
          id,
          patchedRoleServiceProviderMachineRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "RoleServiceProviderMachinesApi.roleServiceProviderMachinesPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleServiceProviderMachine>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceProviderMachinesRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RoleServiceProviderMachinesApi.roleServiceProviderMachinesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceProviderMachinesUpdate(
      id: string,
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleServiceProviderMachine>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceProviderMachinesUpdate(
        id,
        roleServiceProviderMachineRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["RoleServiceProviderMachinesApi.roleServiceProviderMachinesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RoleServiceProviderMachinesApi - factory interface
 */
export const RoleServiceProviderMachinesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RoleServiceProviderMachinesApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesBulkCreateCreate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoleServiceProviderMachine> {
      return localVarFp
        .roleServiceProviderMachinesBulkCreateCreate(roleServiceProviderMachineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesBulkDeleteCreate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoleServiceProviderMachine> {
      return localVarFp
        .roleServiceProviderMachinesBulkDeleteCreate(roleServiceProviderMachineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesBulkUpdateUpdate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoleServiceProviderMachine> {
      return localVarFp
        .roleServiceProviderMachinesBulkUpdateUpdate(roleServiceProviderMachineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesCreate(
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoleServiceProviderMachine> {
      return localVarFp
        .roleServiceProviderMachinesCreate(roleServiceProviderMachineRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .roleServiceProviderMachinesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedRoleServiceProviderMachineList> {
      return localVarFp
        .roleServiceProviderMachinesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {PatchedRoleServiceProviderMachineRequest} [patchedRoleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesPartialUpdate(
      id: string,
      patchedRoleServiceProviderMachineRequest?: PatchedRoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoleServiceProviderMachine> {
      return localVarFp
        .roleServiceProviderMachinesPartialUpdate(
          id,
          patchedRoleServiceProviderMachineRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoleServiceProviderMachine> {
      return localVarFp
        .roleServiceProviderMachinesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this role service provider machine.
     * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceProviderMachinesUpdate(
      id: string,
      roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoleServiceProviderMachine> {
      return localVarFp
        .roleServiceProviderMachinesUpdate(id, roleServiceProviderMachineRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RoleServiceProviderMachinesApi - object-oriented interface
 */
export class RoleServiceProviderMachinesApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesBulkCreateCreate(
    roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesBulkCreateCreate(roleServiceProviderMachineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesBulkDeleteCreate(
    roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesBulkDeleteCreate(roleServiceProviderMachineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesBulkUpdateUpdate(
    roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesBulkUpdateUpdate(roleServiceProviderMachineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesCreate(
    roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesCreate(roleServiceProviderMachineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this role service provider machine.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this role service provider machine.
   * @param {PatchedRoleServiceProviderMachineRequest} [patchedRoleServiceProviderMachineRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesPartialUpdate(
    id: string,
    patchedRoleServiceProviderMachineRequest?: PatchedRoleServiceProviderMachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesPartialUpdate(
        id,
        patchedRoleServiceProviderMachineRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this role service provider machine.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this role service provider machine.
   * @param {RoleServiceProviderMachineRequest} [roleServiceProviderMachineRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public roleServiceProviderMachinesUpdate(
    id: string,
    roleServiceProviderMachineRequest?: RoleServiceProviderMachineRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceProviderMachinesApiFp(this.configuration)
      .roleServiceProviderMachinesUpdate(id, roleServiceProviderMachineRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SaleItemsApi - axios parameter creator
 */
export const SaleItemsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsBulkCreateCreate: async (
      saleItemRequest: SaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleItemRequest' is not null or undefined
      assertParamExists("saleItemsBulkCreateCreate", "saleItemRequest", saleItemRequest)
      const localVarPath = `/administration/sale-items/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsBulkDeleteCreate: async (
      saleItemRequest: SaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleItemRequest' is not null or undefined
      assertParamExists("saleItemsBulkDeleteCreate", "saleItemRequest", saleItemRequest)
      const localVarPath = `/administration/sale-items/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsBulkUpdateUpdate: async (
      saleItemRequest: SaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleItemRequest' is not null or undefined
      assertParamExists("saleItemsBulkUpdateUpdate", "saleItemRequest", saleItemRequest)
      const localVarPath = `/administration/sale-items/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsCreate: async (
      saleItemRequest: SaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleItemRequest' is not null or undefined
      assertParamExists("saleItemsCreate", "saleItemRequest", saleItemRequest)
      const localVarPath = `/administration/sale-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("saleItemsDestroy", "id", id)
      const localVarPath = `/administration/sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/sale-items/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {PatchedSaleItemRequest} [patchedSaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsPartialUpdate: async (
      id: string,
      patchedSaleItemRequest?: PatchedSaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("saleItemsPartialUpdate", "id", id)
      const localVarPath = `/administration/sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedSaleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("saleItemsRetrieve", "id", id)
      const localVarPath = `/administration/sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsUpdate: async (
      id: string,
      saleItemRequest: SaleItemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("saleItemsUpdate", "id", id)
      // verify required parameter 'saleItemRequest' is not null or undefined
      assertParamExists("saleItemsUpdate", "saleItemRequest", saleItemRequest)
      const localVarPath = `/administration/sale-items/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleItemRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * SaleItemsApi - functional programming interface
 */
export const SaleItemsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SaleItemsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsBulkCreateCreate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsBulkCreateCreate(
        saleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsBulkCreateCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsBulkDeleteCreate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsBulkDeleteCreate(
        saleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsBulkDeleteCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsBulkUpdateUpdate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsBulkUpdateUpdate(
        saleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsBulkUpdateUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsCreate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsCreate(
        saleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSaleItemList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {PatchedSaleItemRequest} [patchedSaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsPartialUpdate(
      id: string,
      patchedSaleItemRequest?: PatchedSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsPartialUpdate(
        id,
        patchedSaleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsPartialUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saleItemsUpdate(
      id: string,
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaleItem>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saleItemsUpdate(
        id,
        saleItemRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SaleItemsApi.saleItemsUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * SaleItemsApi - factory interface
 */
export const SaleItemsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SaleItemsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsBulkCreateCreate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SaleItem> {
      return localVarFp
        .saleItemsBulkCreateCreate(saleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsBulkDeleteCreate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SaleItem> {
      return localVarFp
        .saleItemsBulkDeleteCreate(saleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsBulkUpdateUpdate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SaleItem> {
      return localVarFp
        .saleItemsBulkUpdateUpdate(saleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsCreate(
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SaleItem> {
      return localVarFp
        .saleItemsCreate(saleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.saleItemsDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedSaleItemList> {
      return localVarFp
        .saleItemsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {PatchedSaleItemRequest} [patchedSaleItemRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsPartialUpdate(
      id: string,
      patchedSaleItemRequest?: PatchedSaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SaleItem> {
      return localVarFp
        .saleItemsPartialUpdate(id, patchedSaleItemRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SaleItem> {
      return localVarFp.saleItemsRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this Verkoopartikel.
     * @param {SaleItemRequest} saleItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saleItemsUpdate(
      id: string,
      saleItemRequest: SaleItemRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SaleItem> {
      return localVarFp
        .saleItemsUpdate(id, saleItemRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * SaleItemsApi - object-oriented interface
 */
export class SaleItemsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {SaleItemRequest} saleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsBulkCreateCreate(
    saleItemRequest: SaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsBulkCreateCreate(saleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {SaleItemRequest} saleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsBulkDeleteCreate(
    saleItemRequest: SaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsBulkDeleteCreate(saleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {SaleItemRequest} saleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsBulkUpdateUpdate(
    saleItemRequest: SaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsBulkUpdateUpdate(saleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {SaleItemRequest} saleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsCreate(saleItemRequest: SaleItemRequest, options?: RawAxiosRequestConfig) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsCreate(saleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this Verkoopartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Verkoopartikel.
   * @param {PatchedSaleItemRequest} [patchedSaleItemRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsPartialUpdate(
    id: string,
    patchedSaleItemRequest?: PatchedSaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsPartialUpdate(id, patchedSaleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Verkoopartikel.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this Verkoopartikel.
   * @param {SaleItemRequest} saleItemRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saleItemsUpdate(
    id: string,
    saleItemRequest: SaleItemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SaleItemsApiFp(this.configuration)
      .saleItemsUpdate(id, saleItemRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SalesApi - axios parameter creator
 */
export const SalesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesApplyPricesRetroactivelyUpdate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/sales/apply-prices-retroactively/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesBulkCreateCreate: async (
      saleRequest: SaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleRequest' is not null or undefined
      assertParamExists("salesBulkCreateCreate", "saleRequest", saleRequest)
      const localVarPath = `/administration/sales/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesBulkDeleteCreate: async (
      saleRequest: SaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleRequest' is not null or undefined
      assertParamExists("salesBulkDeleteCreate", "saleRequest", saleRequest)
      const localVarPath = `/administration/sales/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesBulkUpdateUpdate: async (
      saleRequest: SaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleRequest' is not null or undefined
      assertParamExists("salesBulkUpdateUpdate", "saleRequest", saleRequest)
      const localVarPath = `/administration/sales/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesCreate: async (
      saleRequest: SaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saleRequest' is not null or undefined
      assertParamExists("salesCreate", "saleRequest", saleRequest)
      const localVarPath = `/administration/sales/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this verkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("salesDestroy", "id", id)
      const localVarPath = `/administration/sales/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/sales/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this verkoop.
     * @param {PatchedSaleRequest} [patchedSaleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPartialUpdate: async (
      id: string,
      patchedSaleRequest?: PatchedSaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("salesPartialUpdate", "id", id)
      const localVarPath = `/administration/sales/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedSaleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this verkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("salesRetrieve", "id", id)
      const localVarPath = `/administration/sales/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this verkoop.
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesUpdate: async (
      id: string,
      saleRequest: SaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("salesUpdate", "id", id)
      // verify required parameter 'saleRequest' is not null or undefined
      assertParamExists("salesUpdate", "saleRequest", saleRequest)
      const localVarPath = `/administration/sales/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * SalesApi - functional programming interface
 */
export const SalesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SalesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesApplyPricesRetroactivelyUpdate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.salesApplyPricesRetroactivelyUpdate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesApplyPricesRetroactivelyUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesBulkCreateCreate(
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesBulkCreateCreate(
        saleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesBulkCreateCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesBulkDeleteCreate(
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesBulkDeleteCreate(
        saleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesBulkDeleteCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesBulkUpdateUpdate(
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesBulkUpdateUpdate(
        saleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesBulkUpdateUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesCreate(
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesCreate(saleRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this verkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSaleList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this verkoop.
     * @param {PatchedSaleRequest} [patchedSaleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPartialUpdate(
      id: string,
      patchedSaleRequest?: PatchedSaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPartialUpdate(
        id,
        patchedSaleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesPartialUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this verkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this verkoop.
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesUpdate(
      id: string,
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesUpdate(
        id,
        saleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SalesApi.salesUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * SalesApi - factory interface
 */
export const SalesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SalesApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesApplyPricesRetroactivelyUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .salesApplyPricesRetroactivelyUpdate(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesBulkCreateCreate(
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Sale> {
      return localVarFp
        .salesBulkCreateCreate(saleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesBulkDeleteCreate(
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Sale> {
      return localVarFp
        .salesBulkDeleteCreate(saleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesBulkUpdateUpdate(
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Sale> {
      return localVarFp
        .salesBulkUpdateUpdate(saleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesCreate(saleRequest: SaleRequest, options?: RawAxiosRequestConfig): AxiosPromise<Sale> {
      return localVarFp
        .salesCreate(saleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this verkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.salesDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedSaleList> {
      return localVarFp
        .salesList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this verkoop.
     * @param {PatchedSaleRequest} [patchedSaleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPartialUpdate(
      id: string,
      patchedSaleRequest?: PatchedSaleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Sale> {
      return localVarFp
        .salesPartialUpdate(id, patchedSaleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this verkoop.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Sale> {
      return localVarFp.salesRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this verkoop.
     * @param {SaleRequest} saleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesUpdate(
      id: string,
      saleRequest: SaleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Sale> {
      return localVarFp
        .salesUpdate(id, saleRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * SalesApi - object-oriented interface
 */
export class SalesApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesApplyPricesRetroactivelyUpdate(options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesApplyPricesRetroactivelyUpdate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {SaleRequest} saleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesBulkCreateCreate(saleRequest: SaleRequest, options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesBulkCreateCreate(saleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {SaleRequest} saleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesBulkDeleteCreate(saleRequest: SaleRequest, options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesBulkDeleteCreate(saleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {SaleRequest} saleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesBulkUpdateUpdate(saleRequest: SaleRequest, options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesBulkUpdateUpdate(saleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {SaleRequest} saleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesCreate(saleRequest: SaleRequest, options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesCreate(saleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this verkoop.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return SalesApiFp(this.configuration)
      .salesList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this verkoop.
   * @param {PatchedSaleRequest} [patchedSaleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesPartialUpdate(
    id: string,
    patchedSaleRequest?: PatchedSaleRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SalesApiFp(this.configuration)
      .salesPartialUpdate(id, patchedSaleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this verkoop.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this verkoop.
   * @param {SaleRequest} saleRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public salesUpdate(id: string, saleRequest: SaleRequest, options?: RawAxiosRequestConfig) {
    return SalesApiFp(this.configuration)
      .salesUpdate(id, saleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SendOfflineBackupApi - axios parameter creator
 */
export const SendOfflineBackupApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendOfflineBackupCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/planning/send-offline-backup/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * SendOfflineBackupApi - functional programming interface
 */
export const SendOfflineBackupApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SendOfflineBackupApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendOfflineBackupCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendOfflineBackupCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SendOfflineBackupApi.sendOfflineBackupCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * SendOfflineBackupApi - factory interface
 */
export const SendOfflineBackupApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SendOfflineBackupApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendOfflineBackupCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.sendOfflineBackupCreate(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * SendOfflineBackupApi - object-oriented interface
 */
export class SendOfflineBackupApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public sendOfflineBackupCreate(options?: RawAxiosRequestConfig) {
    return SendOfflineBackupApiFp(this.configuration)
      .sendOfflineBackupCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ServiceProviderDatesApi - axios parameter creator
 */
export const ServiceProviderDatesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} serviceProviderDateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesAutoShiftInstructionsUpdate: async (
      serviceProviderDateId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceProviderDateId' is not null or undefined
      assertParamExists(
        "serviceProviderDatesAutoShiftInstructionsUpdate",
        "serviceProviderDateId",
        serviceProviderDateId
      )
      const localVarPath =
        `/administration/service-provider-dates/{serviceProviderDateId}/auto-shift-instructions/`.replace(
          `{${"serviceProviderDateId"}}`,
          encodeURIComponent(String(serviceProviderDateId))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesBulkCreateCreate: async (
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceProviderDateRequest' is not null or undefined
      assertParamExists(
        "serviceProviderDatesBulkCreateCreate",
        "serviceProviderDateRequest",
        serviceProviderDateRequest
      )
      const localVarPath = `/administration/service-provider-dates/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceProviderDateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesBulkDeleteCreate: async (
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceProviderDateRequest' is not null or undefined
      assertParamExists(
        "serviceProviderDatesBulkDeleteCreate",
        "serviceProviderDateRequest",
        serviceProviderDateRequest
      )
      const localVarPath = `/administration/service-provider-dates/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceProviderDateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesBulkUpdateUpdate: async (
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceProviderDateRequest' is not null or undefined
      assertParamExists(
        "serviceProviderDatesBulkUpdateUpdate",
        "serviceProviderDateRequest",
        serviceProviderDateRequest
      )
      const localVarPath = `/administration/service-provider-dates/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceProviderDateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Ensures that annotations are applied by re-fetching the saved objects through the custom manager which includes the annotations.
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesCreate: async (
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceProviderDateRequest' is not null or undefined
      assertParamExists(
        "serviceProviderDatesCreate",
        "serviceProviderDateRequest",
        serviceProviderDateRequest
      )
      const localVarPath = `/administration/service-provider-dates/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceProviderDateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("serviceProviderDatesDestroy", "id", id)
      const localVarPath = `/administration/service-provider-dates/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of all ServiceProviderDate instances that the current user has access to. This method filters ServiceProviderDate instances based on their association with the current user through the ServiceProviderDateUser model. It then serializes the data and returns it in the response.  The context for serialization includes a dictionary mapping of \'service_provider_date_users\' which is used in the serializer to dynamically add \'is_expanded\' state to each serialized object based on the user-specific data.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesList: async (
      $skip?: number,
      $top?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/service-provider-dates/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {PatchedServiceProviderDateRequest} [patchedServiceProviderDateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesPartialUpdate: async (
      id: string,
      patchedServiceProviderDateRequest?: PatchedServiceProviderDateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("serviceProviderDatesPartialUpdate", "id", id)
      const localVarPath = `/administration/service-provider-dates/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedServiceProviderDateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("serviceProviderDatesRetrieve", "id", id)
      const localVarPath = `/administration/service-provider-dates/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Similar to list(), but to update an object and performs an update for the ServiceProviderDateUser as well.
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesUpdate: async (
      id: string,
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("serviceProviderDatesUpdate", "id", id)
      // verify required parameter 'serviceProviderDateRequest' is not null or undefined
      assertParamExists(
        "serviceProviderDatesUpdate",
        "serviceProviderDateRequest",
        serviceProviderDateRequest
      )
      const localVarPath = `/administration/service-provider-dates/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceProviderDateRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ServiceProviderDatesApi - functional programming interface
 */
export const ServiceProviderDatesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ServiceProviderDatesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} serviceProviderDateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesAutoShiftInstructionsUpdate(
      serviceProviderDateId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.serviceProviderDatesAutoShiftInstructionsUpdate(
          serviceProviderDateId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "ServiceProviderDatesApi.serviceProviderDatesAutoShiftInstructionsUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesBulkCreateCreate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderDate>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.serviceProviderDatesBulkCreateCreate(
          serviceProviderDateRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesBulkDeleteCreate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderDate>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.serviceProviderDatesBulkDeleteCreate(
          serviceProviderDateRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesBulkUpdateUpdate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderDate>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.serviceProviderDatesBulkUpdateUpdate(
          serviceProviderDateRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Ensures that annotations are applied by re-fetching the saved objects through the custom manager which includes the annotations.
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesCreate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderDate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProviderDatesCreate(
        serviceProviderDateRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProviderDatesDestroy(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of all ServiceProviderDate instances that the current user has access to. This method filters ServiceProviderDate instances based on their association with the current user through the ServiceProviderDateUser model. It then serializes the data and returns it in the response.  The context for serialization includes a dictionary mapping of \'service_provider_date_users\' which is used in the serializer to dynamically add \'is_expanded\' state to each serialized object based on the user-specific data.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedServiceProviderDateList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProviderDatesList(
        $skip,
        $top,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {PatchedServiceProviderDateRequest} [patchedServiceProviderDateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesPartialUpdate(
      id: string,
      patchedServiceProviderDateRequest?: PatchedServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderDate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProviderDatesPartialUpdate(
        id,
        patchedServiceProviderDateRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderDate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProviderDatesRetrieve(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Similar to list(), but to update an object and performs an update for the ServiceProviderDateUser as well.
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProviderDatesUpdate(
      id: string,
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProviderDate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProviderDatesUpdate(
        id,
        serviceProviderDateRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProviderDatesApi.serviceProviderDatesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ServiceProviderDatesApi - factory interface
 */
export const ServiceProviderDatesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ServiceProviderDatesApiFp(configuration)
  return {
    /**
     *
     * @param {string} serviceProviderDateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesAutoShiftInstructionsUpdate(
      serviceProviderDateId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .serviceProviderDatesAutoShiftInstructionsUpdate(serviceProviderDateId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesBulkCreateCreate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ServiceProviderDate> {
      return localVarFp
        .serviceProviderDatesBulkCreateCreate(serviceProviderDateRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesBulkDeleteCreate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ServiceProviderDate> {
      return localVarFp
        .serviceProviderDatesBulkDeleteCreate(serviceProviderDateRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesBulkUpdateUpdate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ServiceProviderDate> {
      return localVarFp
        .serviceProviderDatesBulkUpdateUpdate(serviceProviderDateRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Ensures that annotations are applied by re-fetching the saved objects through the custom manager which includes the annotations.
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesCreate(
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ServiceProviderDate> {
      return localVarFp
        .serviceProviderDatesCreate(serviceProviderDateRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .serviceProviderDatesDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of all ServiceProviderDate instances that the current user has access to. This method filters ServiceProviderDate instances based on their association with the current user through the ServiceProviderDateUser model. It then serializes the data and returns it in the response.  The context for serialization includes a dictionary mapping of \'service_provider_date_users\' which is used in the serializer to dynamically add \'is_expanded\' state to each serialized object based on the user-specific data.
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesList(
      $skip?: number,
      $top?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedServiceProviderDateList> {
      return localVarFp
        .serviceProviderDatesList($skip, $top, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {PatchedServiceProviderDateRequest} [patchedServiceProviderDateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesPartialUpdate(
      id: string,
      patchedServiceProviderDateRequest?: PatchedServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ServiceProviderDate> {
      return localVarFp
        .serviceProviderDatesPartialUpdate(id, patchedServiceProviderDateRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ServiceProviderDate> {
      return localVarFp
        .serviceProviderDatesRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Similar to list(), but to update an object and performs an update for the ServiceProviderDateUser as well.
     * @param {string} id A UUID string identifying this dienstverlenerdatum.
     * @param {ServiceProviderDateRequest} serviceProviderDateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProviderDatesUpdate(
      id: string,
      serviceProviderDateRequest: ServiceProviderDateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ServiceProviderDate> {
      return localVarFp
        .serviceProviderDatesUpdate(id, serviceProviderDateRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ServiceProviderDatesApi - object-oriented interface
 */
export class ServiceProviderDatesApi extends BaseAPI {
  /**
   *
   * @param {string} serviceProviderDateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesAutoShiftInstructionsUpdate(
    serviceProviderDateId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesAutoShiftInstructionsUpdate(serviceProviderDateId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ServiceProviderDateRequest} serviceProviderDateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesBulkCreateCreate(
    serviceProviderDateRequest: ServiceProviderDateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesBulkCreateCreate(serviceProviderDateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ServiceProviderDateRequest} serviceProviderDateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesBulkDeleteCreate(
    serviceProviderDateRequest: ServiceProviderDateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesBulkDeleteCreate(serviceProviderDateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {ServiceProviderDateRequest} serviceProviderDateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesBulkUpdateUpdate(
    serviceProviderDateRequest: ServiceProviderDateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesBulkUpdateUpdate(serviceProviderDateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Ensures that annotations are applied by re-fetching the saved objects through the custom manager which includes the annotations.
   * @param {ServiceProviderDateRequest} serviceProviderDateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesCreate(
    serviceProviderDateRequest: ServiceProviderDateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesCreate(serviceProviderDateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this dienstverlenerdatum.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of all ServiceProviderDate instances that the current user has access to. This method filters ServiceProviderDate instances based on their association with the current user through the ServiceProviderDateUser model. It then serializes the data and returns it in the response.  The context for serialization includes a dictionary mapping of \'service_provider_date_users\' which is used in the serializer to dynamically add \'is_expanded\' state to each serialized object based on the user-specific data.
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesList($skip?: number, $top?: number, options?: RawAxiosRequestConfig) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesList($skip, $top, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this dienstverlenerdatum.
   * @param {PatchedServiceProviderDateRequest} [patchedServiceProviderDateRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesPartialUpdate(
    id: string,
    patchedServiceProviderDateRequest?: PatchedServiceProviderDateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesPartialUpdate(id, patchedServiceProviderDateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this dienstverlenerdatum.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Similar to list(), but to update an object and performs an update for the ServiceProviderDateUser as well.
   * @param {string} id A UUID string identifying this dienstverlenerdatum.
   * @param {ServiceProviderDateRequest} serviceProviderDateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProviderDatesUpdate(
    id: string,
    serviceProviderDateRequest: ServiceProviderDateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProviderDatesApiFp(this.configuration)
      .serviceProviderDatesUpdate(id, serviceProviderDateRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ServiceProvidersApi - axios parameter creator
 */
export const ServiceProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} serviceProviderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProvidersInstructionsRetrieve: async (
      serviceProviderId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceProviderId' is not null or undefined
      assertParamExists(
        "serviceProvidersInstructionsRetrieve",
        "serviceProviderId",
        serviceProviderId
      )
      const localVarPath = `/planning/service-providers/{serviceProviderId}/instructions/`.replace(
        `{${"serviceProviderId"}}`,
        encodeURIComponent(String(serviceProviderId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ServiceProvidersApi - functional programming interface
 */
export const ServiceProvidersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ServiceProvidersApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} serviceProviderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceProvidersInstructionsRetrieve(
      serviceProviderId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.serviceProvidersInstructionsRetrieve(
          serviceProviderId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ServiceProvidersApi.serviceProvidersInstructionsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ServiceProvidersApi - factory interface
 */
export const ServiceProvidersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ServiceProvidersApiFp(configuration)
  return {
    /**
     *
     * @param {string} serviceProviderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceProvidersInstructionsRetrieve(
      serviceProviderId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .serviceProvidersInstructionsRetrieve(serviceProviderId, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ServiceProvidersApi - object-oriented interface
 */
export class ServiceProvidersApi extends BaseAPI {
  /**
   *
   * @param {string} serviceProviderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public serviceProvidersInstructionsRetrieve(
    serviceProviderId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ServiceProvidersApiFp(this.configuration)
      .serviceProvidersInstructionsRetrieve(serviceProviderId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SocketBufferApi - axios parameter creator
 */
export const SocketBufferApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns the socket buffer view.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    socketBufferRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/core/socket-buffer/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * SocketBufferApi - functional programming interface
 */
export const SocketBufferApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SocketBufferApiAxiosParamCreator(configuration)
  return {
    /**
     * Returns the socket buffer view.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async socketBufferRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.socketBufferRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SocketBufferApi.socketBufferRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * SocketBufferApi - factory interface
 */
export const SocketBufferApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SocketBufferApiFp(configuration)
  return {
    /**
     * Returns the socket buffer view.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    socketBufferRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.socketBufferRetrieve(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * SocketBufferApi - object-oriented interface
 */
export class SocketBufferApi extends BaseAPI {
  /**
   * Returns the socket buffer view.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public socketBufferRetrieve(options?: RawAxiosRequestConfig) {
    return SocketBufferApiFp(this.configuration)
      .socketBufferRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TrackingApi - axios parameter creator
 */
export const TrackingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Generates a signed tracking token that allows customers to view service provider location.
     * @summary Generate tracking token for instruction
     * @param {string} instructionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingInstructionsRetrieve: async (
      instructionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'instructionId' is not null or undefined
      assertParamExists("trackingInstructionsRetrieve", "instructionId", instructionId)
      const localVarPath = `/planning/tracking/instructions/{instructionId}/`.replace(
        `{${"instructionId"}}`,
        encodeURIComponent(String(instructionId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns only the service provider current location. Lightweight endpoint for frequent polling. Token must be valid and not expired (2 hour validity).
     * @summary Get location only for instruction
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingLocationRetrieve: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists("trackingLocationRetrieve", "token", token)
      const localVarPath = `/planning/tracking/{token}/location/`.replace(
        `{${"token"}}`,
        encodeURIComponent(String(token))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns full tracking information including service provider location, destination, schedule, order info, and more. Token must be valid and not expired (2 hour validity).
     * @summary Get tracking info for instruction
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingRetrieve: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists("trackingRetrieve", "token", token)
      const localVarPath = `/planning/tracking/{token}/`.replace(
        `{${"token"}}`,
        encodeURIComponent(String(token))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns all users with their last known locations
     * @summary List all user locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingUsersList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/planning/tracking/users/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * TrackingApi - functional programming interface
 */
export const TrackingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TrackingApiAxiosParamCreator(configuration)
  return {
    /**
     * Generates a signed tracking token that allows customers to view service provider location.
     * @summary Generate tracking token for instruction
     * @param {string} instructionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trackingInstructionsRetrieve(
      instructionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingUrl>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.trackingInstructionsRetrieve(
        instructionId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TrackingApi.trackingInstructionsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Returns only the service provider current location. Lightweight endpoint for frequent polling. Token must be valid and not expired (2 hour validity).
     * @summary Get location only for instruction
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trackingLocationRetrieve(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionLocationOnly>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.trackingLocationRetrieve(
        token,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TrackingApi.trackingLocationRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Returns full tracking information including service provider location, destination, schedule, order info, and more. Token must be valid and not expired (2 hour validity).
     * @summary Get tracking info for instruction
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trackingRetrieve(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionTracking>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.trackingRetrieve(token, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TrackingApi.trackingRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Returns all users with their last known locations
     * @summary List all user locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trackingUsersList(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserLocation>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.trackingUsersList(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TrackingApi.trackingUsersList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * TrackingApi - factory interface
 */
export const TrackingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TrackingApiFp(configuration)
  return {
    /**
     * Generates a signed tracking token that allows customers to view service provider location.
     * @summary Generate tracking token for instruction
     * @param {string} instructionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingInstructionsRetrieve(
      instructionId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TrackingUrl> {
      return localVarFp
        .trackingInstructionsRetrieve(instructionId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns only the service provider current location. Lightweight endpoint for frequent polling. Token must be valid and not expired (2 hour validity).
     * @summary Get location only for instruction
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingLocationRetrieve(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionLocationOnly> {
      return localVarFp
        .trackingLocationRetrieve(token, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Returns full tracking information including service provider location, destination, schedule, order info, and more. Token must be valid and not expired (2 hour validity).
     * @summary Get tracking info for instruction
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingRetrieve(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionTracking> {
      return localVarFp.trackingRetrieve(token, options).then((request) => request(axios, basePath))
    },
    /**
     * Returns all users with their last known locations
     * @summary List all user locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackingUsersList(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserLocation>> {
      return localVarFp.trackingUsersList(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * TrackingApi - object-oriented interface
 */
export class TrackingApi extends BaseAPI {
  /**
   * Generates a signed tracking token that allows customers to view service provider location.
   * @summary Generate tracking token for instruction
   * @param {string} instructionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public trackingInstructionsRetrieve(instructionId: string, options?: RawAxiosRequestConfig) {
    return TrackingApiFp(this.configuration)
      .trackingInstructionsRetrieve(instructionId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns only the service provider current location. Lightweight endpoint for frequent polling. Token must be valid and not expired (2 hour validity).
   * @summary Get location only for instruction
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public trackingLocationRetrieve(token: string, options?: RawAxiosRequestConfig) {
    return TrackingApiFp(this.configuration)
      .trackingLocationRetrieve(token, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns full tracking information including service provider location, destination, schedule, order info, and more. Token must be valid and not expired (2 hour validity).
   * @summary Get tracking info for instruction
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public trackingRetrieve(token: string, options?: RawAxiosRequestConfig) {
    return TrackingApiFp(this.configuration)
      .trackingRetrieve(token, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns all users with their last known locations
   * @summary List all user locations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public trackingUsersList(options?: RawAxiosRequestConfig) {
    return TrackingApiFp(this.configuration)
      .trackingUsersList(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TransactionsApi - axios parameter creator
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionsInsertFromServiceProviderMachineCreate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/transactions/insert-from-service-provider-machine/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * TransactionsApi - functional programming interface
 */
export const TransactionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionsInsertFromServiceProviderMachineCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transactionsInsertFromServiceProviderMachineCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TransactionsApi.transactionsInsertFromServiceProviderMachineCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * TransactionsApi - factory interface
 */
export const TransactionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionsApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionsInsertFromServiceProviderMachineCreate(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .transactionsInsertFromServiceProviderMachineCreate(options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * TransactionsApi - object-oriented interface
 */
export class TransactionsApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public transactionsInsertFromServiceProviderMachineCreate(options?: RawAxiosRequestConfig) {
    return TransactionsApiFp(this.configuration)
      .transactionsInsertFromServiceProviderMachineCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserLocationsApi - axios parameter creator
 */
export const UserLocationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsBulkCreateCreate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists("userLocationsBulkCreateCreate", "userLocationRequest", userLocationRequest)
      const localVarPath = `/auth/user-locations/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsBulkDeleteCreate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists("userLocationsBulkDeleteCreate", "userLocationRequest", userLocationRequest)
      const localVarPath = `/auth/user-locations/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsBulkUpdateUpdate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists("userLocationsBulkUpdateUpdate", "userLocationRequest", userLocationRequest)
      const localVarPath = `/auth/user-locations/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsCreate: async (
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists("userLocationsCreate", "userLocationRequest", userLocationRequest)
      const localVarPath = `/auth/user-locations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userLocationsDestroy", "id", id)
      const localVarPath = `/auth/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/user-locations/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsPartialUpdate: async (
      id: string,
      patchedUserLocationRequest?: PatchedUserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userLocationsPartialUpdate", "id", id)
      const localVarPath = `/auth/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedUserLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userLocationsRetrieve", "id", id)
      const localVarPath = `/auth/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsUpdate: async (
      id: string,
      userLocationRequest: UserLocationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userLocationsUpdate", "id", id)
      // verify required parameter 'userLocationRequest' is not null or undefined
      assertParamExists("userLocationsUpdate", "userLocationRequest", userLocationRequest)
      const localVarPath = `/auth/user-locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userLocationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserLocationsApi - functional programming interface
 */
export const UserLocationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserLocationsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsBulkCreateCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsBulkCreateCreate(
        userLocationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsBulkDeleteCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsBulkDeleteCreate(
        userLocationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsBulkUpdateUpdate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsBulkUpdateUpdate(
        userLocationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsCreate(
        userLocationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsCreate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsDestroy"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUserLocationList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsList"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsPartialUpdate(
      id: string,
      patchedUserLocationRequest?: PatchedUserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsPartialUpdate(
        id,
        patchedUserLocationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLocationsUpdate(
      id: string,
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLocation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userLocationsUpdate(
        id,
        userLocationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserLocationsApi.userLocationsUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UserLocationsApi - factory interface
 */
export const UserLocationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserLocationsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsBulkCreateCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .userLocationsBulkCreateCreate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsBulkDeleteCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .userLocationsBulkDeleteCreate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsBulkUpdateUpdate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .userLocationsBulkUpdateUpdate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create a new {model_name}
     * @summary Create {model_name}
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsCreate(
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .userLocationsCreate(userLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete an existing {model_name}
     * @summary Delete {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .userLocationsDestroy(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedUserLocationList> {
      return localVarFp
        .userLocationsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsPartialUpdate(
      id: string,
      patchedUserLocationRequest?: PatchedUserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .userLocationsPartialUpdate(id, patchedUserLocationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserLocation> {
      return localVarFp
        .userLocationsRetrieve(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an existing {model_name}
     * @summary Update {model_name}
     * @param {string} id A UUID string identifying this gebruikerslocatie.
     * @param {UserLocationRequest} userLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLocationsUpdate(
      id: string,
      userLocationRequest: UserLocationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserLocation> {
      return localVarFp
        .userLocationsUpdate(id, userLocationRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserLocationsApi - object-oriented interface
 */
export class UserLocationsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsBulkCreateCreate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsBulkCreateCreate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsBulkDeleteCreate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsBulkDeleteCreate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsBulkUpdateUpdate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsBulkUpdateUpdate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create a new {model_name}
   * @summary Create {model_name}
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsCreate(
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsCreate(userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete an existing {model_name}
   * @summary Delete {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {PatchedUserLocationRequest} [patchedUserLocationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsPartialUpdate(
    id: string,
    patchedUserLocationRequest?: PatchedUserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsPartialUpdate(id, patchedUserLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an existing {model_name}
   * @summary Update {model_name}
   * @param {string} id A UUID string identifying this gebruikerslocatie.
   * @param {UserLocationRequest} userLocationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userLocationsUpdate(
    id: string,
    userLocationRequest: UserLocationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserLocationsApiFp(this.configuration)
      .userLocationsUpdate(id, userLocationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserSettingsApi - axios parameter creator
 */
export const UserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSettingsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/user-settings/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSettingsUpdate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/user-settings/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserSettingsApi - functional programming interface
 */
export const UserSettingsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSettingsRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSettingsRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserSettingsApi.userSettingsRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSettingsUpdate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSettingsUpdate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserSettingsApi.userSettingsUpdate"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UserSettingsApi - factory interface
 */
export const UserSettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserSettingsApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSettingsRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.userSettingsRetrieve(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSettingsUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.userSettingsUpdate(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserSettingsApi - object-oriented interface
 */
export class UserSettingsApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userSettingsRetrieve(options?: RawAxiosRequestConfig) {
    return UserSettingsApiFp(this.configuration)
      .userSettingsRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userSettingsUpdate(options?: RawAxiosRequestConfig) {
    return UserSettingsApiFp(this.configuration)
      .userSettingsUpdate(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserTenantsApi - axios parameter creator
 */
export const UserTenantsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsCreate: async (
      userTenantRequest: UserTenantRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userTenantRequest' is not null or undefined
      assertParamExists("userTenantsCreate", "userTenantRequest", userTenantRequest)
      const localVarPath = `/auth/user-tenants/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userTenantRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userTenantsDestroy", "id", id)
      const localVarPath = `/auth/user-tenants/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/user-tenants/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {PatchedUserTenantRequest} [patchedUserTenantRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsPartialUpdate: async (
      id: string,
      patchedUserTenantRequest?: PatchedUserTenantRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userTenantsPartialUpdate", "id", id)
      const localVarPath = `/auth/user-tenants/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedUserTenantRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userTenantsRetrieve", "id", id)
      const localVarPath = `/auth/user-tenants/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} id
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsUpdate: async (
      id: string,
      userTenantRequest: UserTenantRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userTenantsUpdate", "id", id)
      // verify required parameter 'userTenantRequest' is not null or undefined
      assertParamExists("userTenantsUpdate", "userTenantRequest", userTenantRequest)
      const localVarPath = `/auth/user-tenants/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userTenantRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsUpdateActiveTenantCreate: async (
      userTenantRequest: UserTenantRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userTenantRequest' is not null or undefined
      assertParamExists(
        "userTenantsUpdateActiveTenantCreate",
        "userTenantRequest",
        userTenantRequest
      )
      const localVarPath = `/auth/user-tenants/update-active-tenant/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userTenantRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserTenantsApi - functional programming interface
 */
export const UserTenantsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserTenantsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userTenantsCreate(
      userTenantRequest: UserTenantRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userTenantsCreate(
        userTenantRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserTenantsApi.userTenantsCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userTenantsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userTenantsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserTenantsApi.userTenantsDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userTenantsList(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserTenant>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userTenantsList(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserTenantsApi.userTenantsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {PatchedUserTenantRequest} [patchedUserTenantRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userTenantsPartialUpdate(
      id: string,
      patchedUserTenantRequest?: PatchedUserTenantRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userTenantsPartialUpdate(
        id,
        patchedUserTenantRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserTenantsApi.userTenantsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userTenantsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userTenantsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserTenantsApi.userTenantsRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userTenantsUpdate(
      id: string,
      userTenantRequest: UserTenantRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userTenantsUpdate(
        id,
        userTenantRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserTenantsApi.userTenantsUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userTenantsUpdateActiveTenantCreate(
      userTenantRequest: UserTenantRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userTenantsUpdateActiveTenantCreate(
        userTenantRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserTenantsApi.userTenantsUpdateActiveTenantCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UserTenantsApi - factory interface
 */
export const UserTenantsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserTenantsApiFp(configuration)
  return {
    /**
     *
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsCreate(
      userTenantRequest: UserTenantRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserTenant> {
      return localVarFp
        .userTenantsCreate(userTenantRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.userTenantsDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserTenant>> {
      return localVarFp.userTenantsList(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {PatchedUserTenantRequest} [patchedUserTenantRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsPartialUpdate(
      id: string,
      patchedUserTenantRequest?: PatchedUserTenantRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserTenant> {
      return localVarFp
        .userTenantsPartialUpdate(id, patchedUserTenantRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserTenant> {
      return localVarFp.userTenantsRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsUpdate(
      id: string,
      userTenantRequest: UserTenantRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserTenant> {
      return localVarFp
        .userTenantsUpdate(id, userTenantRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {UserTenantRequest} userTenantRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userTenantsUpdateActiveTenantCreate(
      userTenantRequest: UserTenantRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserTenant> {
      return localVarFp
        .userTenantsUpdateActiveTenantCreate(userTenantRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserTenantsApi - object-oriented interface
 */
export class UserTenantsApi extends BaseAPI {
  /**
   *
   * @param {UserTenantRequest} userTenantRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userTenantsCreate(userTenantRequest: UserTenantRequest, options?: RawAxiosRequestConfig) {
    return UserTenantsApiFp(this.configuration)
      .userTenantsCreate(userTenantRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userTenantsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return UserTenantsApiFp(this.configuration)
      .userTenantsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userTenantsList(options?: RawAxiosRequestConfig) {
    return UserTenantsApiFp(this.configuration)
      .userTenantsList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {PatchedUserTenantRequest} [patchedUserTenantRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userTenantsPartialUpdate(
    id: string,
    patchedUserTenantRequest?: PatchedUserTenantRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserTenantsApiFp(this.configuration)
      .userTenantsPartialUpdate(id, patchedUserTenantRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userTenantsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return UserTenantsApiFp(this.configuration)
      .userTenantsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {UserTenantRequest} userTenantRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userTenantsUpdate(
    id: string,
    userTenantRequest: UserTenantRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserTenantsApiFp(this.configuration)
      .userTenantsUpdate(id, userTenantRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UserTenantRequest} userTenantRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userTenantsUpdateActiveTenantCreate(
    userTenantRequest: UserTenantRequest,
    options?: RawAxiosRequestConfig
  ) {
    return UserTenantsApiFp(this.configuration)
      .userTenantsUpdateActiveTenantCreate(userTenantRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/users/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/users/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersCreate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersCreate(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersRetrieve"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UsersApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.usersCreate(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.usersRetrieve(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersCreate(options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersCreate(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersRetrieve(options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ValidateInviteCodeApi - axios parameter creator
 */
export const ValidateInviteCodeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} inviteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateInviteCodeRetrieve: async (
      inviteCode: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'inviteCode' is not null or undefined
      assertParamExists("validateInviteCodeRetrieve", "inviteCode", inviteCode)
      const localVarPath = `/auth/validate-invite-code/{inviteCode}/`.replace(
        `{${"inviteCode"}}`,
        encodeURIComponent(String(inviteCode))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ValidateInviteCodeApi - functional programming interface
 */
export const ValidateInviteCodeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ValidateInviteCodeApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} inviteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validateInviteCodeRetrieve(
      inviteCode: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.validateInviteCodeRetrieve(
        inviteCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ValidateInviteCodeApi.validateInviteCodeRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ValidateInviteCodeApi - factory interface
 */
export const ValidateInviteCodeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ValidateInviteCodeApiFp(configuration)
  return {
    /**
     *
     * @param {string} inviteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateInviteCodeRetrieve(
      inviteCode: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .validateInviteCodeRetrieve(inviteCode, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ValidateInviteCodeApi - object-oriented interface
 */
export class ValidateInviteCodeApi extends BaseAPI {
  /**
   *
   * @param {string} inviteCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public validateInviteCodeRetrieve(inviteCode: string, options?: RawAxiosRequestConfig) {
    return ValidateInviteCodeApiFp(this.configuration)
      .validateInviteCodeRetrieve(inviteCode, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * WorkPeriodsApi - axios parameter creator
 */
export const WorkPeriodsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsBulkCreateCreate: async (
      workPeriodRequest: WorkPeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'workPeriodRequest' is not null or undefined
      assertParamExists("workPeriodsBulkCreateCreate", "workPeriodRequest", workPeriodRequest)
      const localVarPath = `/administration/work-periods/bulk-create/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        workPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsBulkDeleteCreate: async (
      workPeriodRequest: WorkPeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'workPeriodRequest' is not null or undefined
      assertParamExists("workPeriodsBulkDeleteCreate", "workPeriodRequest", workPeriodRequest)
      const localVarPath = `/administration/work-periods/bulk-delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        workPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsBulkUpdateUpdate: async (
      workPeriodRequest: WorkPeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'workPeriodRequest' is not null or undefined
      assertParamExists("workPeriodsBulkUpdateUpdate", "workPeriodRequest", workPeriodRequest)
      const localVarPath = `/administration/work-periods/bulk-update/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        workPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsCreate: async (
      workPeriodRequest: WorkPeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'workPeriodRequest' is not null or undefined
      assertParamExists("workPeriodsCreate", "workPeriodRequest", workPeriodRequest)
      const localVarPath = `/administration/work-periods/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        workPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("workPeriodsDestroy", "id", id)
      const localVarPath = `/administration/work-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsList: async (
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/administration/work-periods/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby
      }

      if ($search !== undefined) {
        localVarQueryParameter["$search"] = $search
      }

      if ($select !== undefined) {
        localVarQueryParameter["$select"] = $select
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top
      }

      if (getNested !== undefined) {
        localVarQueryParameter["get_nested"] = getNested
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (normalize !== undefined) {
        localVarQueryParameter["normalize"] = normalize
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {PatchedWorkPeriodRequest} [patchedWorkPeriodRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsPartialUpdate: async (
      id: string,
      patchedWorkPeriodRequest?: PatchedWorkPeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("workPeriodsPartialUpdate", "id", id)
      const localVarPath = `/administration/work-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedWorkPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("workPeriodsRetrieve", "id", id)
      const localVarPath = `/administration/work-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsUpdate: async (
      id: string,
      workPeriodRequest: WorkPeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("workPeriodsUpdate", "id", id)
      // verify required parameter 'workPeriodRequest' is not null or undefined
      assertParamExists("workPeriodsUpdate", "workPeriodRequest", workPeriodRequest)
      const localVarPath = `/administration/work-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        workPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * WorkPeriodsApi - functional programming interface
 */
export const WorkPeriodsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WorkPeriodsApiAxiosParamCreator(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsBulkCreateCreate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPeriod>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsBulkCreateCreate(
        workPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsBulkCreateCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsBulkDeleteCreate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPeriod>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsBulkDeleteCreate(
        workPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsBulkDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsBulkUpdateUpdate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPeriod>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsBulkUpdateUpdate(
        workPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsBulkUpdateUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsCreate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPeriod>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsCreate(
        workPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsCreate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsDestroy"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWorkPeriodList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsList"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {PatchedWorkPeriodRequest} [patchedWorkPeriodRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsPartialUpdate(
      id: string,
      patchedWorkPeriodRequest?: PatchedWorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPeriod>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsPartialUpdate(
        id,
        patchedWorkPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPeriod>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsRetrieve"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async workPeriodsUpdate(
      id: string,
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPeriod>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.workPeriodsUpdate(
        id,
        workPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WorkPeriodsApi.workPeriodsUpdate"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * WorkPeriodsApi - factory interface
 */
export const WorkPeriodsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = WorkPeriodsApiFp(configuration)
  return {
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsBulkCreateCreate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkPeriod> {
      return localVarFp
        .workPeriodsBulkCreateCreate(workPeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsBulkDeleteCreate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkPeriod> {
      return localVarFp
        .workPeriodsBulkDeleteCreate(workPeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsBulkUpdateUpdate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkPeriod> {
      return localVarFp
        .workPeriodsBulkUpdateUpdate(workPeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsCreate(
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkPeriod> {
      return localVarFp
        .workPeriodsCreate(workPeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.workPeriodsDestroy(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a paginated list of {model_name} with OData query support
     * @summary List {model_name}
     * @param {string} [$expand] Expand related entities (comma-separated)
     * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
     * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
     * @param {string} [$search] Full-text search across searchable fields
     * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
     * @param {number} [$skip] The initial index from which to return the results.
     * @param {number} [$top] Number of results to return per page.
     * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
     * @param {number} [limit] Number of results to return per page
     * @param {string} [normalize] Apply data normalization (true/false)
     * @param {number} [offset] The initial index from which to return the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsList(
      $expand?: string,
      $filter?: string,
      $orderby?: string,
      $search?: string,
      $select?: string,
      $skip?: number,
      $top?: number,
      getNested?: string,
      limit?: number,
      normalize?: string,
      offset?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedWorkPeriodList> {
      return localVarFp
        .workPeriodsList(
          $expand,
          $filter,
          $orderby,
          $search,
          $select,
          $skip,
          $top,
          getNested,
          limit,
          normalize,
          offset,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Partially update an existing {model_name}
     * @summary Partial update {model_name}
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {PatchedWorkPeriodRequest} [patchedWorkPeriodRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsPartialUpdate(
      id: string,
      patchedWorkPeriodRequest?: PatchedWorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkPeriod> {
      return localVarFp
        .workPeriodsPartialUpdate(id, patchedWorkPeriodRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single {model_name} by ID
     * @summary Retrieve {model_name}
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkPeriod> {
      return localVarFp.workPeriodsRetrieve(id, options).then((request) => request(axios, basePath))
    },
    /**
     * Override update() to prevent serializer caching at the request level
     * @param {string} id A UUID string identifying this Werkperiode.
     * @param {WorkPeriodRequest} workPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    workPeriodsUpdate(
      id: string,
      workPeriodRequest: WorkPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkPeriod> {
      return localVarFp
        .workPeriodsUpdate(id, workPeriodRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * WorkPeriodsApi - object-oriented interface
 */
export class WorkPeriodsApi extends BaseAPI {
  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {WorkPeriodRequest} workPeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsBulkCreateCreate(
    workPeriodRequest: WorkPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsBulkCreateCreate(workPeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {WorkPeriodRequest} workPeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsBulkDeleteCreate(
    workPeriodRequest: WorkPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsBulkDeleteCreate(workPeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {WorkPeriodRequest} workPeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsBulkUpdateUpdate(
    workPeriodRequest: WorkPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsBulkUpdateUpdate(workPeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {WorkPeriodRequest} workPeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsCreate(workPeriodRequest: WorkPeriodRequest, options?: RawAxiosRequestConfig) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsCreate(workPeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Abstract base class for generic types.  On Python 3.12 and newer, generic classes implicitly inherit from Generic when they declare a parameter list after the class\'s name::      class Mapping[KT, VT]:         def __getitem__(self, key: KT) -> VT:             ...         # Etc.  On older versions of Python, however, generic classes have to explicitly inherit from Generic.  After a class has been declared to be generic, it can then be used as follows::      def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:         try:             return mapping[key]         except KeyError:             return default
   * @param {string} id A UUID string identifying this Werkperiode.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a paginated list of {model_name} with OData query support
   * @summary List {model_name}
   * @param {string} [$expand] Expand related entities (comma-separated)
   * @param {string} [$filter] OData filter expression (e.g., \&quot;name eq \&#39;John\&#39;\&quot; or \&quot;age gt 18\&quot;)
   * @param {string} [$orderby] OData ordering (e.g., \&quot;created_at desc\&quot; or \&quot;name asc,age desc\&quot;)
   * @param {string} [$search] Full-text search across searchable fields
   * @param {string} [$select] Select specific fields to return (comma-separated). Supports nested paths using dot notation (e.g., \&quot;id,created_at,messages.messenger.id\&quot;)
   * @param {number} [$skip] The initial index from which to return the results.
   * @param {number} [$top] Number of results to return per page.
   * @param {string} [getNested] Include full nested objects (true/false). Default is false (uses ReadSerializer with foreign key IDs). Set to true to include nested objects.
   * @param {number} [limit] Number of results to return per page
   * @param {string} [normalize] Apply data normalization (true/false)
   * @param {number} [offset] The initial index from which to return the results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsList(
    $expand?: string,
    $filter?: string,
    $orderby?: string,
    $search?: string,
    $select?: string,
    $skip?: number,
    $top?: number,
    getNested?: string,
    limit?: number,
    normalize?: string,
    offset?: number,
    options?: RawAxiosRequestConfig
  ) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsList(
        $expand,
        $filter,
        $orderby,
        $search,
        $select,
        $skip,
        $top,
        getNested,
        limit,
        normalize,
        offset,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Partially update an existing {model_name}
   * @summary Partial update {model_name}
   * @param {string} id A UUID string identifying this Werkperiode.
   * @param {PatchedWorkPeriodRequest} [patchedWorkPeriodRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsPartialUpdate(
    id: string,
    patchedWorkPeriodRequest?: PatchedWorkPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsPartialUpdate(id, patchedWorkPeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single {model_name} by ID
   * @summary Retrieve {model_name}
   * @param {string} id A UUID string identifying this Werkperiode.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Override update() to prevent serializer caching at the request level
   * @param {string} id A UUID string identifying this Werkperiode.
   * @param {WorkPeriodRequest} workPeriodRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public workPeriodsUpdate(
    id: string,
    workPeriodRequest: WorkPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return WorkPeriodsApiFp(this.configuration)
      .workPeriodsUpdate(id, workPeriodRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
